/**
 * OneAmerica AssetCare Category 3 (CA) Demographic-Aware Multiplier Bands
 * Generated: 2026-02-24
 * Demographics: 6 ages (45-70) x 2 genders x 3 legacy products x 20 configs
 * Flat key: "productKey|gender|age|aobInf|cobInf|cobDur"
 * Single Pay / Single Life uses the packed Category 1 demographic subset.
 * Base premium: $100k (Single Pay), $10k (10-Pay)
 */

import type { BandEntry } from "./oneAmericaPricingUtils";

export const OA_CAT3_DEMO_BANDS: Record<string, BandEntry[]> = {
  "sp_joint|Female|45|None|None|2 Years": [
    { premium: 50000, db: 0.999997, ltc: 0.999997 },
    { premium: 75000, db: 0.999999, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.086787, ltc: 0.877124 },
  ],
  "sp_joint|Female|45|None|None|4 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 0.999999, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.102926, ltc: 0.857375 },
  ],
  "sp_joint|Female|45|None|None|6 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 1.000001, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.076175, ltc: 0.934595 },
  ],
  "sp_joint|Female|45|None|None|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000002, ltc: 1 },
    { premium: 300000, db: 1.031647, ltc: 1 },
  ],
  "sp_joint|Female|45|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.062296, ltc: 0.959279 },
    { premium: 200000, db: 1.160905, ltc: 0.894816 },
    { premium: 300000, db: 1.259518, ltc: 0.830354 },
  ],
  "sp_joint|Female|45|None|3%|4 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999995 },
    { premium: 75000, db: 0.999999, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000002 },
    { premium: 150000, db: 1.010452, ltc: 0.992333 },
    { premium: 200000, db: 1.172865, ltc: 0.873171 },
    { premium: 300000, db: 1.335275, ltc: 0.754009 },
  ],
  "sp_joint|Female|45|None|3%|6 Years": [
    { premium: 50000, db: 0.999994, ltc: 0.999995 },
    { premium: 75000, db: 0.999998, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999996 },
    { premium: 150000, db: 0.999998, ltc: 0.999997 },
    { premium: 200000, db: 1.051306, ltc: 0.97699 },
    { premium: 300000, db: 1.417073, ltc: 0.812954 },
  ],
  "sp_joint|Female|45|None|3%|Lifetime": [
    { premium: 50000, db: 0.999994, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 1 },
    { premium: 150000, db: 0.999998, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.40935, ltc: 1 },
  ],
  "sp_joint|Female|45|None|5%|2 Years": [
    { premium: 50000, db: 1, ltc: 0.999998 },
    { premium: 75000, db: 0.999997, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.103747, ltc: 0.964973 },
    { premium: 150000, db: 1.196013, ltc: 0.933822 },
    { premium: 200000, db: 1.311345, ltc: 0.894884 },
    { premium: 300000, db: 1.426675, ltc: 0.855945 },
  ],
  "sp_joint|Female|45|None|5%|4 Years": [
    { premium: 50000, db: 1, ltc: 1.000002 },
    { premium: 75000, db: 0.999997, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.012537, ltc: 0.994347 },
    { premium: 150000, db: 1.167405, ltc: 0.924483 },
    { premium: 200000, db: 1.360987, ltc: 0.837154 },
    { premium: 300000, db: 1.554573, ltc: 0.749825 },
  ],
  "sp_joint|Female|45|None|5%|6 Years": [
    { premium: 50000, db: 1, ltc: 1.000001 },
    { premium: 75000, db: 0.999995, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.270184, ltc: 0.925647 },
    { premium: 300000, db: 1.721876, ltc: 0.801344 },
  ],
  "sp_joint|Female|45|None|5%|Lifetime": [
    { premium: 50000, db: 0.999992, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.159621, ltc: 1 },
    { premium: 300000, db: 1.733611, ltc: 1 },
  ],
  "sp_joint|Female|45|3%|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|Female|45|3%|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|45|3%|3%|6 Years": [
    { premium: 50000, db: 0.999993, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000002 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|45|3%|3%|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|Female|45|5%|5%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000004 },
  ],
  "sp_joint|Female|45|5%|5%|4 Years": [
    { premium: 50000, db: 0.999992, ltc: 0.999991 },
    { premium: 75000, db: 0.999992, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999999 },
    { premium: 150000, db: 0.999997, ltc: 0.999998 },
  ],
  "sp_joint|Female|45|5%|5%|6 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.999992 },
    { premium: 75000, db: 0.999991, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|45|5%|5%|Lifetime": [
    { premium: 50000, db: 1.020001, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|50|None|None|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.066185, ltc: 0.919413 },
  ],
  "sp_joint|Female|50|None|None|4 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 1.000001, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.062225, ltc: 0.923863 },
  ],
  "sp_joint|Female|50|None|None|6 Years": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.161463, ltc: 0.877922 },
  ],
  "sp_joint|Female|50|None|None|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.134309, ltc: 1 },
  ],
  "sp_joint|Female|50|None|3%|2 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999993 },
    { premium: 75000, db: 0.999999, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999996 },
    { premium: 150000, db: 0.999999, ltc: 0.999998 },
    { premium: 200000, db: 1.122953, ltc: 0.932681 },
    { premium: 300000, db: 1.249929, ltc: 0.863163 },
  ],
  "sp_joint|Female|50|None|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1.094926, ltc: 0.939966 },
    { premium: 300000, db: 1.306941, ltc: 0.805877 },
  ],
  "sp_joint|Female|50|None|3%|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1.000001 },
    { premium: 300000, db: 1.304032, ltc: 0.88311 },
    { premium: 400000, db: 1.545299, ltc: 0.790352 },
  ],
  "sp_joint|Female|50|None|3%|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.25051, ltc: 1 },
    { premium: 400000, db: 1.557464, ltc: 1 },
  ],
  "sp_joint|Female|50|None|5%|2 Years": [
    { premium: 50000, db: 0.999995, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.007783, ltc: 0.997938 },
    { premium: 150000, db: 1.126798, ltc: 0.966342 },
    { premium: 200000, db: 1.275572, ltc: 0.92685 },
    { premium: 300000, db: 1.424342, ltc: 0.887357 },
  ],
  "sp_joint|Female|50|None|5%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.029221, ltc: 0.98868 },
    { premium: 200000, db: 1.279285, ltc: 0.891798 },
    { premium: 300000, db: 1.529349, ltc: 0.794917 },
  ],
  "sp_joint|Female|50|None|5%|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000006, ltc: 1.000005 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.011631, ltc: 0.997258 },
    { premium: 300000, db: 1.596658, ltc: 0.859011 },
    { premium: 400000, db: 1.889171, ltc: 0.789888 },
  ],
  "sp_joint|Female|50|None|5%|Lifetime": [
    { premium: 50000, db: 0.999991, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.559366, ltc: 1 },
    { premium: 400000, db: 1.924961, ltc: 1 },
  ],
  "sp_joint|Female|50|3%|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1.000003 },
    { premium: 75000, db: 1, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|50|3%|3%|4 Years": [
    { premium: 50000, db: 0.999993, ltc: 0.999996 },
    { premium: 75000, db: 0.999998, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000002 },
    { premium: 150000, db: 1.000002, ltc: 1.000003 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|Female|50|3%|3%|6 Years": [
    { premium: 50000, db: 1, ltc: 0.999998 },
    { premium: 75000, db: 1, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000006 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|Female|50|3%|3%|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|Female|50|5%|5%|2 Years": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000003 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|Female|50|5%|5%|4 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.999992 },
    { premium: 75000, db: 1.000003, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999997 },
    { premium: 150000, db: 1.000003, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 0.999999 },
  ],
  "sp_joint|Female|50|5%|5%|6 Years": [
    { premium: 50000, db: 1.159999, ltc: 1.159997 },
    { premium: 75000, db: 0.999992, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
  ],
  "sp_joint|Female|50|5%|5%|Lifetime": [
    { premium: 50000, db: 1.220004, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.00001, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|Female|55|None|None|2 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 1.000001, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.034316, ltc: 0.964079 },
    { premium: 400000, db: 1.106545, ltc: 0.888464 },
  ],
  "sp_joint|Female|55|None|None|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.000814, ltc: 0.99914 },
    { premium: 400000, db: 1.120078, ltc: 0.872511 },
  ],
  "sp_joint|Female|55|None|None|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.062459, ltc: 0.958784 },
  ],
  "sp_joint|Female|55|None|None|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000005, ltc: 1 },
  ],
  "sp_joint|Female|55|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 0.999997 },
    { premium: 75000, db: 1, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1.065104, ltc: 0.970636 },
    { premium: 300000, db: 1.228738, ltc: 0.896833 },
    { premium: 400000, db: 1.310555, ltc: 0.859931 },
  ],
  "sp_joint|Female|55|None|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 0.999998 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.255374, ltc: 0.861115 },
    { premium: 400000, db: 1.39322, ltc: 0.786147 },
  ],
  "sp_joint|Female|55|None|3%|6 Years": [
    { premium: 50000, db: 0.999992, ltc: 0.999993 },
    { premium: 75000, db: 1.000003, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000002 },
    { premium: 200000, db: 1, ltc: 0.999999 },
    { premium: 300000, db: 1.133283, ltc: 0.955836 },
    { premium: 400000, db: 1.447484, ltc: 0.851722 },
  ],
  "sp_joint|Female|55|None|3%|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.017379, ltc: 1 },
    { premium: 400000, db: 1.416811, ltc: 1 },
  ],
  "sp_joint|Female|55|None|5%|2 Years": [
    { premium: 50000, db: 0.999994, ltc: 0.999991 },
    { premium: 75000, db: 0.999998, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.024746, ltc: 0.995059 },
    { premium: 200000, db: 1.216739, ltc: 0.9567 },
    { premium: 300000, db: 1.408733, ltc: 0.918343 },
    { premium: 400000, db: 1.50473, ltc: 0.899164 },
  ],
  "sp_joint|Female|55|None|5%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1.000005, ltc: 1.000004 },
    { premium: 200000, db: 1.157344, ltc: 0.947829 },
    { premium: 300000, db: 1.478568, ltc: 0.841309 },
    { premium: 400000, db: 1.639181, ltc: 0.788049 },
  ],
  "sp_joint|Female|55|None|5%|6 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.99999 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.407815, ltc: 0.91742 },
    { premium: 400000, db: 1.783688, ltc: 0.841305 },
  ],
  "sp_joint|Female|55|None|5%|Lifetime": [
    { premium: 50000, db: 1.079995, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.309167, ltc: 1 },
    { premium: 400000, db: 1.775596, ltc: 1 },
  ],
  "sp_joint|Female|55|3%|3%|2 Years": [
    { premium: 50000, db: 0.999993, ltc: 0.999997 },
    { premium: 75000, db: 1.000002, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000006 },
    { premium: 150000, db: 1.000002, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000005 },
  ],
  "sp_joint|Female|55|3%|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1.000007 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000004 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|Female|55|3%|3%|6 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.999991 },
    { premium: 75000, db: 0.99999, ltc: 0.99999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999997 },
    { premium: 150000, db: 0.999997, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 0.999999 },
    { premium: 300000, db: 1, ltc: 0.999999 },
  ],
  "sp_joint|Female|55|3%|3%|Lifetime": [
    { premium: 50000, db: 1.079999, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|Female|55|5%|5%|2 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.999986 },
    { premium: 75000, db: 1.000003, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000005 },
    { premium: 150000, db: 1.000003, ltc: 1.000002 },
    { premium: 200000, db: 1.000005, ltc: 1.000002 },
  ],
  "sp_joint|Female|55|5%|5%|4 Years": [
    { premium: 50000, db: 1.099991, ltc: 1.099991 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1.000005, ltc: 1.000006 },
  ],
  "sp_joint|Female|55|5%|5%|6 Years": [
    { premium: 50000, db: 1.380012, ltc: 1.380013 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000009, ltc: 1.000009 },
  ],
  "sp_joint|Female|55|5%|5%|Lifetime": [
    { premium: 50000, db: 1.459996, ltc: 1 },
    { premium: 75000, db: 0.99999, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|60|None|None|2 Years": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.060784, ltc: 0.939841 },
  ],
  "sp_joint|Female|60|None|None|4 Years": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.041889, ltc: 0.957227 },
  ],
  "sp_joint|Female|60|None|None|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
  ],
  "sp_joint|Female|60|None|None|Lifetime": [
    { premium: 50000, db: 0.999992, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|Female|60|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1.000003 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.160335, ltc: 0.931592 },
    { premium: 400000, db: 1.262982, ltc: 0.887796 },
  ],
  "sp_joint|Female|60|None|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 0.999999 },
    { premium: 300000, db: 1.135402, ltc: 0.929129 },
    { premium: 400000, db: 1.308182, ltc: 0.838692 },
  ],
  "sp_joint|Female|60|None|3%|6 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.999989 },
    { premium: 75000, db: 0.999997, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000001 },
    { premium: 150000, db: 1.000003, ltc: 1.000002 },
    { premium: 200000, db: 1.000005, ltc: 1.000003 },
    { premium: 300000, db: 1.000003, ltc: 1.000002 },
    { premium: 400000, db: 1.242747, ltc: 0.921635 },
  ],
  "sp_joint|Female|60|None|3%|Lifetime": [
    { premium: 50000, db: 1.079989, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.158957, ltc: 1 },
  ],
  "sp_joint|Female|60|None|5%|2 Years": [
    { premium: 50000, db: 1, ltc: 1.000003 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1.092699, ltc: 0.98232 },
    { premium: 300000, db: 1.32965, ltc: 0.937117 },
    { premium: 400000, db: 1.448125, ltc: 0.914516 },
  ],
  "sp_joint|Female|60|None|5%|4 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.99999 },
    { premium: 75000, db: 0.999997, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000001 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000005 },
    { premium: 300000, db: 1.342894, ltc: 0.888179 },
    { premium: 400000, db: 1.539892, ltc: 0.823932 },
  ],
  "sp_joint|Female|60|None|5%|6 Years": [
    { premium: 50000, db: 1.2, ltc: 1.2 },
    { premium: 75000, db: 0.999996, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000004 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000008 },
    { premium: 300000, db: 1.09059, ltc: 0.981704 },
    { premium: 400000, db: 1.546282, ltc: 0.889626 },
  ],
  "sp_joint|Female|60|None|5%|Lifetime": [
    { premium: 50000, db: 1.300005, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.490344, ltc: 1 },
  ],
  "sp_joint|Female|60|3%|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 0.999996 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 0.999998 },
  ],
  "sp_joint|Female|60|3%|3%|4 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.999991 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999995 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|60|3%|3%|6 Years": [
    { premium: 50000, db: 1.219994, ltc: 1.219996 },
    { premium: 75000, db: 0.999992, ltc: 0.999991 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000003 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1.000005 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.000006, ltc: 1.000005 },
  ],
  "sp_joint|Female|60|3%|3%|Lifetime": [
    { premium: 50000, db: 1.319989, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000009, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
  ],
  "sp_joint|Female|60|5%|5%|2 Years": [
    { premium: 50000, db: 1.199995, ltc: 1.199998 },
    { premium: 75000, db: 0.999992, ltc: 0.999989 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999993 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|60|5%|5%|4 Years": [
    { premium: 50000, db: 1.339994, ltc: 1.339994 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000006 },
    { premium: 150000, db: 1.000004, ltc: 1.000003 },
    { premium: 200000, db: 1.000007, ltc: 1.000006 },
    { premium: 300000, db: 1.000009, ltc: 1.000007 },
  ],
  "sp_joint|Female|60|5%|5%|6 Years": [
    { premium: 50000, db: 1.660003, ltc: 1.660001 },
    { premium: 75000, db: 1.106669, ltc: 1.106668 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000006 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
  ],
  "sp_joint|Female|60|5%|5%|Lifetime": [
    { premium: 50000, db: 1.760006, ltc: 1 },
    { premium: 75000, db: 1.173337, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|Female|65|None|None|2 Years": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|Female|65|None|None|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|65|None|None|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|Female|65|None|None|Lifetime": [
    { premium: 50000, db: 1.019992, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|Female|65|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 0.999996 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.060653, ltc: 0.972738 },
    { premium: 400000, db: 1.184721, ltc: 0.916971 },
  ],
  "sp_joint|Female|65|None|3%|4 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000004 },
    { premium: 400000, db: 1.181231, ltc: 0.90118 },
  ],
  "sp_joint|Female|65|None|3%|6 Years": [
    { premium: 50000, db: 1.219979, ltc: 1.219982 },
    { premium: 75000, db: 0.999992, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1.000001 },
    { premium: 400000, db: 1, ltc: 1.000001 },
  ],
  "sp_joint|Female|65|None|3%|Lifetime": [
    { premium: 50000, db: 1.319998, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999992, ltc: 1 },
    { premium: 150000, db: 0.999996, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|65|None|5%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000003 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.212791, ltc: 0.95347 },
    { premium: 400000, db: 1.352332, ltc: 0.922955 },
  ],
  "sp_joint|Female|65|None|5%|4 Years": [
    { premium: 50000, db: 1.079997, ltc: 1.079997 },
    { premium: 75000, db: 0.999996, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.160409, ltc: 0.943391 },
    { premium: 400000, db: 1.391355, ltc: 0.861883 },
  ],
  "sp_joint|Female|65|None|5%|6 Years": [
    { premium: 50000, db: 1.439978, ltc: 1.439979 },
    { premium: 75000, db: 0.999986, ltc: 0.999987 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999998 },
    { premium: 150000, db: 0.999995, ltc: 0.999995 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.250431, ltc: 0.943513 },
  ],
  "sp_joint|Female|65|None|5%|Lifetime": [
    { premium: 50000, db: 1.559995, ltc: 1 },
    { premium: 75000, db: 1.039997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.00001, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.00001, ltc: 1 },
    { premium: 400000, db: 1.151471, ltc: 1 },
  ],
  "sp_joint|Female|65|3%|3%|2 Years": [
    { premium: 50000, db: 1.060009, ltc: 1.060013 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000004 },
    { premium: 150000, db: 1.000004, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000007, ltc: 1.000008 },
  ],
  "sp_joint|Female|65|3%|3%|4 Years": [
    { premium: 50000, db: 1.199981, ltc: 1.199978 },
    { premium: 75000, db: 0.999992, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|65|3%|3%|6 Years": [
    { premium: 50000, db: 1.479995, ltc: 1.479998 },
    { premium: 75000, db: 1, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|65|3%|3%|Lifetime": [
    { premium: 50000, db: 1.580002, ltc: 1 },
    { premium: 75000, db: 1.053334, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
  ],
  "sp_joint|Female|65|5%|5%|2 Years": [
    { premium: 50000, db: 1.41999, ltc: 1.419992 },
    { premium: 75000, db: 1, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 0.999997 },
    { premium: 300000, db: 1.000005, ltc: 1.000002 },
  ],
  "sp_joint|Female|65|5%|5%|4 Years": [
    { premium: 50000, db: 1.579982, ltc: 1.579979 },
    { premium: 75000, db: 1.053322, ltc: 1.05332 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|65|5%|5%|6 Years": [
    { premium: 50000, db: 1.960002, ltc: 1.960007 },
    { premium: 75000, db: 1.306668, ltc: 1.306672 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000009 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1.00001, ltc: 1.00001 },
    { premium: 300000, db: 1.000006, ltc: 1.000008 },
    { premium: 400000, db: 1.00001, ltc: 1.00001 },
  ],
  "sp_joint|Female|65|5%|5%|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.97088, ltc: 1 },
    { premium: 150000, db: 0.97087, ltc: 1 },
    { premium: 200000, db: 0.970876, ltc: 1 },
    { premium: 300000, db: 0.970876, ltc: 1 },
    { premium: 400000, db: 0.970881, ltc: 1 },
  ],
  "sp_joint|Female|70|None|None|2 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|Female|70|None|None|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000005, ltc: 1.000005 },
  ],
  "sp_joint|Female|70|None|None|6 Years": [
    { premium: 50000, db: 1.179988, ltc: 1.179988 },
    { premium: 75000, db: 0.999988, ltc: 0.999988 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|70|None|None|Lifetime": [
    { premium: 50000, db: 1.279991, ltc: 1 },
    { premium: 75000, db: 1.000008, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|Female|70|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999993, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.085113, ltc: 0.953617 },
  ],
  "sp_joint|Female|70|None|3%|4 Years": [
    { premium: 50000, db: 1.139997, ltc: 1.139997 },
    { premium: 75000, db: 0.999992, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999994 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.034486, ltc: 0.97787 },
  ],
  "sp_joint|Female|70|None|3%|6 Years": [
    { premium: 50000, db: 1.459983, ltc: 1.459983 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 0.999998 },
    { premium: 300000, db: 1, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 0.999999 },
  ],
  "sp_joint|Female|70|None|3%|Lifetime": [
    { premium: 50000, db: 1.580018, ltc: 1 },
    { premium: 75000, db: 1.053345, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000013, ltc: 1 },
    { premium: 150000, db: 1.00001, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.00001, ltc: 1 },
    { premium: 400000, db: 1.000012, ltc: 1 },
  ],
  "sp_joint|Female|70|None|5%|2 Years": [
    { premium: 50000, db: 1.119992, ltc: 1.119993 },
    { premium: 75000, db: 1, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1.000002 },
    { premium: 200000, db: 1, ltc: 1.000003 },
    { premium: 300000, db: 1.079601, ltc: 0.975012 },
    { premium: 400000, db: 1.229006, ltc: 0.92811 },
  ],
  "sp_joint|Female|70|None|5%|4 Years": [
    { premium: 50000, db: 1.3, ltc: 1.299997 },
    { premium: 75000, db: 1, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.219155, ltc: 0.902365 },
  ],
  "sp_joint|Female|70|None|5%|6 Years": [
    { premium: 50000, db: 1.700012, ltc: 1.700013 },
    { premium: 75000, db: 1.133341, ltc: 1.133342 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.00001, ltc: 1.000011 },
    { premium: 150000, db: 1.000006, ltc: 1.000007 },
    { premium: 200000, db: 1.000008, ltc: 1.000011 },
    { premium: 300000, db: 1.000011, ltc: 1.000013 },
    { premium: 400000, db: 1.000013, ltc: 1.000015 },
  ],
  "sp_joint|Female|70|None|5%|Lifetime": [
    { premium: 50000, db: 1.820005, ltc: 1 },
    { premium: 75000, db: 1.213336, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.000009, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000009, ltc: 1 },
  ],
  "sp_joint|Female|70|3%|3%|2 Years": [
    { premium: 50000, db: 1.279991, ltc: 1.279991 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000005 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1.000003 },
    { premium: 300000, db: 1.000008, ltc: 1.000006 },
    { premium: 400000, db: 1.000009, ltc: 1.000008 },
  ],
  "sp_joint|Female|70|3%|3%|4 Years": [
    { premium: 50000, db: 1.420006, ltc: 1.420007 },
    { premium: 75000, db: 1.000009, ltc: 1.000009 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000005 },
    { premium: 150000, db: 1.000009, ltc: 1.000012 },
    { premium: 200000, db: 1.000007, ltc: 1.000009 },
    { premium: 300000, db: 1.000009, ltc: 1.00001 },
    { premium: 400000, db: 1.000011, ltc: 1.000011 },
  ],
  "sp_joint|Female|70|3%|3%|6 Years": [
    { premium: 50000, db: 1.740018, ltc: 1.740026 },
    { premium: 75000, db: 1.160012, ltc: 1.160017 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.00001, ltc: 1.000012 },
    { premium: 150000, db: 1.000006, ltc: 1.000009 },
    { premium: 200000, db: 1.000009, ltc: 1.00001 },
    { premium: 300000, db: 1.000012, ltc: 1.000014 },
    { premium: 400000, db: 1.000013, ltc: 1.000016 },
  ],
  "sp_joint|Female|70|3%|3%|Lifetime": [
    { premium: 50000, db: 1.839979, ltc: 1 },
    { premium: 75000, db: 1.226653, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Female|70|5%|5%|2 Years": [
    { premium: 50000, db: 1.64, ltc: 1.639995 },
    { premium: 75000, db: 1.093333, ltc: 1.09333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 0.999996 },
    { premium: 300000, db: 1, ltc: 0.999997 },
  ],
  "sp_joint|Female|70|5%|5%|4 Years": [
    { premium: 50000, db: 1.820003, ltc: 1.820009 },
    { premium: 75000, db: 1.213335, ltc: 1.213339 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000002 },
    { premium: 150000, db: 1, ltc: 1.000004 },
    { premium: 200000, db: 1, ltc: 1.000003 },
    { premium: 300000, db: 1, ltc: 1.000002 },
    { premium: 400000, db: 1, ltc: 1.000003 },
  ],
  "sp_joint|Female|70|5%|5%|6 Years": [
    { premium: 50000, db: 2, ltc: 2 },
    { premium: 75000, db: 1.333333, ltc: 1.333333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.892847, ltc: 0.892846 },
    { premium: 150000, db: 0.89285, ltc: 0.892848 },
    { premium: 200000, db: 0.892853, ltc: 0.892852 },
    { premium: 300000, db: 0.892856, ltc: 0.892854 },
    { premium: 400000, db: 0.892858, ltc: 0.892856 },
  ],
  "sp_joint|Female|70|5%|5%|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.854702, ltc: 1 },
    { premium: 150000, db: 0.8547, ltc: 1 },
    { premium: 200000, db: 0.854706, ltc: 1 },
    { premium: 300000, db: 0.854706, ltc: 1 },
    { premium: 400000, db: 0.854711, ltc: 1 },
  ],
  "sp_joint|Male|45|None|None|2 Years": [
    { premium: 50000, db: 0.999997, ltc: 0.999997 },
    { premium: 75000, db: 0.999999, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.086787, ltc: 0.877124 },
  ],
  "sp_joint|Male|45|None|None|4 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 0.999999, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.102926, ltc: 0.857375 },
  ],
  "sp_joint|Male|45|None|None|6 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 1.000001, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.076175, ltc: 0.934595 },
  ],
  "sp_joint|Male|45|None|None|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000002, ltc: 1 },
    { premium: 300000, db: 1.031647, ltc: 1 },
  ],
  "sp_joint|Male|45|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.062296, ltc: 0.959279 },
    { premium: 200000, db: 1.160905, ltc: 0.894816 },
    { premium: 300000, db: 1.259518, ltc: 0.830354 },
  ],
  "sp_joint|Male|45|None|3%|4 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999995 },
    { premium: 75000, db: 0.999999, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000002 },
    { premium: 150000, db: 1.010452, ltc: 0.992333 },
    { premium: 200000, db: 1.172865, ltc: 0.873171 },
    { premium: 300000, db: 1.335275, ltc: 0.754009 },
  ],
  "sp_joint|Male|45|None|3%|6 Years": [
    { premium: 50000, db: 0.999994, ltc: 0.999995 },
    { premium: 75000, db: 0.999998, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999996 },
    { premium: 150000, db: 0.999998, ltc: 0.999997 },
    { premium: 200000, db: 1.051306, ltc: 0.97699 },
    { premium: 300000, db: 1.417073, ltc: 0.812954 },
  ],
  "sp_joint|Male|45|None|3%|Lifetime": [
    { premium: 50000, db: 0.999994, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 1 },
    { premium: 150000, db: 0.999998, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.40935, ltc: 1 },
  ],
  "sp_joint|Male|45|None|5%|2 Years": [
    { premium: 50000, db: 1, ltc: 0.999998 },
    { premium: 75000, db: 0.999997, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.103747, ltc: 0.964973 },
    { premium: 150000, db: 1.196013, ltc: 0.933822 },
    { premium: 200000, db: 1.311345, ltc: 0.894884 },
    { premium: 300000, db: 1.426675, ltc: 0.855945 },
  ],
  "sp_joint|Male|45|None|5%|4 Years": [
    { premium: 50000, db: 1, ltc: 1.000002 },
    { premium: 75000, db: 0.999997, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.012537, ltc: 0.994347 },
    { premium: 150000, db: 1.167405, ltc: 0.924483 },
    { premium: 200000, db: 1.360987, ltc: 0.837154 },
    { premium: 300000, db: 1.554573, ltc: 0.749825 },
  ],
  "sp_joint|Male|45|None|5%|6 Years": [
    { premium: 50000, db: 1, ltc: 1.000001 },
    { premium: 75000, db: 0.999995, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.270184, ltc: 0.925647 },
    { premium: 300000, db: 1.721876, ltc: 0.801344 },
  ],
  "sp_joint|Male|45|None|5%|Lifetime": [
    { premium: 50000, db: 0.999992, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.159621, ltc: 1 },
    { premium: 300000, db: 1.733611, ltc: 1 },
  ],
  "sp_joint|Male|45|3%|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|Male|45|3%|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|45|3%|3%|6 Years": [
    { premium: 50000, db: 0.999993, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000002 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|45|3%|3%|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|Male|45|5%|5%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000004 },
  ],
  "sp_joint|Male|45|5%|5%|4 Years": [
    { premium: 50000, db: 0.999992, ltc: 0.999991 },
    { premium: 75000, db: 0.999992, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999999 },
    { premium: 150000, db: 0.999997, ltc: 0.999998 },
  ],
  "sp_joint|Male|45|5%|5%|6 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.999992 },
    { premium: 75000, db: 0.999991, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|45|5%|5%|Lifetime": [
    { premium: 50000, db: 1.020001, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|50|None|None|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.066185, ltc: 0.919413 },
  ],
  "sp_joint|Male|50|None|None|4 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 1.000001, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.062225, ltc: 0.923863 },
  ],
  "sp_joint|Male|50|None|None|6 Years": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.161463, ltc: 0.877922 },
  ],
  "sp_joint|Male|50|None|None|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.134309, ltc: 1 },
  ],
  "sp_joint|Male|50|None|3%|2 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999993 },
    { premium: 75000, db: 0.999999, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999996 },
    { premium: 150000, db: 0.999999, ltc: 0.999998 },
    { premium: 200000, db: 1.122953, ltc: 0.932681 },
    { premium: 300000, db: 1.249929, ltc: 0.863163 },
  ],
  "sp_joint|Male|50|None|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1.094926, ltc: 0.939966 },
    { premium: 300000, db: 1.306941, ltc: 0.805877 },
  ],
  "sp_joint|Male|50|None|3%|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1.000001 },
    { premium: 300000, db: 1.304032, ltc: 0.88311 },
    { premium: 400000, db: 1.545299, ltc: 0.790352 },
  ],
  "sp_joint|Male|50|None|3%|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.25051, ltc: 1 },
    { premium: 400000, db: 1.557464, ltc: 1 },
  ],
  "sp_joint|Male|50|None|5%|2 Years": [
    { premium: 50000, db: 0.999995, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.007783, ltc: 0.997938 },
    { premium: 150000, db: 1.126798, ltc: 0.966342 },
    { premium: 200000, db: 1.275572, ltc: 0.92685 },
    { premium: 300000, db: 1.424342, ltc: 0.887357 },
  ],
  "sp_joint|Male|50|None|5%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.029221, ltc: 0.98868 },
    { premium: 200000, db: 1.279285, ltc: 0.891798 },
    { premium: 300000, db: 1.529349, ltc: 0.794917 },
  ],
  "sp_joint|Male|50|None|5%|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000006, ltc: 1.000005 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.011631, ltc: 0.997258 },
    { premium: 300000, db: 1.596658, ltc: 0.859011 },
    { premium: 400000, db: 1.889171, ltc: 0.789888 },
  ],
  "sp_joint|Male|50|None|5%|Lifetime": [
    { premium: 50000, db: 0.999991, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.559366, ltc: 1 },
    { premium: 400000, db: 1.924961, ltc: 1 },
  ],
  "sp_joint|Male|50|3%|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1.000003 },
    { premium: 75000, db: 1, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|50|3%|3%|4 Years": [
    { premium: 50000, db: 0.999993, ltc: 0.999996 },
    { premium: 75000, db: 0.999998, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000002 },
    { premium: 150000, db: 1.000002, ltc: 1.000003 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|Male|50|3%|3%|6 Years": [
    { premium: 50000, db: 1, ltc: 0.999998 },
    { premium: 75000, db: 1, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000006 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|Male|50|3%|3%|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|Male|50|5%|5%|2 Years": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000003 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|Male|50|5%|5%|4 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.999992 },
    { premium: 75000, db: 1.000003, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999997 },
    { premium: 150000, db: 1.000003, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 0.999999 },
  ],
  "sp_joint|Male|50|5%|5%|6 Years": [
    { premium: 50000, db: 1.159999, ltc: 1.159997 },
    { premium: 75000, db: 0.999992, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
  ],
  "sp_joint|Male|50|5%|5%|Lifetime": [
    { premium: 50000, db: 1.220004, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.00001, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|Male|55|None|None|2 Years": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 1.000001, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.034316, ltc: 0.964079 },
    { premium: 400000, db: 1.106545, ltc: 0.888464 },
  ],
  "sp_joint|Male|55|None|None|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.000814, ltc: 0.99914 },
    { premium: 400000, db: 1.120078, ltc: 0.872511 },
  ],
  "sp_joint|Male|55|None|None|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.062459, ltc: 0.958784 },
  ],
  "sp_joint|Male|55|None|None|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000005, ltc: 1 },
  ],
  "sp_joint|Male|55|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 0.999997 },
    { premium: 75000, db: 1, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1.065104, ltc: 0.970636 },
    { premium: 300000, db: 1.228738, ltc: 0.896833 },
    { premium: 400000, db: 1.310555, ltc: 0.859931 },
  ],
  "sp_joint|Male|55|None|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 0.999998 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.255374, ltc: 0.861115 },
    { premium: 400000, db: 1.39322, ltc: 0.786147 },
  ],
  "sp_joint|Male|55|None|3%|6 Years": [
    { premium: 50000, db: 0.999992, ltc: 0.999993 },
    { premium: 75000, db: 1.000003, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000002 },
    { premium: 200000, db: 1, ltc: 0.999999 },
    { premium: 300000, db: 1.133283, ltc: 0.955836 },
    { premium: 400000, db: 1.447484, ltc: 0.851722 },
  ],
  "sp_joint|Male|55|None|3%|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.017379, ltc: 1 },
    { premium: 400000, db: 1.416811, ltc: 1 },
  ],
  "sp_joint|Male|55|None|5%|2 Years": [
    { premium: 50000, db: 0.999994, ltc: 0.999991 },
    { premium: 75000, db: 0.999998, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.024746, ltc: 0.995059 },
    { premium: 200000, db: 1.216739, ltc: 0.9567 },
    { premium: 300000, db: 1.408733, ltc: 0.918343 },
    { premium: 400000, db: 1.50473, ltc: 0.899164 },
  ],
  "sp_joint|Male|55|None|5%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1.000005, ltc: 1.000004 },
    { premium: 200000, db: 1.157344, ltc: 0.947829 },
    { premium: 300000, db: 1.478568, ltc: 0.841309 },
    { premium: 400000, db: 1.639181, ltc: 0.788049 },
  ],
  "sp_joint|Male|55|None|5%|6 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.99999 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.407815, ltc: 0.91742 },
    { premium: 400000, db: 1.783688, ltc: 0.841305 },
  ],
  "sp_joint|Male|55|None|5%|Lifetime": [
    { premium: 50000, db: 1.079995, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.309167, ltc: 1 },
    { premium: 400000, db: 1.775596, ltc: 1 },
  ],
  "sp_joint|Male|55|3%|3%|2 Years": [
    { premium: 50000, db: 0.999993, ltc: 0.999997 },
    { premium: 75000, db: 1.000002, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000006 },
    { premium: 150000, db: 1.000002, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000005 },
  ],
  "sp_joint|Male|55|3%|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1.000007 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000004 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|Male|55|3%|3%|6 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.999991 },
    { premium: 75000, db: 0.99999, ltc: 0.99999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999997 },
    { premium: 150000, db: 0.999997, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 0.999999 },
    { premium: 300000, db: 1, ltc: 0.999999 },
  ],
  "sp_joint|Male|55|3%|3%|Lifetime": [
    { premium: 50000, db: 1.079999, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|Male|55|5%|5%|2 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.999986 },
    { premium: 75000, db: 1.000003, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000005 },
    { premium: 150000, db: 1.000003, ltc: 1.000002 },
    { premium: 200000, db: 1.000005, ltc: 1.000002 },
  ],
  "sp_joint|Male|55|5%|5%|4 Years": [
    { premium: 50000, db: 1.099991, ltc: 1.099991 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1.000005, ltc: 1.000006 },
  ],
  "sp_joint|Male|55|5%|5%|6 Years": [
    { premium: 50000, db: 1.380012, ltc: 1.380013 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000009, ltc: 1.000009 },
  ],
  "sp_joint|Male|55|5%|5%|Lifetime": [
    { premium: 50000, db: 1.459996, ltc: 1 },
    { premium: 75000, db: 0.99999, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|60|None|None|2 Years": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.060784, ltc: 0.939841 },
  ],
  "sp_joint|Male|60|None|None|4 Years": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.041889, ltc: 0.957227 },
  ],
  "sp_joint|Male|60|None|None|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
  ],
  "sp_joint|Male|60|None|None|Lifetime": [
    { premium: 50000, db: 0.999992, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|Male|60|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1.000003 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.160335, ltc: 0.931592 },
    { premium: 400000, db: 1.262982, ltc: 0.887796 },
  ],
  "sp_joint|Male|60|None|3%|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 0.999999 },
    { premium: 300000, db: 1.135402, ltc: 0.929129 },
    { premium: 400000, db: 1.308182, ltc: 0.838692 },
  ],
  "sp_joint|Male|60|None|3%|6 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.999989 },
    { premium: 75000, db: 0.999997, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000001 },
    { premium: 150000, db: 1.000003, ltc: 1.000002 },
    { premium: 200000, db: 1.000005, ltc: 1.000003 },
    { premium: 300000, db: 1.000003, ltc: 1.000002 },
    { premium: 400000, db: 1.242747, ltc: 0.921635 },
  ],
  "sp_joint|Male|60|None|3%|Lifetime": [
    { premium: 50000, db: 1.079989, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.158957, ltc: 1 },
  ],
  "sp_joint|Male|60|None|5%|2 Years": [
    { premium: 50000, db: 1, ltc: 1.000003 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1.092699, ltc: 0.98232 },
    { premium: 300000, db: 1.32965, ltc: 0.937117 },
    { premium: 400000, db: 1.448125, ltc: 0.914516 },
  ],
  "sp_joint|Male|60|None|5%|4 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.99999 },
    { premium: 75000, db: 0.999997, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000001 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000005 },
    { premium: 300000, db: 1.342894, ltc: 0.888179 },
    { premium: 400000, db: 1.539892, ltc: 0.823932 },
  ],
  "sp_joint|Male|60|None|5%|6 Years": [
    { premium: 50000, db: 1.2, ltc: 1.2 },
    { premium: 75000, db: 0.999996, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000004 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000008 },
    { premium: 300000, db: 1.09059, ltc: 0.981704 },
    { premium: 400000, db: 1.546282, ltc: 0.889626 },
  ],
  "sp_joint|Male|60|None|5%|Lifetime": [
    { premium: 50000, db: 1.300005, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.490344, ltc: 1 },
  ],
  "sp_joint|Male|60|3%|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 0.999996 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 0.999998 },
  ],
  "sp_joint|Male|60|3%|3%|4 Years": [
    { premium: 50000, db: 0.99999, ltc: 0.999991 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999995 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|60|3%|3%|6 Years": [
    { premium: 50000, db: 1.219994, ltc: 1.219996 },
    { premium: 75000, db: 0.999992, ltc: 0.999991 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000003 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1.000005 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.000006, ltc: 1.000005 },
  ],
  "sp_joint|Male|60|3%|3%|Lifetime": [
    { premium: 50000, db: 1.319989, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000009, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
  ],
  "sp_joint|Male|60|5%|5%|2 Years": [
    { premium: 50000, db: 1.199995, ltc: 1.199998 },
    { premium: 75000, db: 0.999992, ltc: 0.999989 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999993 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|60|5%|5%|4 Years": [
    { premium: 50000, db: 1.339994, ltc: 1.339994 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000006 },
    { premium: 150000, db: 1.000004, ltc: 1.000003 },
    { premium: 200000, db: 1.000007, ltc: 1.000006 },
    { premium: 300000, db: 1.000009, ltc: 1.000007 },
  ],
  "sp_joint|Male|60|5%|5%|6 Years": [
    { premium: 50000, db: 1.660003, ltc: 1.660001 },
    { premium: 75000, db: 1.106669, ltc: 1.106668 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000006 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
  ],
  "sp_joint|Male|60|5%|5%|Lifetime": [
    { premium: 50000, db: 1.760006, ltc: 1 },
    { premium: 75000, db: 1.173337, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|Male|65|None|None|2 Years": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|Male|65|None|None|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|65|None|None|6 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|Male|65|None|None|Lifetime": [
    { premium: 50000, db: 1.019992, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|Male|65|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 0.999996 },
    { premium: 75000, db: 1, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.060653, ltc: 0.972738 },
    { premium: 400000, db: 1.184721, ltc: 0.916971 },
  ],
  "sp_joint|Male|65|None|3%|4 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000004 },
    { premium: 400000, db: 1.181231, ltc: 0.90118 },
  ],
  "sp_joint|Male|65|None|3%|6 Years": [
    { premium: 50000, db: 1.219979, ltc: 1.219982 },
    { premium: 75000, db: 0.999992, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1.000001 },
    { premium: 400000, db: 1, ltc: 1.000001 },
  ],
  "sp_joint|Male|65|None|3%|Lifetime": [
    { premium: 50000, db: 1.319998, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999992, ltc: 1 },
    { premium: 150000, db: 0.999996, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|65|None|5%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000003 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.212791, ltc: 0.95347 },
    { premium: 400000, db: 1.352332, ltc: 0.922955 },
  ],
  "sp_joint|Male|65|None|5%|4 Years": [
    { premium: 50000, db: 1.079997, ltc: 1.079997 },
    { premium: 75000, db: 0.999996, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.160409, ltc: 0.943391 },
    { premium: 400000, db: 1.391355, ltc: 0.861883 },
  ],
  "sp_joint|Male|65|None|5%|6 Years": [
    { premium: 50000, db: 1.439978, ltc: 1.439979 },
    { premium: 75000, db: 0.999986, ltc: 0.999987 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999998 },
    { premium: 150000, db: 0.999995, ltc: 0.999995 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.250431, ltc: 0.943513 },
  ],
  "sp_joint|Male|65|None|5%|Lifetime": [
    { premium: 50000, db: 1.559995, ltc: 1 },
    { premium: 75000, db: 1.039997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.00001, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.00001, ltc: 1 },
    { premium: 400000, db: 1.151471, ltc: 1 },
  ],
  "sp_joint|Male|65|3%|3%|2 Years": [
    { premium: 50000, db: 1.060009, ltc: 1.060013 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000004 },
    { premium: 150000, db: 1.000004, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000007, ltc: 1.000008 },
  ],
  "sp_joint|Male|65|3%|3%|4 Years": [
    { premium: 50000, db: 1.199981, ltc: 1.199978 },
    { premium: 75000, db: 0.999992, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|65|3%|3%|6 Years": [
    { premium: 50000, db: 1.479995, ltc: 1.479998 },
    { premium: 75000, db: 1, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|65|3%|3%|Lifetime": [
    { premium: 50000, db: 1.580002, ltc: 1 },
    { premium: 75000, db: 1.053334, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
  ],
  "sp_joint|Male|65|5%|5%|2 Years": [
    { premium: 50000, db: 1.41999, ltc: 1.419992 },
    { premium: 75000, db: 1, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 0.999997 },
    { premium: 300000, db: 1.000005, ltc: 1.000002 },
  ],
  "sp_joint|Male|65|5%|5%|4 Years": [
    { premium: 50000, db: 1.579982, ltc: 1.579979 },
    { premium: 75000, db: 1.053322, ltc: 1.05332 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|65|5%|5%|6 Years": [
    { premium: 50000, db: 1.960002, ltc: 1.960007 },
    { premium: 75000, db: 1.306668, ltc: 1.306672 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000009 },
    { premium: 150000, db: 1, ltc: 1.000001 },
    { premium: 200000, db: 1.00001, ltc: 1.00001 },
    { premium: 300000, db: 1.000006, ltc: 1.000008 },
    { premium: 400000, db: 1.00001, ltc: 1.00001 },
  ],
  "sp_joint|Male|65|5%|5%|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.97088, ltc: 1 },
    { premium: 150000, db: 0.97087, ltc: 1 },
    { premium: 200000, db: 0.970876, ltc: 1 },
    { premium: 300000, db: 0.970876, ltc: 1 },
    { premium: 400000, db: 0.970881, ltc: 1 },
  ],
  "sp_joint|Male|70|None|None|2 Years": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|Male|70|None|None|4 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000005, ltc: 1.000005 },
  ],
  "sp_joint|Male|70|None|None|6 Years": [
    { premium: 50000, db: 1.179988, ltc: 1.179988 },
    { premium: 75000, db: 0.999988, ltc: 0.999988 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|70|None|None|Lifetime": [
    { premium: 50000, db: 1.279991, ltc: 1 },
    { premium: 75000, db: 1.000008, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|Male|70|None|3%|2 Years": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999993, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.085113, ltc: 0.953617 },
  ],
  "sp_joint|Male|70|None|3%|4 Years": [
    { premium: 50000, db: 1.139997, ltc: 1.139997 },
    { premium: 75000, db: 0.999992, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999994 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.034486, ltc: 0.97787 },
  ],
  "sp_joint|Male|70|None|3%|6 Years": [
    { premium: 50000, db: 1.459983, ltc: 1.459983 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 0.999998 },
    { premium: 300000, db: 1, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 0.999999 },
  ],
  "sp_joint|Male|70|None|3%|Lifetime": [
    { premium: 50000, db: 1.580018, ltc: 1 },
    { premium: 75000, db: 1.053345, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000013, ltc: 1 },
    { premium: 150000, db: 1.00001, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.00001, ltc: 1 },
    { premium: 400000, db: 1.000012, ltc: 1 },
  ],
  "sp_joint|Male|70|None|5%|2 Years": [
    { premium: 50000, db: 1.119992, ltc: 1.119993 },
    { premium: 75000, db: 1, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000001 },
    { premium: 150000, db: 1, ltc: 1.000002 },
    { premium: 200000, db: 1, ltc: 1.000003 },
    { premium: 300000, db: 1.079601, ltc: 0.975012 },
    { premium: 400000, db: 1.229006, ltc: 0.92811 },
  ],
  "sp_joint|Male|70|None|5%|4 Years": [
    { premium: 50000, db: 1.3, ltc: 1.299997 },
    { premium: 75000, db: 1, ltc: 1.000001 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999999 },
    { premium: 150000, db: 1, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.219155, ltc: 0.902365 },
  ],
  "sp_joint|Male|70|None|5%|6 Years": [
    { premium: 50000, db: 1.700012, ltc: 1.700013 },
    { premium: 75000, db: 1.133341, ltc: 1.133342 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.00001, ltc: 1.000011 },
    { premium: 150000, db: 1.000006, ltc: 1.000007 },
    { premium: 200000, db: 1.000008, ltc: 1.000011 },
    { premium: 300000, db: 1.000011, ltc: 1.000013 },
    { premium: 400000, db: 1.000013, ltc: 1.000015 },
  ],
  "sp_joint|Male|70|None|5%|Lifetime": [
    { premium: 50000, db: 1.820005, ltc: 1 },
    { premium: 75000, db: 1.213336, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.000009, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000009, ltc: 1 },
  ],
  "sp_joint|Male|70|3%|3%|2 Years": [
    { premium: 50000, db: 1.279991, ltc: 1.279991 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000005 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1.000003 },
    { premium: 300000, db: 1.000008, ltc: 1.000006 },
    { premium: 400000, db: 1.000009, ltc: 1.000008 },
  ],
  "sp_joint|Male|70|3%|3%|4 Years": [
    { premium: 50000, db: 1.420006, ltc: 1.420007 },
    { premium: 75000, db: 1.000009, ltc: 1.000009 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000005 },
    { premium: 150000, db: 1.000009, ltc: 1.000012 },
    { premium: 200000, db: 1.000007, ltc: 1.000009 },
    { premium: 300000, db: 1.000009, ltc: 1.00001 },
    { premium: 400000, db: 1.000011, ltc: 1.000011 },
  ],
  "sp_joint|Male|70|3%|3%|6 Years": [
    { premium: 50000, db: 1.740018, ltc: 1.740026 },
    { premium: 75000, db: 1.160012, ltc: 1.160017 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.00001, ltc: 1.000012 },
    { premium: 150000, db: 1.000006, ltc: 1.000009 },
    { premium: 200000, db: 1.000009, ltc: 1.00001 },
    { premium: 300000, db: 1.000012, ltc: 1.000014 },
    { premium: 400000, db: 1.000013, ltc: 1.000016 },
  ],
  "sp_joint|Male|70|3%|3%|Lifetime": [
    { premium: 50000, db: 1.839979, ltc: 1 },
    { premium: 75000, db: 1.226653, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|Male|70|5%|5%|2 Years": [
    { premium: 50000, db: 1.64, ltc: 1.639995 },
    { premium: 75000, db: 1.093333, ltc: 1.09333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 0.999996 },
    { premium: 300000, db: 1, ltc: 0.999997 },
  ],
  "sp_joint|Male|70|5%|5%|4 Years": [
    { premium: 50000, db: 1.820003, ltc: 1.820009 },
    { premium: 75000, db: 1.213335, ltc: 1.213339 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1.000002 },
    { premium: 150000, db: 1, ltc: 1.000004 },
    { premium: 200000, db: 1, ltc: 1.000003 },
    { premium: 300000, db: 1, ltc: 1.000002 },
    { premium: 400000, db: 1, ltc: 1.000003 },
  ],
  "sp_joint|Male|70|5%|5%|6 Years": [
    { premium: 50000, db: 2, ltc: 2 },
    { premium: 75000, db: 1.333333, ltc: 1.333333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.892847, ltc: 0.892846 },
    { premium: 150000, db: 0.89285, ltc: 0.892848 },
    { premium: 200000, db: 0.892853, ltc: 0.892852 },
    { premium: 300000, db: 0.892856, ltc: 0.892854 },
    { premium: 400000, db: 0.892858, ltc: 0.892856 },
  ],
  "sp_joint|Male|70|5%|5%|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.854702, ltc: 1 },
    { premium: 150000, db: 0.8547, ltc: 1 },
    { premium: 200000, db: 0.854706, ltc: 1 },
    { premium: 300000, db: 0.854706, ltc: 1 },
    { premium: 400000, db: 0.854711, ltc: 1 },
  ],
  "10pay_single|Female|45|None|None|2 Years": [
    { premium: 5000, db: 0.979868, ltc: 0.979868 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_single|Female|45|None|None|4 Years": [
    { premium: 5000, db: 0.979889, ltc: 0.979889 },
    { premium: 7500, db: 0.999994, ltc: 0.999994 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|45|None|None|6 Years": [
    { premium: 5000, db: 0.979897, ltc: 0.979897 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_single|Female|45|None|None|Lifetime": [
    { premium: 5000, db: 0.979979, ltc: 1 },
    { premium: 7500, db: 1.000002, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 1.000007, ltc: 1 },
    { premium: 20000, db: 1.000007, ltc: 1 },
    { premium: 25000, db: 1.000007, ltc: 1 },
    { premium: 30000, db: 1.000007, ltc: 1 },
  ],
  "10pay_single|Female|45|None|3%|2 Years": [
    { premium: 5000, db: 0.979994, ltc: 0.979993 },
    { premium: 7500, db: 0.999994, ltc: 0.999993 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999996 },
    { premium: 15500, db: 0.999999, ltc: 0.999997 },
    { premium: 20000, db: 1.004268, ltc: 0.991482 },
    { premium: 25000, db: 1.045264, ltc: 0.909637 },
    { premium: 30000, db: 1.072594, ltc: 0.855074 },
  ],
  "10pay_single|Female|45|None|3%|4 Years": [
    { premium: 5000, db: 0.979966, ltc: 0.979967 },
    { premium: 7500, db: 1, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 1.000002, ltc: 1.000004 },
    { premium: 20000, db: 1, ltc: 1.000001 },
    { premium: 25000, db: 1.046865, ltc: 0.910005 },
    { premium: 30000, db: 1.090556, ltc: 0.826108 },
  ],
  "10pay_single|Female|45|None|3%|6 Years": [
    { premium: 5000, db: 0.979926, ltc: 0.979926 },
    { premium: 7500, db: 1, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.089768, ltc: 0.893593 },
  ],
  "10pay_single|Female|45|None|3%|Lifetime": [
    { premium: 5000, db: 0.979924, ltc: 1 },
    { premium: 7500, db: 0.986653, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.073057, ltc: 1 },
  ],
  "10pay_single|Female|45|None|5%|2 Years": [
    { premium: 5000, db: 0.980011, ltc: 0.980012 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 1.008514, ltc: 0.989021 },
    { premium: 20000, db: 1.074443, ltc: 0.903973 },
    { premium: 25000, db: 1.11986, ltc: 0.845384 },
    { premium: 30000, db: 1.150141, ltc: 0.806326 },
  ],
  "10pay_single|Female|45|None|5%|4 Years": [
    { premium: 5000, db: 0.979924, ltc: 0.979921 },
    { premium: 7500, db: 0.999998, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000001 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1.072721, ltc: 0.907078 },
    { premium: 25000, db: 1.147603, ltc: 0.811394 },
    { premium: 30000, db: 1.197522, ltc: 0.747604 },
  ],
  "10pay_single|Female|45|None|5%|6 Years": [
    { premium: 5000, db: 0.980006, ltc: 0.980007 },
    { premium: 7500, db: 0.986659, ltc: 0.986659 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000004, ltc: 1.000005 },
    { premium: 25000, db: 1.137379, ltc: 0.889806 },
    { premium: 30000, db: 1.244411, ltc: 0.803952 },
  ],
  "10pay_single|Female|45|None|5%|Lifetime": [
    { premium: 5000, db: 0.979916, ltc: 1 },
    { premium: 7500, db: 0.986663, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000006, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.107614, ltc: 1 },
    { premium: 30000, db: 1.240136, ltc: 1 },
  ],
  "10pay_single|Female|45|3%|3%|2 Years": [
    { premium: 5000, db: 0.979885, ltc: 0.979884 },
    { premium: 7500, db: 1, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 1, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|45|3%|3%|4 Years": [
    { premium: 5000, db: 0.979991, ltc: 0.979992 },
    { premium: 7500, db: 0.99999, ltc: 0.999992 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999995, ltc: 0.999996 },
    { premium: 15500, db: 0.999996, ltc: 0.999997 },
    { premium: 20000, db: 0.999996, ltc: 0.999998 },
  ],
  "10pay_single|Female|45|3%|3%|6 Years": [
    { premium: 5000, db: 0.979957, ltc: 0.979958 },
    { premium: 7500, db: 0.986655, ltc: 0.986656 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|45|3%|3%|Lifetime": [
    { premium: 5000, db: 0.979954, ltc: 1 },
    { premium: 7500, db: 0.98666, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
  ],
  "10pay_single|Female|45|5%|5%|2 Years": [
    { premium: 5000, db: 0.979977, ltc: 0.97998 },
    { premium: 7500, db: 0.986673, ltc: 0.986674 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1.000002 },
  ],
  "10pay_single|Female|45|5%|5%|4 Years": [
    { premium: 5000, db: 0.980012, ltc: 0.98001 },
    { premium: 7500, db: 0.986623, ltc: 0.986623 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999996 },
    { premium: 15500, db: 0.999998, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 0.999999 },
  ],
  "10pay_single|Female|45|5%|5%|6 Years": [
    { premium: 5000, db: 1.078594, ltc: 1.078596 },
    { premium: 7500, db: 0.996571, ltc: 0.996571 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010115, ltc: 1.010116 },
    { premium: 15500, db: 1.010113, ltc: 1.010112 },
    { premium: 20000, db: 1.010115, ltc: 1.010115 },
    { premium: 25000, db: 1.010115, ltc: 1.010116 },
  ],
  "10pay_single|Female|45|5%|5%|Lifetime": [
    { premium: 5000, db: 1.13859, ltc: 1 },
    { premium: 7500, db: 0.996592, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010117, ltc: 1 },
    { premium: 15500, db: 1.01012, ltc: 1 },
    { premium: 20000, db: 1.01012, ltc: 1 },
    { premium: 25000, db: 1.010118, ltc: 1 },
  ],
  "10pay_single|Female|50|None|None|2 Years": [
    { premium: 5000, db: 0.980004, ltc: 0.980004 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|50|None|None|4 Years": [
    { premium: 5000, db: 0.979969, ltc: 0.979969 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|50|None|None|6 Years": [
    { premium: 5000, db: 0.979886, ltc: 0.979886 },
    { premium: 7500, db: 0.999995, ltc: 0.999995 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_single|Female|50|None|None|Lifetime": [
    { premium: 5000, db: 0.979939, ltc: 1 },
    { premium: 7500, db: 0.986576, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
  ],
  "10pay_single|Female|50|None|3%|2 Years": [
    { premium: 5000, db: 0.979994, ltc: 0.979993 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1.000002 },
    { premium: 25000, db: 1.032217, ltc: 0.947747 },
    { premium: 30000, db: 1.067927, ltc: 0.88982 },
  ],
  "10pay_single|Female|50|None|3%|4 Years": [
    { premium: 5000, db: 0.979991, ltc: 0.97999 },
    { premium: 7500, db: 1.000002, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000004, ltc: 1.000003 },
    { premium: 25000, db: 1.016733, ltc: 0.973932 },
    { premium: 30000, db: 1.075422, ltc: 0.882479 },
  ],
  "10pay_single|Female|50|None|3%|6 Years": [
    { premium: 5000, db: 0.97997, ltc: 0.979971 },
    { premium: 7500, db: 0.986675, ltc: 0.986675 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.029627, ltc: 0.970905 },
  ],
  "10pay_single|Female|50|None|3%|Lifetime": [
    { premium: 5000, db: 0.979955, ltc: 1 },
    { premium: 7500, db: 0.986655, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
  ],
  "10pay_single|Female|50|None|5%|2 Years": [
    { premium: 5000, db: 0.979904, ltc: 0.979908 },
    { premium: 7500, db: 0.999993, ltc: 0.999995 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999999 },
    { premium: 15500, db: 1, ltc: 1.000002 },
    { premium: 20000, db: 1.05556, ltc: 0.942728 },
    { premium: 25000, db: 1.115175, ltc: 0.881281 },
    { premium: 30000, db: 1.154919, ltc: 0.840316 },
  ],
  "10pay_single|Female|50|None|5%|4 Years": [
    { premium: 5000, db: 0.979999, ltc: 0.979998 },
    { premium: 7500, db: 0.986619, ltc: 0.98662 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 1.000002, ltc: 1.000001 },
    { premium: 20000, db: 1.027539, ltc: 0.970971 },
    { premium: 25000, db: 1.126251, ltc: 0.86689 },
    { premium: 30000, db: 1.192061, ltc: 0.797504 },
  ],
  "10pay_single|Female|50|None|5%|6 Years": [
    { premium: 5000, db: 0.987978, ltc: 0.987977 },
    { premium: 7500, db: 0.986615, ltc: 0.986617 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.046729, ltc: 0.969014 },
    { premium: 30000, db: 1.189549, ltc: 0.874312 },
  ],
  "10pay_single|Female|50|None|5%|Lifetime": [
    { premium: 5000, db: 1.066495, ltc: 1 },
    { premium: 7500, db: 0.996638, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010137, ltc: 1 },
    { premium: 15500, db: 1.010133, ltc: 1 },
    { premium: 20000, db: 1.010135, ltc: 1 },
    { premium: 25000, db: 1.010138, ltc: 1 },
    { premium: 30000, db: 1.172624, ltc: 1 },
  ],
  "10pay_single|Female|50|3%|3%|2 Years": [
    { premium: 5000, db: 0.979961, ltc: 0.979964 },
    { premium: 7500, db: 0.986669, ltc: 0.98667 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999995 },
    { premium: 15500, db: 0.999997, ltc: 0.999996 },
    { premium: 20000, db: 0.999996, ltc: 0.999994 },
    { premium: 25000, db: 0.999998, ltc: 0.999997 },
  ],
  "10pay_single|Female|50|3%|3%|4 Years": [
    { premium: 5000, db: 0.979956, ltc: 0.979957 },
    { premium: 7500, db: 0.986629, ltc: 0.986628 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000005, ltc: 1.000004 },
    { premium: 20000, db: 1.000008, ltc: 1.000008 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_single|Female|50|3%|3%|6 Years": [
    { premium: 5000, db: 0.982582, ltc: 0.982582 },
    { premium: 7500, db: 0.986636, ltc: 0.986637 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000004 },
    { premium: 15500, db: 1, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1.000001 },
    { premium: 25000, db: 1.000002, ltc: 1.000003 },
    { premium: 30000, db: 1.000003, ltc: 1.000004 },
  ],
  "10pay_single|Female|50|3%|3%|Lifetime": [
    { premium: 5000, db: 1.051101, ltc: 1 },
    { premium: 7500, db: 0.996585, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010098, ltc: 1 },
    { premium: 15500, db: 1.010096, ltc: 1 },
    { premium: 20000, db: 1.010098, ltc: 1 },
    { premium: 25000, db: 1.010098, ltc: 1 },
    { premium: 30000, db: 1.010098, ltc: 1 },
  ],
  "10pay_single|Female|50|5%|5%|2 Years": [
    { premium: 5000, db: 0.979986, ltc: 0.979988 },
    { premium: 7500, db: 0.986612, ltc: 0.98661 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000007 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000005, ltc: 1.000004 },
  ],
  "10pay_single|Female|50|5%|5%|4 Years": [
    { premium: 5000, db: 1.062885, ltc: 1.062889 },
    { premium: 7500, db: 0.996628, ltc: 0.996628 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01018, ltc: 1.010181 },
    { premium: 15500, db: 1.010178, ltc: 1.010178 },
    { premium: 20000, db: 1.01018, ltc: 1.010181 },
    { premium: 25000, db: 1.01018, ltc: 1.010181 },
  ],
  "10pay_single|Female|50|5%|5%|6 Years": [
    { premium: 5000, db: 1.263282, ltc: 1.263281 },
    { premium: 7500, db: 0.996691, ltc: 0.996691 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010155, ltc: 1.010156 },
    { premium: 15500, db: 1.010158, ltc: 1.010158 },
    { premium: 20000, db: 1.010155, ltc: 1.010155 },
    { premium: 25000, db: 1.01016, ltc: 1.01016 },
    { premium: 30000, db: 1.01016, ltc: 1.01016 },
  ],
  "10pay_single|Female|50|5%|5%|Lifetime": [
    { premium: 5000, db: 1.331798, ltc: 1 },
    { premium: 7500, db: 0.996631, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010169, ltc: 1 },
    { premium: 15500, db: 1.010169, ltc: 1 },
    { premium: 20000, db: 1.010174, ltc: 1 },
    { premium: 25000, db: 1.010171, ltc: 1 },
    { premium: 30000, db: 1.010174, ltc: 1 },
  ],
  "10pay_single|Female|55|None|None|2 Years": [
    { premium: 5000, db: 0.979979, ltc: 0.979979 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_single|Female|55|None|None|4 Years": [
    { premium: 5000, db: 0.979935, ltc: 0.979935 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|55|None|None|6 Years": [
    { premium: 5000, db: 0.979975, ltc: 0.979975 },
    { premium: 7500, db: 0.986639, ltc: 0.986639 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|55|None|None|Lifetime": [
    { premium: 5000, db: 0.979977, ltc: 1 },
    { premium: 7500, db: 0.98671, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|55|None|3%|2 Years": [
    { premium: 5000, db: 0.979976, ltc: 0.979976 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.001963, ltc: 0.997359 },
    { premium: 30000, db: 1.048883, ltc: 0.934133 },
  ],
  "10pay_single|Female|55|None|3%|4 Years": [
    { premium: 5000, db: 0.980007, ltc: 0.980008 },
    { premium: 7500, db: 0.986628, ltc: 0.986629 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000006 },
    { premium: 15500, db: 1.000004, ltc: 1.000005 },
    { premium: 20000, db: 1.000004, ltc: 1.000005 },
    { premium: 25000, db: 1.000007, ltc: 1.000008 },
    { premium: 30000, db: 1.035062, ltc: 0.95364 },
  ],
  "10pay_single|Female|55|None|3%|6 Years": [
    { premium: 5000, db: 0.996185, ltc: 0.996186 },
    { premium: 7500, db: 0.98663, ltc: 0.98663 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000004 },
    { premium: 15500, db: 1.000003, ltc: 1.000004 },
    { premium: 20000, db: 1.000005, ltc: 1.000006 },
    { premium: 25000, db: 1.000006, ltc: 1.000007 },
    { premium: 30000, db: 1.000003, ltc: 1.000004 },
  ],
  "10pay_single|Female|55|None|3%|Lifetime": [
    { premium: 5000, db: 1.0735, ltc: 1 },
    { premium: 7500, db: 0.996573, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010075, ltc: 1 },
    { premium: 15500, db: 1.010072, ltc: 1 },
    { premium: 20000, db: 1.010073, ltc: 1 },
    { premium: 25000, db: 1.010072, ltc: 1 },
    { premium: 30000, db: 1.010075, ltc: 1 },
  ],
  "10pay_single|Female|55|None|5%|2 Years": [
    { premium: 5000, db: 0.97999, ltc: 0.979993 },
    { premium: 7500, db: 0.986693, ltc: 0.986691 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 0.999995, ltc: 0.999996 },
    { premium: 20000, db: 1.011918, ltc: 0.989978 },
    { premium: 25000, db: 1.090514, ltc: 0.923894 },
    { premium: 30000, db: 1.142912, ltc: 0.879838 },
  ],
  "10pay_single|Female|55|None|5%|4 Years": [
    { premium: 5000, db: 0.980016, ltc: 0.980017 },
    { premium: 7500, db: 0.986656, ltc: 0.986656 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999996 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.070916, ltc: 0.936846 },
    { premium: 30000, db: 1.157934, ltc: 0.859351 },
  ],
  "10pay_single|Female|55|None|5%|6 Years": [
    { premium: 5000, db: 1.173894, ltc: 1.173896 },
    { premium: 7500, db: 0.9966, ltc: 0.996601 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010074, ltc: 1.010073 },
    { premium: 15500, db: 1.010079, ltc: 1.010079 },
    { premium: 20000, db: 1.010075, ltc: 1.010075 },
    { premium: 25000, db: 1.010077, ltc: 1.010076 },
    { premium: 30000, db: 1.082568, ltc: 0.969139 },
  ],
  "10pay_single|Female|55|None|5%|Lifetime": [
    { premium: 5000, db: 1.257974, ltc: 1 },
    { premium: 7500, db: 0.996663, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010113, ltc: 1 },
    { premium: 15500, db: 1.010118, ltc: 1 },
    { premium: 20000, db: 1.010113, ltc: 1 },
    { premium: 25000, db: 1.010113, ltc: 1 },
    { premium: 30000, db: 1.014628, ltc: 1 },
  ],
  "10pay_single|Female|55|3%|3%|2 Years": [
    { premium: 5000, db: 0.979991, ltc: 0.979986 },
    { premium: 7500, db: 0.986658, ltc: 0.986656 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000001 },
    { premium: 15500, db: 1.000003, ltc: 1.000001 },
    { premium: 20000, db: 1.000005, ltc: 1.000002 },
    { premium: 25000, db: 1.000005, ltc: 1.000004 },
    { premium: 30000, db: 1.000003, ltc: 1.000001 },
  ],
  "10pay_single|Female|55|3%|3%|4 Years": [
    { premium: 5000, db: 0.981803, ltc: 0.981804 },
    { premium: 7500, db: 0.986638, ltc: 0.986641 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000007, ltc: 1.000008 },
    { premium: 15500, db: 1.000005, ltc: 1.000006 },
    { premium: 20000, db: 1.000005, ltc: 1.000006 },
    { premium: 25000, db: 1.000008, ltc: 1.00001 },
    { premium: 30000, db: 1.000007, ltc: 1.000008 },
  ],
  "10pay_single|Female|55|3%|3%|6 Years": [
    { premium: 5000, db: 1.170695, ltc: 1.170696 },
    { premium: 7500, db: 0.996602, ltc: 0.996601 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010101, ltc: 1.010101 },
    { premium: 15500, db: 1.010103, ltc: 1.010102 },
    { premium: 20000, db: 1.010101, ltc: 1.010101 },
    { premium: 25000, db: 1.010101, ltc: 1.010101 },
    { premium: 30000, db: 1.010101, ltc: 1.010101 },
  ],
  "10pay_single|Female|55|3%|3%|Lifetime": [
    { premium: 5000, db: 1.238006, ltc: 1 },
    { premium: 7500, db: 0.996617, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010117, ltc: 1 },
    { premium: 15500, db: 1.010123, ltc: 1 },
    { premium: 20000, db: 1.010125, ltc: 1 },
    { premium: 25000, db: 1.010125, ltc: 1 },
    { premium: 30000, db: 1.010125, ltc: 1 },
  ],
  "10pay_single|Female|55|5%|5%|2 Years": [
    { premium: 5000, db: 1.14688, ltc: 1.146884 },
    { premium: 7500, db: 0.996694, ltc: 0.996696 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1.010126 },
    { premium: 15500, db: 1.010122, ltc: 1.010122 },
    { premium: 20000, db: 1.010125, ltc: 1.010126 },
    { premium: 25000, db: 1.010125, ltc: 1.010126 },
  ],
  "10pay_single|Female|55|5%|5%|4 Years": [
    { premium: 5000, db: 1.256384, ltc: 1.256388 },
    { premium: 7500, db: 0.996663, ltc: 0.996664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010137, ltc: 1.01014 },
    { premium: 15500, db: 1.010138, ltc: 1.01014 },
    { premium: 20000, db: 1.010137, ltc: 1.010138 },
    { premium: 25000, db: 1.010137, ltc: 1.010139 },
  ],
  "10pay_single|Female|55|5%|5%|6 Years": [
    { premium: 5000, db: 1.503578, ltc: 1.503583 },
    { premium: 7500, db: 1.002385, ltc: 1.002389 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010082, ltc: 1.010084 },
    { premium: 15500, db: 1.010077, ltc: 1.010079 },
    { premium: 20000, db: 1.01008, ltc: 1.010082 },
    { premium: 25000, db: 1.010078, ltc: 1.01008 },
    { premium: 30000, db: 1.010082, ltc: 1.010084 },
  ],
  "10pay_single|Female|55|5%|5%|Lifetime": [
    { premium: 5000, db: 1.587694, ltc: 1 },
    { premium: 7500, db: 1.058462, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003408, ltc: 1 },
    { premium: 15500, db: 1.003599, ltc: 1 },
    { premium: 20000, db: 1.010112, ltc: 1 },
    { premium: 25000, db: 1.010116, ltc: 1 },
    { premium: 30000, db: 1.010118, ltc: 1 },
  ],
  "10pay_single|Female|60|None|None|2 Years": [
    { premium: 5000, db: 0.979975, ltc: 0.979975 },
    { premium: 7500, db: 0.98665, ltc: 0.98665 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|Female|60|None|None|4 Years": [
    { premium: 5000, db: 0.979907, ltc: 0.979907 },
    { premium: 7500, db: 0.98656, ltc: 0.98656 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Female|60|None|None|6 Years": [
    { premium: 5000, db: 0.979952, ltc: 0.979952 },
    { premium: 7500, db: 0.98666, ltc: 0.98666 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|Female|60|None|None|Lifetime": [
    { premium: 5000, db: 1.036993, ltc: 1 },
    { premium: 7500, db: 0.996634, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010133, ltc: 1 },
    { premium: 15500, db: 1.010137, ltc: 1 },
    { premium: 20000, db: 1.010135, ltc: 1 },
    { premium: 25000, db: 1.010136, ltc: 1 },
    { premium: 30000, db: 1.010137, ltc: 1 },
  ],
  "10pay_single|Female|60|None|3%|2 Years": [
    { premium: 5000, db: 0.979982, ltc: 0.979984 },
    { premium: 7500, db: 0.986566, ltc: 0.986568 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.014425, ltc: 0.983336 },
  ],
  "10pay_single|Female|60|None|3%|4 Years": [
    { premium: 5000, db: 0.979948, ltc: 0.979946 },
    { premium: 7500, db: 0.986648, ltc: 0.986645 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000005, ltc: 1.000003 },
    { premium: 20000, db: 1.000005, ltc: 1.000004 },
    { premium: 25000, db: 1.000006, ltc: 1.000005 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
  ],
  "10pay_single|Female|60|None|3%|6 Years": [
    { premium: 5000, db: 1.186092, ltc: 1.186094 },
    { premium: 7500, db: 0.996632, ltc: 0.996631 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010136, ltc: 1.010135 },
    { premium: 15500, db: 1.010136, ltc: 1.010137 },
    { premium: 20000, db: 1.010134, ltc: 1.010134 },
    { premium: 25000, db: 1.010137, ltc: 1.010137 },
    { premium: 30000, db: 1.010136, ltc: 1.010136 },
  ],
  "10pay_single|Female|60|None|3%|Lifetime": [
    { premium: 5000, db: 1.270487, ltc: 1 },
    { premium: 7500, db: 0.996617, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010099, ltc: 1 },
    { premium: 15500, db: 1.010101, ltc: 1 },
    { premium: 20000, db: 1.010105, ltc: 1 },
    { premium: 25000, db: 1.010104, ltc: 1 },
    { premium: 30000, db: 1.010103, ltc: 1 },
  ],
  "10pay_single|Female|60|None|5%|2 Years": [
    { premium: 5000, db: 0.979979, ltc: 0.979984 },
    { premium: 7500, db: 0.986668, ltc: 0.986671 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000005, ltc: 1.000004 },
    { premium: 25000, db: 1.044301, ltc: 0.968767 },
    { premium: 30000, db: 1.112193, ltc: 0.92089 },
  ],
  "10pay_single|Female|60|None|5%|4 Years": [
    { premium: 5000, db: 1.080598, ltc: 1.080599 },
    { premium: 7500, db: 0.996579, ltc: 0.996579 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010098, ltc: 1.010097 },
    { premium: 15500, db: 1.010101, ltc: 1.0101 },
    { premium: 20000, db: 1.010096, ltc: 1.010095 },
    { premium: 25000, db: 1.0101, ltc: 1.010098 },
    { premium: 30000, db: 1.105242, ltc: 0.935685 },
  ],
  "10pay_single|Female|60|None|5%|6 Years": [
    { premium: 5000, db: 1.382497, ltc: 1.382499 },
    { premium: 7500, db: 0.996678, ltc: 0.99668 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01016, ltc: 1.010161 },
    { premium: 15500, db: 1.010152, ltc: 1.010153 },
    { premium: 20000, db: 1.01016, ltc: 1.010162 },
    { premium: 25000, db: 1.01016, ltc: 1.010161 },
    { premium: 30000, db: 1.01016, ltc: 1.010161 },
  ],
  "10pay_single|Female|60|None|5%|Lifetime": [
    { premium: 5000, db: 1.476192, ltc: 1 },
    { premium: 7500, db: 0.996625, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010135, ltc: 1 },
    { premium: 15500, db: 1.010137, ltc: 1 },
    { premium: 20000, db: 1.010133, ltc: 1 },
    { premium: 25000, db: 1.010137, ltc: 1 },
    { premium: 30000, db: 1.010135, ltc: 1 },
  ],
  "10pay_single|Female|60|3%|3%|2 Years": [
    { premium: 5000, db: 1.061492, ltc: 1.061497 },
    { premium: 7500, db: 0.996703, ltc: 0.996704 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010181, ltc: 1.010183 },
    { premium: 15500, db: 1.01018, ltc: 1.010182 },
    { premium: 20000, db: 1.010183, ltc: 1.010185 },
    { premium: 25000, db: 1.010184, ltc: 1.010187 },
    { premium: 30000, db: 1.010185, ltc: 1.010186 },
  ],
  "10pay_single|Female|60|3%|3%|4 Years": [
    { premium: 5000, db: 1.162896, ltc: 1.162898 },
    { premium: 7500, db: 0.996659, ltc: 0.996657 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01017, ltc: 1.010169 },
    { premium: 15500, db: 1.01017, ltc: 1.010168 },
    { premium: 20000, db: 1.010168, ltc: 1.010167 },
    { premium: 25000, db: 1.010171, ltc: 1.01017 },
    { premium: 30000, db: 1.01017, ltc: 1.010169 },
  ],
  "10pay_single|Female|60|3%|3%|6 Years": [
    { premium: 5000, db: 1.386503, ltc: 1.386501 },
    { premium: 7500, db: 0.996627, ltc: 0.996625 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010129, ltc: 1.01013 },
    { premium: 15500, db: 1.010127, ltc: 1.010127 },
    { premium: 20000, db: 1.010134, ltc: 1.010133 },
    { premium: 25000, db: 1.010131, ltc: 1.010132 },
    { premium: 30000, db: 1.010134, ltc: 1.010134 },
  ],
  "10pay_single|Female|60|3%|3%|Lifetime": [
    { premium: 5000, db: 1.470981, ltc: 1 },
    { premium: 7500, db: 0.996676, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010158, ltc: 1 },
    { premium: 15500, db: 1.010168, ltc: 1 },
    { premium: 20000, db: 1.010163, ltc: 1 },
    { premium: 25000, db: 1.010166, ltc: 1 },
    { premium: 30000, db: 1.010163, ltc: 1 },
  ],
  "10pay_single|Female|60|5%|5%|2 Years": [
    { premium: 5000, db: 1.345503, ltc: 1.345505 },
    { premium: 7500, db: 0.996655, ltc: 0.99666 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010143, ltc: 1.010143 },
    { premium: 15500, db: 1.010138, ltc: 1.010138 },
    { premium: 20000, db: 1.010136, ltc: 1.010137 },
    { premium: 25000, db: 1.010143, ltc: 1.010146 },
    { premium: 30000, db: 1.010143, ltc: 1.010145 },
  ],
  "10pay_single|Female|60|5%|5%|4 Years": [
    { premium: 5000, db: 1.47678, ltc: 1.476781 },
    { premium: 7500, db: 0.996609, ltc: 0.996608 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1.010125 },
    { premium: 15500, db: 1.01012, ltc: 1.01012 },
    { premium: 20000, db: 1.010122, ltc: 1.010121 },
    { premium: 25000, db: 1.010127, ltc: 1.010125 },
    { premium: 30000, db: 1.010125, ltc: 1.010123 },
  ],
  "10pay_single|Female|60|5%|5%|6 Years": [
    { premium: 5000, db: 1.778588, ltc: 1.778593 },
    { premium: 7500, db: 1.185725, ltc: 1.185729 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003332, ltc: 1.003332 },
    { premium: 15500, db: 1.003551, ltc: 1.003552 },
    { premium: 20000, db: 1.01011, ltc: 1.010111 },
    { premium: 25000, db: 1.010116, ltc: 1.010116 },
    { premium: 30000, db: 1.010113, ltc: 1.010114 },
  ],
  "10pay_single|Female|60|5%|5%|Lifetime": [
    { premium: 5000, db: 1.872391, ltc: 1 },
    { premium: 7500, db: 1.24826, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003376, ltc: 1 },
    { premium: 15500, db: 1.003586, ltc: 1 },
    { premium: 20000, db: 1.010138, ltc: 1 },
    { premium: 25000, db: 1.010144, ltc: 1 },
    { premium: 30000, db: 1.010141, ltc: 1 },
  ],
  "10pay_single|Female|65|None|None|2 Years": [
    { premium: 5000, db: 0.97996, ltc: 0.97996 },
    { premium: 7500, db: 0.986698, ltc: 0.986698 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000006 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|Female|65|None|None|4 Years": [
    { premium: 5000, db: 0.980054, ltc: 0.980054 },
    { premium: 7500, db: 0.986655, ltc: 0.986655 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000006, ltc: 1.000006 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000006, ltc: 1.000006 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
  ],
  "10pay_single|Female|65|None|None|6 Years": [
    { premium: 5000, db: 1.138405, ltc: 1.138405 },
    { premium: 7500, db: 0.996669, ltc: 0.996669 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010115, ltc: 1.010115 },
    { premium: 15500, db: 1.010112, ltc: 1.010112 },
    { premium: 20000, db: 1.010113, ltc: 1.010113 },
    { premium: 25000, db: 1.010116, ltc: 1.010116 },
    { premium: 30000, db: 1.010115, ltc: 1.010115 },
  ],
  "10pay_single|Female|65|None|None|Lifetime": [
    { premium: 5000, db: 1.208895, ltc: 1 },
    { premium: 7500, db: 0.996616, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010112, ltc: 1 },
    { premium: 15500, db: 1.010113, ltc: 1 },
    { premium: 20000, db: 1.010116, ltc: 1 },
    { premium: 25000, db: 1.010114, ltc: 1 },
    { premium: 30000, db: 1.010116, ltc: 1 },
  ],
  "10pay_single|Female|65|None|3%|2 Years": [
    { premium: 5000, db: 0.980018, ltc: 0.980019 },
    { premium: 7500, db: 0.986659, ltc: 0.986659 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999998 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000004, ltc: 1.000003 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|Female|65|None|3%|4 Years": [
    { premium: 5000, db: 1.1087, ltc: 1.108705 },
    { premium: 7500, db: 0.99666, ltc: 0.996661 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01011, ltc: 1.010111 },
    { premium: 15500, db: 1.010108, ltc: 1.01011 },
    { premium: 20000, db: 1.01011, ltc: 1.010112 },
    { premium: 25000, db: 1.010114, ltc: 1.010116 },
    { premium: 30000, db: 1.010113, ltc: 1.010116 },
  ],
  "10pay_single|Female|65|None|3%|6 Years": [
    { premium: 5000, db: 1.38671, ltc: 1.38671 },
    { premium: 7500, db: 0.996696, ltc: 0.996693 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1.010126 },
    { premium: 15500, db: 1.010126, ltc: 1.010124 },
    { premium: 20000, db: 1.010128, ltc: 1.010128 },
    { premium: 25000, db: 1.010129, ltc: 1.010129 },
    { premium: 30000, db: 1.01013, ltc: 1.010129 },
  ],
  "10pay_single|Female|65|None|3%|Lifetime": [
    { premium: 5000, db: 1.487906, ltc: 1 },
    { premium: 7500, db: 0.996638, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010116, ltc: 1 },
    { premium: 15500, db: 1.010115, ltc: 1 },
    { premium: 20000, db: 1.010123, ltc: 1 },
    { premium: 25000, db: 1.010122, ltc: 1 },
    { premium: 30000, db: 1.010121, ltc: 1 },
  ],
  "10pay_single|Female|65|None|5%|2 Years": [
    { premium: 5000, db: 1.084808, ltc: 1.084808 },
    { premium: 7500, db: 0.996602, ltc: 0.996601 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010057, ltc: 1.010059 },
    { premium: 15500, db: 1.010059, ltc: 1.010058 },
    { premium: 20000, db: 1.010059, ltc: 1.010058 },
    { premium: 25000, db: 1.01006, ltc: 1.01006 },
    { premium: 30000, db: 1.079867, ltc: 0.967255 },
  ],
  "10pay_single|Female|65|None|5%|4 Years": [
    { premium: 5000, db: 1.251906, ltc: 1.251905 },
    { premium: 7500, db: 0.996658, ltc: 0.996659 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010085, ltc: 1.010086 },
    { premium: 15500, db: 1.010086, ltc: 1.010087 },
    { premium: 20000, db: 1.010089, ltc: 1.010091 },
    { premium: 25000, db: 1.010091, ltc: 1.010093 },
    { premium: 30000, db: 1.016372, ltc: 1.005811 },
  ],
  "10pay_single|Female|65|None|5%|6 Years": [
    { premium: 5000, db: 1.609689, ltc: 1.609684 },
    { premium: 7500, db: 1.073126, ltc: 1.073123 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003364, ltc: 1.003363 },
    { premium: 15500, db: 1.003611, ltc: 1.003609 },
    { premium: 20000, db: 1.010099, ltc: 1.010098 },
    { premium: 25000, db: 1.010104, ltc: 1.010103 },
    { premium: 30000, db: 1.010102, ltc: 1.010101 },
  ],
  "10pay_single|Female|65|None|5%|Lifetime": [
    { premium: 5000, db: 1.709709, ltc: 1 },
    { premium: 7500, db: 1.139806, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00335, ltc: 1 },
    { premium: 15500, db: 1.003584, ltc: 1 },
    { premium: 20000, db: 1.010103, ltc: 1 },
    { premium: 25000, db: 1.010099, ltc: 1 },
    { premium: 30000, db: 1.010103, ltc: 1 },
  ],
  "10pay_single|Female|65|3%|3%|2 Years": [
    { premium: 5000, db: 1.214302, ltc: 1.214304 },
    { premium: 7500, db: 0.996637, ltc: 0.996636 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010073, ltc: 1.01007 },
    { premium: 15500, db: 1.010067, ltc: 1.010065 },
    { premium: 20000, db: 1.010071, ltc: 1.010067 },
    { premium: 25000, db: 1.01007, ltc: 1.010068 },
    { premium: 30000, db: 1.010073, ltc: 1.01007 },
  ],
  "10pay_single|Female|65|3%|3%|4 Years": [
    { premium: 5000, db: 1.337389, ltc: 1.337385 },
    { premium: 7500, db: 0.996635, ltc: 0.996632 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010113, ltc: 1.01011 },
    { premium: 15500, db: 1.010119, ltc: 1.010116 },
    { premium: 20000, db: 1.010115, ltc: 1.010112 },
    { premium: 25000, db: 1.010116, ltc: 1.010114 },
    { premium: 30000, db: 1.010117, ltc: 1.010115 },
  ],
  "10pay_single|Female|65|3%|3%|6 Years": [
    { premium: 5000, db: 1.615103, ltc: 1.615104 },
    { premium: 7500, db: 1.076735, ltc: 1.076736 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003354, ltc: 1.003352 },
    { premium: 15500, db: 1.003546, ltc: 1.003546 },
    { premium: 20000, db: 1.010069, ltc: 1.010068 },
    { premium: 25000, db: 1.010074, ltc: 1.010073 },
    { premium: 30000, db: 1.010072, ltc: 1.010072 },
  ],
  "10pay_single|Female|65|3%|3%|Lifetime": [
    { premium: 5000, db: 1.716414, ltc: 1 },
    { premium: 7500, db: 1.144276, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003387, ltc: 1 },
    { premium: 15500, db: 1.003627, ltc: 1 },
    { premium: 20000, db: 1.010126, ltc: 1 },
    { premium: 25000, db: 1.010126, ltc: 1 },
    { premium: 30000, db: 1.010126, ltc: 1 },
  ],
  "10pay_single|Female|65|5%|5%|2 Years": [
    { premium: 5000, db: 1.534708, ltc: 1.53471 },
    { premium: 7500, db: 1.023139, ltc: 1.02314 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003335, ltc: 1.003337 },
    { premium: 15500, db: 1.010072, ltc: 1.010071 },
    { premium: 20000, db: 1.010066, ltc: 1.010064 },
    { premium: 25000, db: 1.010072, ltc: 1.010073 },
    { premium: 30000, db: 1.010071, ltc: 1.01007 },
  ],
  "10pay_single|Female|65|5%|5%|4 Years": [
    { premium: 5000, db: 1.701811, ltc: 1.701813 },
    { premium: 7500, db: 1.13454, ltc: 1.134542 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003358, ltc: 1.003359 },
    { premium: 15500, db: 1.003596, ltc: 1.003598 },
    { premium: 20000, db: 1.010091, ltc: 1.010092 },
    { premium: 25000, db: 1.010094, ltc: 1.010095 },
    { premium: 30000, db: 1.010091, ltc: 1.010092 },
  ],
  "10pay_single|Female|65|5%|5%|6 Years": [
    { premium: 5000, db: 2, ltc: 2 },
    { premium: 7500, db: 1.333333, ltc: 1.333333 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.97433, ltc: 0.974331 },
    { premium: 15500, db: 0.97456, ltc: 0.974559 },
    { premium: 20000, db: 0.975993, ltc: 0.975993 },
    { premium: 25000, db: 0.980879, ltc: 0.98088 },
    { premium: 30000, db: 0.980876, ltc: 0.980876 },
  ],
  "10pay_single|Female|65|5%|5%|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.92923, ltc: 1 },
    { premium: 15500, db: 0.929405, ltc: 1 },
    { premium: 20000, db: 0.93079, ltc: 1 },
    { premium: 25000, db: 0.935453, ltc: 1 },
    { premium: 30000, db: 0.935449, ltc: 1 },
  ],
  "10pay_single|Female|70|None|None|2 Years": [
    { premium: 5000, db: 1.132297, ltc: 1.132297 },
    { premium: 7500, db: 0.996645, ltc: 0.996645 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010079, ltc: 1.010079 },
    { premium: 15500, db: 1.010082, ltc: 1.010082 },
    { premium: 20000, db: 1.01008, ltc: 1.01008 },
    { premium: 25000, db: 1.010082, ltc: 1.010082 },
    { premium: 30000, db: 1.010082, ltc: 1.010082 },
  ],
  "10pay_single|Female|70|None|None|4 Years": [
    { premium: 5000, db: 1.230504, ltc: 1.230504 },
    { premium: 7500, db: 0.996601, ltc: 0.996601 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.0101, ltc: 1.0101 },
    { premium: 15500, db: 1.010105, ltc: 1.010105 },
    { premium: 20000, db: 1.010106, ltc: 1.010106 },
    { premium: 25000, db: 1.010105, ltc: 1.010105 },
    { premium: 30000, db: 1.010104, ltc: 1.010104 },
  ],
  "10pay_single|Female|70|None|None|6 Years": [
    { premium: 5000, db: 1.448274, ltc: 1.448274 },
    { premium: 7500, db: 0.996621, ltc: 0.996621 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010108, ltc: 1.010108 },
    { premium: 15500, db: 1.010111, ltc: 1.010111 },
    { premium: 20000, db: 1.010108, ltc: 1.010108 },
    { premium: 25000, db: 1.010114, ltc: 1.010114 },
    { premium: 30000, db: 1.010113, ltc: 1.010113 },
  ],
  "10pay_single|Female|70|None|None|Lifetime": [
    { premium: 5000, db: 1.532892, ltc: 1 },
    { premium: 7500, db: 1.021928, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003341, ltc: 1 },
    { premium: 15500, db: 1.010084, ltc: 1 },
    { premium: 20000, db: 1.010085, ltc: 1 },
    { premium: 25000, db: 1.010085, ltc: 1 },
    { premium: 30000, db: 1.010085, ltc: 1 },
  ],
  "10pay_single|Female|70|None|3%|2 Years": [
    { premium: 5000, db: 1.244801, ltc: 1.244795 },
    { premium: 7500, db: 0.996561, ltc: 0.99656 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010061, ltc: 1.01006 },
    { premium: 15500, db: 1.010062, ltc: 1.010063 },
    { premium: 20000, db: 1.010063, ltc: 1.010062 },
    { premium: 25000, db: 1.010064, ltc: 1.010063 },
    { premium: 30000, db: 1.010061, ltc: 1.01006 },
  ],
  "10pay_single|Female|70|None|3%|4 Years": [
    { premium: 5000, db: 1.393483, ltc: 1.393487 },
    { premium: 7500, db: 0.996624, ltc: 0.996626 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010073, ltc: 1.010074 },
    { premium: 15500, db: 1.010073, ltc: 1.010075 },
    { premium: 20000, db: 1.01008, ltc: 1.010082 },
    { premium: 25000, db: 1.010078, ltc: 1.010079 },
    { premium: 30000, db: 1.010078, ltc: 1.010079 },
  ],
  "10pay_single|Female|70|None|3%|6 Years": [
    { premium: 5000, db: 1.716571, ltc: 1.716573 },
    { premium: 7500, db: 1.144381, ltc: 1.144382 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003381, ltc: 1.003381 },
    { premium: 15500, db: 1.003613, ltc: 1.003612 },
    { premium: 20000, db: 1.010118, ltc: 1.010117 },
    { premium: 25000, db: 1.010116, ltc: 1.010115 },
    { premium: 30000, db: 1.01012, ltc: 1.010119 },
  ],
  "10pay_single|Female|70|None|3%|Lifetime": [
    { premium: 5000, db: 1.833902, ltc: 1 },
    { premium: 7500, db: 1.222601, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003337, ltc: 1 },
    { premium: 15500, db: 1.003565, ltc: 1 },
    { premium: 20000, db: 1.010085, ltc: 1 },
    { premium: 25000, db: 1.010085, ltc: 1 },
    { premium: 30000, db: 1.010085, ltc: 1 },
  ],
  "10pay_single|Female|70|None|5%|2 Years": [
    { premium: 5000, db: 1.351101, ltc: 1.351102 },
    { premium: 7500, db: 0.996605, ltc: 0.996603 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010095, ltc: 1.010094 },
    { premium: 15500, db: 1.010096, ltc: 1.010094 },
    { premium: 20000, db: 1.010097, ltc: 1.010096 },
    { premium: 25000, db: 1.010093, ltc: 1.010092 },
    { premium: 30000, db: 1.010095, ltc: 1.010094 },
  ],
  "10pay_single|Female|70|None|5%|4 Years": [
    { premium: 5000, db: 1.542797, ltc: 1.542797 },
    { premium: 7500, db: 1.028531, ltc: 1.028531 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003388, ltc: 1.003386 },
    { premium: 15500, db: 1.010092, ltc: 1.010089 },
    { premium: 20000, db: 1.010096, ltc: 1.010093 },
    { premium: 25000, db: 1.010097, ltc: 1.010095 },
    { premium: 30000, db: 1.010093, ltc: 1.010092 },
  ],
  "10pay_single|Female|70|None|5%|6 Years": [
    { premium: 5000, db: 1.951074, ltc: 1.951074 },
    { premium: 7500, db: 1.300716, ltc: 1.300716 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003349, ltc: 1.003349 },
    { premium: 15500, db: 1.003593, ltc: 1.003592 },
    { premium: 20000, db: 1.010095, ltc: 1.010096 },
    { premium: 25000, db: 1.010093, ltc: 1.010092 },
    { premium: 30000, db: 1.010092, ltc: 1.010092 },
  ],
  "10pay_single|Female|70|None|5%|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.967398, ltc: 1 },
    { premium: 15500, db: 0.967632, ltc: 1 },
    { premium: 20000, db: 0.969044, ltc: 1 },
    { premium: 25000, db: 0.973904, ltc: 1 },
    { premium: 30000, db: 0.973904, ltc: 1 },
  ],
  "10pay_single|Female|70|3%|3%|2 Years": [
    { premium: 5000, db: 1.485894, ltc: 1.485903 },
    { premium: 7500, db: 0.996638, ltc: 0.996643 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010127, ltc: 1.010127 },
    { premium: 15500, db: 1.010129, ltc: 1.010134 },
    { premium: 20000, db: 1.010124, ltc: 1.010127 },
    { premium: 25000, db: 1.010129, ltc: 1.010133 },
    { premium: 30000, db: 1.010127, ltc: 1.01013 },
  ],
  "10pay_single|Female|70|3%|3%|4 Years": [
    { premium: 5000, db: 1.634317, ltc: 1.634313 },
    { premium: 7500, db: 1.089544, ltc: 1.089542 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003328, ltc: 1.003325 },
    { premium: 15500, db: 1.003571, ltc: 1.00357 },
    { premium: 20000, db: 1.010083, ltc: 1.01008 },
    { premium: 25000, db: 1.010083, ltc: 1.010081 },
    { premium: 30000, db: 1.010088, ltc: 1.010087 },
  ],
  "10pay_single|Female|70|3%|3%|6 Years": [
    { premium: 5000, db: 1.957411, ltc: 1.957406 },
    { premium: 7500, db: 1.304941, ltc: 1.304937 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003386, ltc: 1.003385 },
    { premium: 15500, db: 1.003597, ltc: 1.003596 },
    { premium: 20000, db: 1.010119, ltc: 1.010118 },
    { premium: 25000, db: 1.010119, ltc: 1.010118 },
    { premium: 30000, db: 1.010119, ltc: 1.010119 },
  ],
  "10pay_single|Female|70|3%|3%|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.967118, ltc: 1 },
    { premium: 15500, db: 0.967348, ltc: 1 },
    { premium: 20000, db: 0.968754, ltc: 1 },
    { premium: 25000, db: 0.973616, ltc: 1 },
    { premium: 30000, db: 0.973617, ltc: 1 },
  ],
  "10pay_single|Female|70|5%|5%|2 Years": [
    { premium: 5000, db: 1.816194, ltc: 1.816207 },
    { premium: 7500, db: 1.210796, ltc: 1.210805 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003372, ltc: 1.003373 },
    { premium: 15500, db: 1.003597, ltc: 1.003602 },
    { premium: 20000, db: 1.010124, ltc: 1.010128 },
    { premium: 25000, db: 1.010122, ltc: 1.010127 },
    { premium: 30000, db: 1.010121, ltc: 1.010123 },
  ],
  "10pay_single|Female|70|5%|5%|4 Years": [
    { premium: 5000, db: 2, ltc: 2 },
    { premium: 7500, db: 1.333333, ltc: 1.333333 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.99946, ltc: 0.999459 },
    { premium: 15500, db: 0.999654, ltc: 0.999656 },
    { premium: 20000, db: 1.006139, ltc: 1.006142 },
    { premium: 25000, db: 1.006147, ltc: 1.006148 },
    { premium: 30000, db: 1.006146, ltc: 1.006146 },
  ],
  "10pay_single|Female|70|5%|5%|6 Years": [
    { premium: 5000, db: 2, ltc: 2 },
    { premium: 7500, db: 1.333333, ltc: 1.333333 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.83054, ltc: 0.83054 },
    { premium: 15500, db: 0.830739, ltc: 0.830741 },
    { premium: 20000, db: 0.83195, ltc: 0.83195 },
    { premium: 25000, db: 0.836124, ltc: 0.836125 },
    { premium: 30000, db: 0.83612, ltc: 0.836121 },
  ],
  "10pay_single|Female|70|5%|5%|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.790241, ltc: 1 },
    { premium: 15500, db: 0.790424, ltc: 1 },
    { premium: 20000, db: 0.791591, ltc: 1 },
    { premium: 25000, db: 0.792377, ltc: 1 },
    { premium: 30000, db: 0.79556, ltc: 1 },
  ],
  "10pay_single|Male|45|None|None|2 Years": [
    { premium: 5000, db: 0.980067, ltc: 0.980067 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_single|Male|45|None|None|4 Years": [
    { premium: 5000, db: 0.979929, ltc: 0.979929 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|45|None|None|6 Years": [
    { premium: 5000, db: 0.97998, ltc: 0.97998 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_single|Male|45|None|None|Lifetime": [
    { premium: 5000, db: 0.979981, ltc: 1 },
    { premium: 7500, db: 0.999998, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
  ],
  "10pay_single|Male|45|None|3%|2 Years": [
    { premium: 5000, db: 0.980039, ltc: 0.98004 },
    { premium: 7500, db: 1, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 1.000001, ltc: 1.000002 },
    { premium: 20000, db: 1.01029, ltc: 0.948391 },
    { premium: 25000, db: 1.027094, ltc: 0.864096 },
    { premium: 30000, db: 1.038297, ltc: 0.8079 },
  ],
  "10pay_single|Male|45|None|3%|4 Years": [
    { premium: 5000, db: 0.979983, ltc: 0.979982 },
    { premium: 7500, db: 1, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000003 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.010362, ltc: 0.948975 },
    { premium: 25000, db: 1.034622, ltc: 0.829487 },
    { premium: 30000, db: 1.050795, ltc: 0.749828 },
  ],
  "10pay_single|Male|45|None|3%|6 Years": [
    { premium: 5000, db: 0.979942, ltc: 0.979941 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999997 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1.046468, ltc: 0.866612 },
    { premium: 30000, db: 1.080408, ltc: 0.769196 },
  ],
  "10pay_single|Male|45|None|3%|Lifetime": [
    { premium: 5000, db: 0.98008, ltc: 1 },
    { premium: 7500, db: 0.999996, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.046589, ltc: 1 },
    { premium: 30000, db: 1.085324, ltc: 1 },
  ],
  "10pay_single|Male|45|None|5%|2 Years": [
    { premium: 5000, db: 0.980029, ltc: 0.980028 },
    { premium: 7500, db: 1.000002, ltc: 1.000003 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.016185, ltc: 0.943682 },
    { premium: 15500, db: 1.019997, ltc: 0.930419 },
    { premium: 20000, db: 1.045724, ltc: 0.840896 },
    { premium: 25000, db: 1.063448, ltc: 0.779225 },
    { premium: 30000, db: 1.075263, ltc: 0.73811 },
  ],
  "10pay_single|Male|45|None|5%|4 Years": [
    { premium: 5000, db: 0.980025, ltc: 0.980027 },
    { premium: 7500, db: 1, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01505, ltc: 0.94703 },
    { premium: 15500, db: 1.020517, ltc: 0.927799 },
    { premium: 20000, db: 1.057409, ltc: 0.797987 },
    { premium: 25000, db: 1.082824, ltc: 0.708561 },
    { premium: 30000, db: 1.099767, ltc: 0.648944 },
  ],
  "10pay_single|Male|45|None|5%|6 Years": [
    { premium: 5000, db: 0.979946, ltc: 0.979945 },
    { premium: 7500, db: 1.000002, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000001 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.075248, ltc: 0.846617 },
    { premium: 25000, db: 1.1304, ltc: 0.734183 },
    { premium: 30000, db: 1.16717, ltc: 0.659228 },
  ],
  "10pay_single|Male|45|None|5%|Lifetime": [
    { premium: 5000, db: 0.98001, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999996, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 1 },
    { premium: 20000, db: 1.074884, ltc: 1 },
    { premium: 25000, db: 1.137126, ltc: 1 },
    { premium: 30000, db: 1.178621, ltc: 1 },
  ],
  "10pay_single|Male|45|3%|3%|2 Years": [
    { premium: 5000, db: 0.980071, ltc: 0.980071 },
    { premium: 7500, db: 0.999996, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 1.000001, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1.000001 },
  ],
  "10pay_single|Male|45|3%|3%|4 Years": [
    { premium: 5000, db: 0.980014, ltc: 0.980013 },
    { premium: 7500, db: 1, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 1.000002, ltc: 1.000003 },
    { premium: 20000, db: 1, ltc: 1.000001 },
  ],
  "10pay_single|Male|45|3%|3%|6 Years": [
    { premium: 5000, db: 0.979981, ltc: 0.979982 },
    { premium: 7500, db: 1, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|45|3%|3%|Lifetime": [
    { premium: 5000, db: 0.979959, ltc: 1 },
    { premium: 7500, db: 1.000002, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
  ],
  "10pay_single|Male|45|5%|5%|2 Years": [
    { premium: 5000, db: 0.979951, ltc: 0.979951 },
    { premium: 7500, db: 0.999998, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000004 },
  ],
  "10pay_single|Male|45|5%|5%|4 Years": [
    { premium: 5000, db: 0.979951, ltc: 0.97995 },
    { premium: 7500, db: 0.999995, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 1.000001, ltc: 1.000002 },
  ],
  "10pay_single|Male|45|5%|5%|6 Years": [
    { premium: 5000, db: 0.980002, ltc: 0.980003 },
    { premium: 7500, db: 0.98671, ltc: 0.98671 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000006 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_single|Male|45|5%|5%|Lifetime": [
    { premium: 5000, db: 0.979947, ltc: 1 },
    { premium: 7500, db: 0.986626, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
  ],
  "10pay_single|Male|50|None|None|2 Years": [
    { premium: 5000, db: 0.97997, ltc: 0.97997 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|50|None|None|4 Years": [
    { premium: 5000, db: 0.979943, ltc: 0.979943 },
    { premium: 7500, db: 0.999994, ltc: 0.999994 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|50|None|None|6 Years": [
    { premium: 5000, db: 0.979916, ltc: 0.979916 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_single|Male|50|None|None|Lifetime": [
    { premium: 5000, db: 0.979985, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000004, ltc: 1 },
  ],
  "10pay_single|Male|50|None|3%|2 Years": [
    { premium: 5000, db: 0.979933, ltc: 0.979932 },
    { premium: 7500, db: 1.000002, ltc: 0.999999 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999997 },
    { premium: 15500, db: 1.000001, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1.021247, ltc: 0.907062 },
    { premium: 30000, db: 1.035502, ltc: 0.844705 },
  ],
  "10pay_single|Male|50|None|3%|4 Years": [
    { premium: 5000, db: 0.979856, ltc: 0.979856 },
    { premium: 7500, db: 1.000004, ltc: 1.000004 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.025, ltc: 0.89089 },
    { premium: 30000, db: 1.04541, ltc: 0.801815 },
  ],
  "10pay_single|Male|50|None|3%|6 Years": [
    { premium: 5000, db: 0.979969, ltc: 0.979969 },
    { premium: 7500, db: 0.999998, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.020439, ltc: 0.948367 },
    { premium: 30000, db: 1.063922, ltc: 0.8385 },
  ],
  "10pay_single|Male|50|None|3%|Lifetime": [
    { premium: 5000, db: 0.979975, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.016355, ltc: 1 },
    { premium: 30000, db: 1.06504, ltc: 1 },
  ],
  "10pay_single|Male|50|None|5%|2 Years": [
    { premium: 5000, db: 0.979909, ltc: 0.979908 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.001281, ltc: 0.996105 },
    { premium: 15500, db: 1.006103, ltc: 0.981401 },
    { premium: 20000, db: 1.038657, ltc: 0.882144 },
    { premium: 25000, db: 1.061085, ltc: 0.813768 },
    { premium: 30000, db: 1.076035, ltc: 0.768183 },
  ],
  "10pay_single|Male|50|None|5%|4 Years": [
    { premium: 5000, db: 0.979951, ltc: 0.97995 },
    { premium: 7500, db: 1.000004, ltc: 1.000004 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 0.999999 },
    { premium: 20000, db: 1.045569, ltc: 0.858751 },
    { premium: 25000, db: 1.077906, ltc: 0.758521 },
    { premium: 30000, db: 1.099461, ltc: 0.6917 },
  ],
  "10pay_single|Male|50|None|5%|6 Years": [
    { premium: 5000, db: 0.979907, ltc: 0.979905 },
    { premium: 7500, db: 1, ltc: 1.000001 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.040276, ltc: 0.926125 },
    { premium: 25000, db: 1.109438, ltc: 0.799266 },
    { premium: 30000, db: 1.155543, ltc: 0.714694 },
  ],
  "10pay_single|Male|50|None|5%|Lifetime": [
    { premium: 5000, db: 0.97995, ltc: 1 },
    { premium: 7500, db: 0.986634, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1.03356, ltc: 1 },
    { premium: 25000, db: 1.111935, ltc: 1 },
    { premium: 30000, db: 1.164187, ltc: 1 },
  ],
  "10pay_single|Male|50|3%|3%|2 Years": [
    { premium: 5000, db: 0.979915, ltc: 0.979918 },
    { premium: 7500, db: 0.999998, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999999 },
    { premium: 15500, db: 1.000001, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1.000002 },
  ],
  "10pay_single|Male|50|3%|3%|4 Years": [
    { premium: 5000, db: 0.979991, ltc: 0.979994 },
    { premium: 7500, db: 0.999998, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000003 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_single|Male|50|3%|3%|6 Years": [
    { premium: 5000, db: 0.979959, ltc: 0.979959 },
    { premium: 7500, db: 0.986541, ltc: 0.98654 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999996, ltc: 0.999997 },
    { premium: 20000, db: 0.999996, ltc: 0.999997 },
    { premium: 25000, db: 0.999997, ltc: 0.999997 },
  ],
  "10pay_single|Male|50|3%|3%|Lifetime": [
    { premium: 5000, db: 0.979962, ltc: 1 },
    { premium: 7500, db: 0.986668, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1 },
    { premium: 15500, db: 1.000005, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
  ],
  "10pay_single|Male|50|5%|5%|2 Years": [
    { premium: 5000, db: 0.979987, ltc: 0.979988 },
    { premium: 7500, db: 0.986566, ltc: 0.986567 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000004 },
    { premium: 15500, db: 1.000005, ltc: 1.000007 },
  ],
  "10pay_single|Male|50|5%|5%|4 Years": [
    { premium: 5000, db: 0.979888, ltc: 0.979888 },
    { premium: 7500, db: 0.986586, ltc: 0.986586 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 1.000001, ltc: 0.999999 },
  ],
  "10pay_single|Male|50|5%|5%|6 Years": [
    { premium: 5000, db: 0.979974, ltc: 0.979974 },
    { premium: 7500, db: 0.986591, ltc: 0.986589 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 0.999999 },
  ],
  "10pay_single|Male|50|5%|5%|Lifetime": [
    { premium: 5000, db: 0.979898, ltc: 1 },
    { premium: 7500, db: 0.98658, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
  ],
  "10pay_single|Male|55|None|None|2 Years": [
    { premium: 5000, db: 0.98, ltc: 0.98 },
    { premium: 7500, db: 1.000004, ltc: 1.000004 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_single|Male|55|None|None|4 Years": [
    { premium: 5000, db: 0.979934, ltc: 0.979934 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|55|None|None|6 Years": [
    { premium: 5000, db: 0.979938, ltc: 0.979938 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|55|None|None|Lifetime": [
    { premium: 5000, db: 0.980058, ltc: 1 },
    { premium: 7500, db: 1.000002, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
  ],
  "10pay_single|Male|55|None|3%|2 Years": [
    { premium: 5000, db: 0.980006, ltc: 0.980004 },
    { premium: 7500, db: 1, ltc: 0.999999 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1.000002 },
    { premium: 25000, db: 1.013618, ltc: 0.949104 },
    { premium: 30000, db: 1.03183, ltc: 0.881033 },
  ],
  "10pay_single|Male|55|None|3%|4 Years": [
    { premium: 5000, db: 0.979934, ltc: 0.979936 },
    { premium: 7500, db: 0.999995, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1.000001 },
    { premium: 25000, db: 1.012571, ltc: 0.952533 },
    { premium: 30000, db: 1.038594, ltc: 0.854284 },
  ],
  "10pay_single|Male|55|None|3%|6 Years": [
    { premium: 5000, db: 0.980031, ltc: 0.98003 },
    { premium: 7500, db: 0.986643, ltc: 0.986642 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 0.999998, ltc: 0.999998 },
    { premium: 30000, db: 1.041559, ltc: 0.9076 },
  ],
  "10pay_single|Male|55|None|3%|Lifetime": [
    { premium: 5000, db: 0.979994, ltc: 1 },
    { premium: 7500, db: 0.986705, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.038507, ltc: 1 },
  ],
  "10pay_single|Male|55|None|5%|2 Years": [
    { premium: 5000, db: 0.979997, ltc: 0.979996 },
    { premium: 7500, db: 1, ltc: 0.999999 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.02949, ltc: 0.923041 },
    { premium: 25000, db: 1.058047, ltc: 0.848502 },
    { premium: 30000, db: 1.077082, ltc: 0.798808 },
  ],
  "10pay_single|Male|55|None|5%|4 Years": [
    { premium: 5000, db: 0.980022, ltc: 0.980023 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999996 },
    { premium: 15500, db: 0.999997, ltc: 0.999996 },
    { premium: 20000, db: 1.02989, ltc: 0.918375 },
    { premium: 25000, db: 1.070417, ltc: 0.807717 },
    { premium: 30000, db: 1.097434, ltc: 0.733946 },
  ],
  "10pay_single|Male|55|None|5%|6 Years": [
    { premium: 5000, db: 0.97996, ltc: 0.97996 },
    { premium: 7500, db: 0.986623, ltc: 0.986622 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000005 },
    { premium: 15500, db: 1.000005, ltc: 1.000004 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.082362, ltc: 0.864959 },
    { premium: 30000, db: 1.139751, ltc: 0.770863 },
  ],
  "10pay_single|Male|55|None|5%|Lifetime": [
    { premium: 5000, db: 0.979987, ltc: 1 },
    { premium: 7500, db: 0.986721, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1 },
    { premium: 15500, db: 1.000005, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.079878, ltc: 1 },
    { premium: 30000, db: 1.143706, ltc: 1 },
  ],
  "10pay_single|Male|55|3%|3%|2 Years": [
    { premium: 5000, db: 0.980003, ltc: 0.980001 },
    { premium: 7500, db: 0.986669, ltc: 0.986666 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000004 },
    { premium: 15500, db: 1.000005, ltc: 1.000005 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000003, ltc: 1.000002 },
  ],
  "10pay_single|Male|55|3%|3%|4 Years": [
    { premium: 5000, db: 0.979963, ltc: 0.979961 },
    { premium: 7500, db: 0.986629, ltc: 0.986626 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000002 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000003 },
  ],
  "10pay_single|Male|55|3%|3%|6 Years": [
    { premium: 5000, db: 0.980039, ltc: 0.980039 },
    { premium: 7500, db: 0.986714, ltc: 0.986714 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 0.999999, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_single|Male|55|3%|3%|Lifetime": [
    { premium: 5000, db: 0.980012, ltc: 1 },
    { premium: 7500, db: 0.98665, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1 },
    { premium: 15500, db: 1.000005, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.000006, ltc: 1 },
  ],
  "10pay_single|Male|55|5%|5%|2 Years": [
    { premium: 5000, db: 0.979956, ltc: 0.979955 },
    { premium: 7500, db: 0.986692, ltc: 0.986692 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|55|5%|5%|4 Years": [
    { premium: 5000, db: 0.979987, ltc: 0.979986 },
    { premium: 7500, db: 0.986661, ltc: 0.98666 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 0.999996, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|55|5%|5%|6 Years": [
    { premium: 5000, db: 1.065291, ltc: 1.065293 },
    { premium: 7500, db: 0.996719, ltc: 0.996722 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010147, ltc: 1.010148 },
    { premium: 15500, db: 1.010147, ltc: 1.010148 },
    { premium: 20000, db: 1.010145, ltc: 1.010146 },
    { premium: 25000, db: 1.010144, ltc: 1.010144 },
  ],
  "10pay_single|Male|55|5%|5%|Lifetime": [
    { premium: 5000, db: 1.086885, ltc: 1 },
    { premium: 7500, db: 0.996689, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010134, ltc: 1 },
    { premium: 15500, db: 1.010133, ltc: 1 },
    { premium: 20000, db: 1.010133, ltc: 1 },
    { premium: 25000, db: 1.010131, ltc: 1 },
  ],
  "10pay_single|Male|60|None|None|2 Years": [
    { premium: 5000, db: 0.979951, ltc: 0.979951 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_single|Male|60|None|None|4 Years": [
    { premium: 5000, db: 0.979963, ltc: 0.979963 },
    { premium: 7500, db: 0.986602, ltc: 0.986602 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|Male|60|None|None|6 Years": [
    { premium: 5000, db: 0.979944, ltc: 0.979944 },
    { premium: 7500, db: 0.986615, ltc: 0.986615 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|Male|60|None|None|Lifetime": [
    { premium: 5000, db: 0.979928, ltc: 1 },
    { premium: 7500, db: 0.98661, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|60|None|3%|2 Years": [
    { premium: 5000, db: 0.979969, ltc: 0.979965 },
    { premium: 7500, db: 0.986602, ltc: 0.986601 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000002 },
    { premium: 15500, db: 1, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000001 },
    { premium: 30000, db: 1.017653, ltc: 0.938957 },
  ],
  "10pay_single|Male|60|None|3%|4 Years": [
    { premium: 5000, db: 0.979965, ltc: 0.979963 },
    { premium: 7500, db: 0.986676, ltc: 0.986674 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000004 },
    { premium: 15500, db: 1.000004, ltc: 1.000003 },
    { premium: 20000, db: 1.000008, ltc: 1.000008 },
    { premium: 25000, db: 1.000006, ltc: 1.000006 },
    { premium: 30000, db: 1.01742, ltc: 0.93928 },
  ],
  "10pay_single|Male|60|None|3%|6 Years": [
    { premium: 5000, db: 0.979999, ltc: 0.98 },
    { premium: 7500, db: 0.986675, ltc: 0.986675 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000001, ltc: 1.000003 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|Male|60|None|3%|Lifetime": [
    { premium: 5000, db: 0.980009, ltc: 1 },
    { premium: 7500, db: 0.986651, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000006, ltc: 1 },
    { premium: 30000, db: 1.000006, ltc: 1 },
  ],
  "10pay_single|Male|60|None|5%|2 Years": [
    { premium: 5000, db: 0.979983, ltc: 0.979988 },
    { premium: 7500, db: 0.986691, ltc: 0.986693 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999999 },
    { premium: 15500, db: 0.999996, ltc: 0.999998 },
    { premium: 20000, db: 1.005535, ltc: 0.986536 },
    { premium: 25000, db: 1.040992, ltc: 0.900288 },
    { premium: 30000, db: 1.064629, ltc: 0.842789 },
  ],
  "10pay_single|Male|60|None|5%|4 Years": [
    { premium: 5000, db: 0.980027, ltc: 0.980025 },
    { premium: 7500, db: 0.986634, ltc: 0.986634 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999994, ltc: 0.999994 },
    { premium: 15500, db: 0.999995, ltc: 0.999995 },
    { premium: 20000, db: 0.999996, ltc: 0.999996 },
    { premium: 25000, db: 1.044892, ltc: 0.88326 },
    { premium: 30000, db: 1.077906, ltc: 0.797413 },
  ],
  "10pay_single|Male|60|None|5%|6 Years": [
    { premium: 5000, db: 0.990601, ltc: 0.9906 },
    { premium: 7500, db: 0.986653, ltc: 0.986652 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999996 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1.022132, ltc: 0.965806 },
    { premium: 30000, db: 1.093385, ltc: 0.855708 },
  ],
  "10pay_single|Male|60|None|5%|Lifetime": [
    { premium: 5000, db: 1.020392, ltc: 1 },
    { premium: 7500, db: 0.996576, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010102, ltc: 1 },
    { premium: 15500, db: 1.010103, ltc: 1 },
    { premium: 20000, db: 1.010104, ltc: 1 },
    { premium: 25000, db: 1.024836, ltc: 1 },
    { premium: 30000, db: 1.102885, ltc: 1 },
  ],
  "10pay_single|Male|60|3%|3%|2 Years": [
    { premium: 5000, db: 0.980012, ltc: 0.980009 },
    { premium: 7500, db: 0.986669, ltc: 0.98667 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1.000005 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1.000005 },
    { premium: 30000, db: 1.000003, ltc: 1.000004 },
  ],
  "10pay_single|Male|60|3%|3%|4 Years": [
    { premium: 5000, db: 0.980016, ltc: 0.980012 },
    { premium: 7500, db: 0.986618, ltc: 0.986617 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999996 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 0.999998, ltc: 0.999998 },
    { premium: 30000, db: 0.999997, ltc: 0.999996 },
  ],
  "10pay_single|Male|60|3%|3%|6 Years": [
    { premium: 5000, db: 1.051697, ltc: 1.051695 },
    { premium: 7500, db: 0.99659, ltc: 0.996589 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01009, ltc: 1.01009 },
    { premium: 15500, db: 1.010086, ltc: 1.010087 },
    { premium: 20000, db: 1.010088, ltc: 1.010088 },
    { premium: 25000, db: 1.010087, ltc: 1.010087 },
    { premium: 30000, db: 1.01009, ltc: 1.01009 },
  ],
  "10pay_single|Male|60|3%|3%|Lifetime": [
    { premium: 5000, db: 1.071694, ltc: 1 },
    { premium: 7500, db: 0.996639, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010083, ltc: 1 },
    { premium: 15500, db: 1.010087, ltc: 1 },
    { premium: 20000, db: 1.010088, ltc: 1 },
    { premium: 25000, db: 1.010087, ltc: 1 },
    { premium: 30000, db: 1.010086, ltc: 1 },
  ],
  "10pay_single|Male|60|5%|5%|2 Years": [
    { premium: 5000, db: 1.073304, ltc: 1.073308 },
    { premium: 7500, db: 0.996562, ltc: 0.996561 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010077, ltc: 1.010078 },
    { premium: 15500, db: 1.010081, ltc: 1.010084 },
    { premium: 20000, db: 1.010082, ltc: 1.010083 },
    { premium: 25000, db: 1.010081, ltc: 1.010082 },
  ],
  "10pay_single|Male|60|5%|5%|4 Years": [
    { premium: 5000, db: 1.114993, ltc: 1.114995 },
    { premium: 7500, db: 0.996693, ltc: 0.996693 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010151, ltc: 1.010151 },
    { premium: 15500, db: 1.010151, ltc: 1.010151 },
    { premium: 20000, db: 1.010149, ltc: 1.010149 },
    { premium: 25000, db: 1.010148, ltc: 1.010148 },
  ],
  "10pay_single|Male|60|5%|5%|6 Years": [
    { premium: 5000, db: 1.257585, ltc: 1.257583 },
    { premium: 7500, db: 0.996677, ltc: 0.996677 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01013, ltc: 1.01013 },
    { premium: 15500, db: 1.010121, ltc: 1.01012 },
    { premium: 20000, db: 1.010128, ltc: 1.010127 },
    { premium: 25000, db: 1.010126, ltc: 1.010126 },
  ],
  "10pay_single|Male|60|5%|5%|Lifetime": [
    { premium: 5000, db: 1.277188, ltc: 1 },
    { premium: 7500, db: 0.996646, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010131, ltc: 1 },
    { premium: 15500, db: 1.01013, ltc: 1 },
    { premium: 20000, db: 1.010127, ltc: 1 },
    { premium: 25000, db: 1.010129, ltc: 1 },
    { premium: 30000, db: 1.010131, ltc: 1 },
  ],
  "10pay_single|Male|65|None|None|2 Years": [
    { premium: 5000, db: 0.980006, ltc: 0.980006 },
    { premium: 7500, db: 0.986618, ltc: 0.986618 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|65|None|None|4 Years": [
    { premium: 5000, db: 0.980026, ltc: 0.980026 },
    { premium: 7500, db: 0.986666, ltc: 0.986666 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 0.999995, ltc: 0.999995 },
    { premium: 25000, db: 0.999996, ltc: 0.999996 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|Male|65|None|None|6 Years": [
    { premium: 5000, db: 0.986585, ltc: 0.986585 },
    { premium: 7500, db: 0.986697, ltc: 0.986697 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000007, ltc: 1.000007 },
    { premium: 15500, db: 1.000007, ltc: 1.000007 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000007, ltc: 1.000007 },
  ],
  "10pay_single|Male|65|None|None|Lifetime": [
    { premium: 5000, db: 1.014493, ltc: 1 },
    { premium: 7500, db: 0.996562, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010064, ltc: 1 },
    { premium: 15500, db: 1.010067, ltc: 1 },
    { premium: 20000, db: 1.010066, ltc: 1 },
    { premium: 25000, db: 1.010067, ltc: 1 },
    { premium: 30000, db: 1.010068, ltc: 1 },
  ],
  "10pay_single|Male|65|None|3%|2 Years": [
    { premium: 5000, db: 0.97996, ltc: 0.979957 },
    { premium: 7500, db: 0.986692, ltc: 0.986694 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 1, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999998, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1.000001 },
  ],
  "10pay_single|Male|65|None|3%|4 Years": [
    { premium: 5000, db: 0.979977, ltc: 0.979979 },
    { premium: 7500, db: 0.986629, ltc: 0.986627 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000002 },
    { premium: 15500, db: 1.000006, ltc: 1.000006 },
    { premium: 20000, db: 1.000005, ltc: 1.000004 },
    { premium: 25000, db: 1.000006, ltc: 1.000005 },
    { premium: 30000, db: 1.000006, ltc: 1.000005 },
  ],
  "10pay_single|Male|65|None|3%|6 Years": [
    { premium: 5000, db: 1.096392, ltc: 1.096392 },
    { premium: 7500, db: 0.996639, ltc: 0.996638 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010143, ltc: 1.010142 },
    { premium: 15500, db: 1.010144, ltc: 1.010143 },
    { premium: 20000, db: 1.010139, ltc: 1.010138 },
    { premium: 25000, db: 1.010141, ltc: 1.010141 },
    { premium: 30000, db: 1.010143, ltc: 1.010142 },
  ],
  "10pay_single|Male|65|None|3%|Lifetime": [
    { premium: 5000, db: 1.119787, ltc: 1 },
    { premium: 7500, db: 0.996615, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01011, ltc: 1 },
    { premium: 15500, db: 1.01011, ltc: 1 },
    { premium: 20000, db: 1.01011, ltc: 1 },
    { premium: 25000, db: 1.01011, ltc: 1 },
    { premium: 30000, db: 1.01011, ltc: 1 },
  ],
  "10pay_single|Male|65|None|5%|2 Years": [
    { premium: 5000, db: 0.980039, ltc: 0.980035 },
    { premium: 7500, db: 0.986699, ltc: 0.986696 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999994, ltc: 0.999991 },
    { premium: 15500, db: 0.999998, ltc: 0.999995 },
    { premium: 20000, db: 0.999995, ltc: 0.999993 },
    { premium: 25000, db: 1.015041, ltc: 0.964346 },
    { premium: 30000, db: 1.043679, ltc: 0.896488 },
  ],
  "10pay_single|Male|65|None|5%|4 Years": [
    { premium: 5000, db: 1.018192, ltc: 1.018192 },
    { premium: 7500, db: 0.996671, ltc: 0.996668 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010129, ltc: 1.010129 },
    { premium: 15500, db: 1.010127, ltc: 1.010127 },
    { premium: 20000, db: 1.010129, ltc: 1.010129 },
    { premium: 25000, db: 1.018298, ltc: 0.989434 },
    { premium: 30000, db: 1.058827, ltc: 0.886806 },
  ],
  "10pay_single|Male|65|None|5%|6 Years": [
    { premium: 5000, db: 1.185094, ltc: 1.185096 },
    { premium: 7500, db: 0.996631, ltc: 0.99663 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010147, ltc: 1.010147 },
    { premium: 15500, db: 1.010142, ltc: 1.010143 },
    { premium: 20000, db: 1.010143, ltc: 1.010144 },
    { premium: 25000, db: 1.010145, ltc: 1.010146 },
    { premium: 30000, db: 1.038367, ltc: 0.966965 },
  ],
  "10pay_single|Male|65|None|5%|Lifetime": [
    { premium: 5000, db: 1.208297, ltc: 1 },
    { premium: 7500, db: 0.996622, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010119, ltc: 1 },
    { premium: 15500, db: 1.01012, ltc: 1 },
    { premium: 20000, db: 1.010123, ltc: 1 },
    { premium: 25000, db: 1.010121, ltc: 1 },
    { premium: 30000, db: 1.031191, ltc: 1 },
  ],
  "10pay_single|Male|65|3%|3%|2 Years": [
    { premium: 5000, db: 1.080003, ltc: 1.080007 },
    { premium: 7500, db: 0.996678, ltc: 0.996677 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010111, ltc: 1.010112 },
    { premium: 15500, db: 1.010109, ltc: 1.010109 },
    { premium: 20000, db: 1.010107, ltc: 1.010107 },
    { premium: 25000, db: 1.010109, ltc: 1.01011 },
    { premium: 30000, db: 1.010111, ltc: 1.010111 },
  ],
  "10pay_single|Male|65|3%|3%|4 Years": [
    { premium: 5000, db: 1.1202, ltc: 1.120204 },
    { premium: 7500, db: 0.996614, ltc: 0.996616 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010105, ltc: 1.010106 },
    { premium: 15500, db: 1.010107, ltc: 1.01011 },
    { premium: 20000, db: 1.010107, ltc: 1.010109 },
    { premium: 25000, db: 1.010108, ltc: 1.01011 },
    { premium: 30000, db: 1.010109, ltc: 1.010111 },
  ],
  "10pay_single|Male|65|3%|3%|6 Years": [
    { premium: 5000, db: 1.247113, ltc: 1.247115 },
    { premium: 7500, db: 0.99665, ltc: 0.996649 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010133, ltc: 1.010133 },
    { premium: 15500, db: 1.010137, ltc: 1.010137 },
    { premium: 20000, db: 1.010137, ltc: 1.010138 },
    { premium: 25000, db: 1.010135, ltc: 1.010135 },
    { premium: 30000, db: 1.010137, ltc: 1.010137 },
  ],
  "10pay_single|Male|65|3%|3%|Lifetime": [
    { premium: 5000, db: 1.270685, ltc: 1 },
    { premium: 7500, db: 0.996625, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.0101, ltc: 1 },
    { premium: 15500, db: 1.010096, ltc: 1 },
    { premium: 20000, db: 1.0101, ltc: 1 },
    { premium: 25000, db: 1.0101, ltc: 1 },
    { premium: 30000, db: 1.0101, ltc: 1 },
  ],
  "10pay_single|Male|65|5%|5%|2 Years": [
    { premium: 5000, db: 1.258988, ltc: 1.258998 },
    { premium: 7500, db: 0.996677, ltc: 0.996678 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010112, ltc: 1.010117 },
    { premium: 15500, db: 1.010119, ltc: 1.010123 },
    { premium: 20000, db: 1.010115, ltc: 1.010117 },
    { premium: 25000, db: 1.010116, ltc: 1.010119 },
  ],
  "10pay_single|Male|65|5%|5%|4 Years": [
    { premium: 5000, db: 1.309495, ltc: 1.309495 },
    { premium: 7500, db: 0.996648, ltc: 0.996648 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010108, ltc: 1.01011 },
    { premium: 15500, db: 1.010113, ltc: 1.010115 },
    { premium: 20000, db: 1.010114, ltc: 1.010115 },
    { premium: 25000, db: 1.010113, ltc: 1.010114 },
    { premium: 30000, db: 1.010112, ltc: 1.010113 },
  ],
  "10pay_single|Male|65|5%|5%|6 Years": [
    { premium: 5000, db: 1.476388, ltc: 1.476388 },
    { premium: 7500, db: 0.996619, ltc: 0.996622 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010132, ltc: 1.010133 },
    { premium: 15500, db: 1.010128, ltc: 1.01013 },
    { premium: 20000, db: 1.010134, ltc: 1.010135 },
    { premium: 25000, db: 1.01013, ltc: 1.010131 },
    { premium: 30000, db: 1.010132, ltc: 1.010133 },
  ],
  "10pay_single|Male|65|5%|5%|Lifetime": [
    { premium: 5000, db: 1.499588, ltc: 1 },
    { premium: 7500, db: 0.999725, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01011, ltc: 1 },
    { premium: 15500, db: 1.010115, ltc: 1 },
    { premium: 20000, db: 1.010113, ltc: 1 },
    { premium: 25000, db: 1.010114, ltc: 1 },
    { premium: 30000, db: 1.010115, ltc: 1 },
  ],
  "10pay_single|Male|70|None|None|2 Years": [
    { premium: 5000, db: 1.067479, ltc: 1.067479 },
    { premium: 7500, db: 0.996638, ltc: 0.996638 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010128, ltc: 1.010128 },
    { premium: 15500, db: 1.010124, ltc: 1.010124 },
    { premium: 20000, db: 1.010128, ltc: 1.010128 },
    { premium: 25000, db: 1.010128, ltc: 1.010128 },
    { premium: 30000, db: 1.010128, ltc: 1.010128 },
  ],
  "10pay_single|Male|70|None|None|4 Years": [
    { premium: 5000, db: 1.098604, ltc: 1.098604 },
    { premium: 7500, db: 0.996635, ltc: 0.996635 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010116, ltc: 1.010116 },
    { premium: 15500, db: 1.010116, ltc: 1.010116 },
    { premium: 20000, db: 1.010122, ltc: 1.010122 },
    { premium: 25000, db: 1.010121, ltc: 1.010121 },
    { premium: 30000, db: 1.01012, ltc: 1.01012 },
  ],
  "10pay_single|Male|70|None|None|6 Years": [
    { premium: 5000, db: 1.201191, ltc: 1.201191 },
    { premium: 7500, db: 0.996589, ltc: 0.996589 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010088, ltc: 1.010088 },
    { premium: 15500, db: 1.010087, ltc: 1.010087 },
    { premium: 20000, db: 1.010088, ltc: 1.010088 },
    { premium: 25000, db: 1.010088, ltc: 1.010088 },
    { premium: 30000, db: 1.010088, ltc: 1.010088 },
  ],
  "10pay_single|Male|70|None|None|Lifetime": [
    { premium: 5000, db: 1.219805, ltc: 1 },
    { premium: 7500, db: 0.99665, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010114, ltc: 1 },
    { premium: 15500, db: 1.01011, ltc: 1 },
    { premium: 20000, db: 1.01011, ltc: 1 },
    { premium: 25000, db: 1.010112, ltc: 1 },
    { premium: 30000, db: 1.010114, ltc: 1 },
  ],
  "10pay_single|Male|70|None|3%|2 Years": [
    { premium: 5000, db: 1.112278, ltc: 1.112275 },
    { premium: 7500, db: 0.99659, ltc: 0.996593 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010076, ltc: 1.010076 },
    { premium: 15500, db: 1.010081, ltc: 1.010081 },
    { premium: 20000, db: 1.010081, ltc: 1.010083 },
    { premium: 25000, db: 1.01008, ltc: 1.010081 },
    { premium: 30000, db: 1.010079, ltc: 1.010081 },
  ],
  "10pay_single|Male|70|None|3%|4 Years": [
    { premium: 5000, db: 1.158786, ltc: 1.158785 },
    { premium: 7500, db: 0.996644, ltc: 0.996647 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010107, ltc: 1.010107 },
    { premium: 15500, db: 1.010113, ltc: 1.010114 },
    { premium: 20000, db: 1.010109, ltc: 1.01011 },
    { premium: 25000, db: 1.01011, ltc: 1.010111 },
    { premium: 30000, db: 1.010111, ltc: 1.010112 },
  ],
  "10pay_single|Male|70|None|3%|6 Years": [
    { premium: 5000, db: 1.307885, ltc: 1.307883 },
    { premium: 7500, db: 0.996644, ltc: 0.996641 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010122, ltc: 1.010119 },
    { premium: 15500, db: 1.01012, ltc: 1.010119 },
    { premium: 20000, db: 1.010115, ltc: 1.010114 },
    { premium: 25000, db: 1.010116, ltc: 1.010115 },
    { premium: 30000, db: 1.010117, ltc: 1.010115 },
  ],
  "10pay_single|Male|70|None|3%|Lifetime": [
    { premium: 5000, db: 1.331089, ltc: 1 },
    { premium: 7500, db: 0.996615, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010093, ltc: 1 },
    { premium: 15500, db: 1.010095, ltc: 1 },
    { premium: 20000, db: 1.010095, ltc: 1 },
    { premium: 25000, db: 1.010091, ltc: 1 },
    { premium: 30000, db: 1.010093, ltc: 1 },
  ],
  "10pay_single|Male|70|None|5%|2 Years": [
    { premium: 5000, db: 1.153694, ltc: 1.153688 },
    { premium: 7500, db: 0.996632, ltc: 0.996628 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010074, ltc: 1.010073 },
    { premium: 15500, db: 1.010072, ltc: 1.010069 },
    { premium: 20000, db: 1.010076, ltc: 1.010075 },
    { premium: 25000, db: 1.010077, ltc: 1.010075 },
    { premium: 30000, db: 1.025804, ltc: 0.97116 },
  ],
  "10pay_single|Male|70|None|5%|4 Years": [
    { premium: 5000, db: 1.211507, ltc: 1.211505 },
    { premium: 7500, db: 0.996637, ltc: 0.996636 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010098, ltc: 1.010098 },
    { premium: 15500, db: 1.010095, ltc: 1.010094 },
    { premium: 20000, db: 1.010096, ltc: 1.010097 },
    { premium: 25000, db: 1.0101, ltc: 1.0101 },
    { premium: 30000, db: 1.019926, ltc: 0.98412 },
  ],
  "10pay_single|Male|70|None|5%|6 Years": [
    { premium: 5000, db: 1.399194, ltc: 1.399195 },
    { premium: 7500, db: 0.996661, ltc: 0.996664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010119, ltc: 1.01012 },
    { premium: 15500, db: 1.010116, ltc: 1.010117 },
    { premium: 20000, db: 1.010114, ltc: 1.010116 },
    { premium: 25000, db: 1.010117, ltc: 1.010118 },
    { premium: 30000, db: 1.010119, ltc: 1.01012 },
  ],
  "10pay_single|Male|70|None|5%|Lifetime": [
    { premium: 5000, db: 1.420008, ltc: 1 },
    { premium: 7500, db: 0.99663, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.0101, ltc: 1 },
    { premium: 15500, db: 1.010107, ltc: 1 },
    { premium: 20000, db: 1.010109, ltc: 1 },
    { premium: 25000, db: 1.010109, ltc: 1 },
    { premium: 30000, db: 1.010104, ltc: 1 },
  ],
  "10pay_single|Male|70|3%|3%|2 Years": [
    { premium: 5000, db: 1.26828, ltc: 1.26829 },
    { premium: 7500, db: 0.996627, ltc: 0.996629 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010111, ltc: 1.010116 },
    { premium: 15500, db: 1.010113, ltc: 1.010115 },
    { premium: 20000, db: 1.010113, ltc: 1.010115 },
    { premium: 25000, db: 1.010114, ltc: 1.010117 },
    { premium: 30000, db: 1.010115, ltc: 1.010118 },
  ],
  "10pay_single|Male|70|3%|3%|4 Years": [
    { premium: 5000, db: 1.314694, ltc: 1.314694 },
    { premium: 7500, db: 0.996591, ltc: 0.996595 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010069, ltc: 1.01007 },
    { premium: 15500, db: 1.010069, ltc: 1.010071 },
    { premium: 20000, db: 1.010069, ltc: 1.010072 },
    { premium: 25000, db: 1.010069, ltc: 1.010071 },
    { premium: 30000, db: 1.010069, ltc: 1.010072 },
  ],
  "10pay_single|Male|70|3%|3%|6 Years": [
    { premium: 5000, db: 1.46379, ltc: 1.463791 },
    { premium: 7500, db: 0.996604, ltc: 0.996604 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010079, ltc: 1.010081 },
    { premium: 15500, db: 1.010083, ltc: 1.010082 },
    { premium: 20000, db: 1.010084, ltc: 1.010085 },
    { premium: 25000, db: 1.010081, ltc: 1.010082 },
    { premium: 30000, db: 1.010084, ltc: 1.010084 },
  ],
  "10pay_single|Male|70|3%|3%|Lifetime": [
    { premium: 5000, db: 1.487079, ltc: 1 },
    { premium: 7500, db: 0.99664, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010121, ltc: 1 },
    { premium: 15500, db: 1.010114, ltc: 1 },
    { premium: 20000, db: 1.010118, ltc: 1 },
    { premium: 25000, db: 1.010123, ltc: 1 },
    { premium: 30000, db: 1.010121, ltc: 1 },
  ],
  "10pay_single|Male|70|5%|5%|2 Years": [
    { premium: 5000, db: 1.450879, ltc: 1.450876 },
    { premium: 7500, db: 0.996634, ltc: 0.996636 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010097, ltc: 1.010095 },
    { premium: 15500, db: 1.010093, ltc: 1.010092 },
    { premium: 20000, db: 1.010097, ltc: 1.010097 },
    { premium: 25000, db: 1.010097, ltc: 1.010096 },
    { premium: 30000, db: 1.010097, ltc: 1.010097 },
  ],
  "10pay_single|Male|70|5%|5%|4 Years": [
    { premium: 5000, db: 1.508681, ltc: 1.50868 },
    { premium: 7500, db: 1.005788, ltc: 1.005787 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010102, ltc: 1.010101 },
    { premium: 15500, db: 1.010111, ltc: 1.010111 },
    { premium: 20000, db: 1.010107, ltc: 1.010104 },
    { premium: 25000, db: 1.01011, ltc: 1.010108 },
    { premium: 30000, db: 1.010107, ltc: 1.010106 },
  ],
  "10pay_single|Male|70|5%|5%|6 Years": [
    { premium: 5000, db: 1.696365, ltc: 1.696367 },
    { premium: 7500, db: 1.13091, ltc: 1.130911 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003364, ltc: 1.003365 },
    { premium: 15500, db: 1.003595, ltc: 1.003595 },
    { premium: 20000, db: 1.010117, ltc: 1.010117 },
    { premium: 25000, db: 1.010119, ltc: 1.01012 },
    { premium: 30000, db: 1.01012, ltc: 1.010121 },
  ],
  "10pay_single|Male|70|5%|5%|Lifetime": [
    { premium: 5000, db: 1.717175, ltc: 1 },
    { premium: 7500, db: 1.144783, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003382, ltc: 1 },
    { premium: 15500, db: 1.003616, ltc: 1 },
    { premium: 20000, db: 1.010113, ltc: 1 },
    { premium: 25000, db: 1.01012, ltc: 1 },
    { premium: 30000, db: 1.010119, ltc: 1 },
  ],
  "10pay_joint|Female|45|None|None|2 Years": [
    { premium: 5000, db: 0.98002, ltc: 0.98002 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|Female|45|None|None|4 Years": [
    { premium: 5000, db: 0.980078, ltc: 0.980078 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|Female|45|None|None|6 Years": [
    { premium: 5000, db: 0.980013, ltc: 0.980013 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_joint|Female|45|None|None|Lifetime": [
    { premium: 5000, db: 0.979999, ltc: 1 },
    { premium: 7500, db: 0.999998, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 1 },
    { premium: 20000, db: 0.999996, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 1 },
    { premium: 30000, db: 0.999998, ltc: 1 },
  ],
  "10pay_joint|Female|45|None|3%|2 Years": [
    { premium: 5000, db: 0.979964, ltc: 0.979964 },
    { premium: 7500, db: 0.999998, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.001856, ltc: 0.997986 },
    { premium: 25000, db: 1.067568, ltc: 0.92651 },
    { premium: 30000, db: 1.111374, ltc: 0.878858 },
  ],
  "10pay_joint|Female|45|None|3%|4 Years": [
    { premium: 5000, db: 0.979966, ltc: 0.979967 },
    { premium: 7500, db: 0.999996, ltc: 0.999995 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999999, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1.054496, ltc: 0.939335 },
    { premium: 30000, db: 1.126107, ltc: 0.859618 },
  ],
  "10pay_joint|Female|45|None|3%|6 Years": [
    { premium: 5000, db: 0.979997, ltc: 0.979996 },
    { premium: 7500, db: 0.986695, ltc: 0.986694 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999998 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 0.999996, ltc: 0.999995 },
    { premium: 25000, db: 0.999998, ltc: 0.999998 },
    { premium: 30000, db: 1.066102, ltc: 0.954766 },
  ],
  "10pay_joint|Female|45|None|3%|Lifetime": [
    { premium: 5000, db: 0.979963, ltc: 1 },
    { premium: 7500, db: 0.98666, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
  ],
  "10pay_joint|Female|45|None|5%|2 Years": [
    { premium: 5000, db: 0.980014, ltc: 0.98001 },
    { premium: 7500, db: 1.000004, ltc: 1.000005 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000002 },
    { premium: 20000, db: 1.100883, ltc: 0.935104 },
    { premium: 25000, db: 1.176056, ltc: 0.88674 },
    { premium: 30000, db: 1.226172, ltc: 0.854498 },
  ],
  "10pay_joint|Female|45|None|5%|4 Years": [
    { premium: 5000, db: 0.979984, ltc: 0.979987 },
    { premium: 7500, db: 0.986648, ltc: 0.98665 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000002, ltc: 1.000003 },
    { premium: 20000, db: 1.066208, ltc: 0.95253 },
    { premium: 25000, db: 1.191876, ltc: 0.862413 },
    { premium: 30000, db: 1.275652, ltc: 0.802334 },
  ],
  "10pay_joint|Female|45|None|5%|6 Years": [
    { premium: 5100, db: 0.980411, ltc: 0.980413 },
    { premium: 7500, db: 0.986697, ltc: 0.986699 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000007, ltc: 1.000007 },
    { premium: 15500, db: 1.000007, ltc: 1.000008 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.064582, ltc: 0.971717 },
    { premium: 30000, db: 1.256676, ltc: 0.887566 },
  ],
  "10pay_joint|Female|45|None|5%|Lifetime": [
    { premium: 5500, db: 0.991673, ltc: 1 },
    { premium: 7500, db: 0.996588, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010077, ltc: 1 },
    { premium: 15500, db: 1.010077, ltc: 1 },
    { premium: 20000, db: 1.010078, ltc: 1 },
    { premium: 25000, db: 1.010075, ltc: 1 },
    { premium: 30000, db: 1.212571, ltc: 1 },
  ],
  "10pay_joint|Female|45|3%|3%|2 Years": [
    { premium: 5000, db: 0.980055, ltc: 0.980058 },
    { premium: 7500, db: 1.000005, ltc: 1.000007 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000002, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|Female|45|3%|3%|4 Years": [
    { premium: 5000, db: 0.98004, ltc: 0.980039 },
    { premium: 7500, db: 0.98662, ltc: 0.986618 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000002 },
    { premium: 15500, db: 1.000004, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000004 },
  ],
  "10pay_joint|Female|45|3%|3%|6 Years": [
    { premium: 5000, db: 0.979973, ltc: 0.979972 },
    { premium: 7500, db: 0.986626, ltc: 0.986625 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1, ltc: 0.999999 },
    { premium: 20000, db: 1.000005, ltc: 1.000004 },
    { premium: 25000, db: 1.000006, ltc: 1.000005 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_joint|Female|45|3%|3%|Lifetime": [
    { premium: 5400, db: 0.991447, ltc: 1 },
    { premium: 7500, db: 0.996695, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010134, ltc: 1 },
    { premium: 15500, db: 1.010135, ltc: 1 },
    { premium: 20000, db: 1.010138, ltc: 1 },
    { premium: 25000, db: 1.010135, ltc: 1 },
    { premium: 30000, db: 1.010138, ltc: 1 },
  ],
  "10pay_joint|Female|45|5%|5%|2 Years": [
    { premium: 5000, db: 0.979983, ltc: 0.97998 },
    { premium: 7500, db: 0.986623, ltc: 0.986624 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999997 },
    { premium: 15500, db: 0.999997, ltc: 0.999994 },
    { premium: 20000, db: 1, ltc: 0.999998 },
  ],
  "10pay_joint|Female|45|5%|5%|4 Years": [
    { premium: 5400, db: 0.99145, ltc: 0.991448 },
    { premium: 7500, db: 0.996638, ltc: 0.996637 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010128, ltc: 1.010128 },
    { premium: 15500, db: 1.010124, ltc: 1.010123 },
    { premium: 20000, db: 1.010128, ltc: 1.010128 },
    { premium: 25000, db: 1.010128, ltc: 1.010127 },
  ],
  "10pay_joint|Female|45|5%|5%|6 Years": [
    { premium: 6600, db: 0.994799, ltc: 0.994802 },
    { premium: 7500, db: 0.996632, ltc: 0.996635 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010095, ltc: 1.010095 },
    { premium: 15500, db: 1.010095, ltc: 1.010096 },
    { premium: 20000, db: 1.010097, ltc: 1.010098 },
    { premium: 25000, db: 1.010093, ltc: 1.010094 },
    { premium: 30000, db: 1.010095, ltc: 1.010096 },
  ],
  "10pay_joint|Female|45|5%|5%|Lifetime": [
    { premium: 7000, db: 0.995699, ltc: 1 },
    { premium: 7500, db: 0.99663, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010111, ltc: 1 },
    { premium: 15500, db: 1.010114, ltc: 1 },
    { premium: 20000, db: 1.010117, ltc: 1 },
    { premium: 25000, db: 1.010116, ltc: 1 },
    { premium: 30000, db: 1.010115, ltc: 1 },
  ],
  "10pay_joint|Female|50|None|None|2 Years": [
    { premium: 5000, db: 0.979972, ltc: 0.979972 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999996, ltc: 0.999996 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 0.999997, ltc: 0.999997 },
    { premium: 25000, db: 0.999998, ltc: 0.999998 },
    { premium: 30000, db: 0.999998, ltc: 0.999998 },
  ],
  "10pay_joint|Female|50|None|None|4 Years": [
    { premium: 5000, db: 0.979931, ltc: 0.979931 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 0.999997, ltc: 0.999997 },
    { premium: 25000, db: 0.999999, ltc: 0.999999 },
    { premium: 30000, db: 0.999998, ltc: 0.999998 },
  ],
  "10pay_joint|Female|50|None|None|6 Years": [
    { premium: 5000, db: 0.979906, ltc: 0.979906 },
    { premium: 7500, db: 0.986591, ltc: 0.986591 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_joint|Female|50|None|None|Lifetime": [
    { premium: 5000, db: 0.979913, ltc: 1 },
    { premium: 7500, db: 0.986603, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000007, ltc: 1 },
    { premium: 30000, db: 1.000005, ltc: 1 },
  ],
  "10pay_joint|Female|50|None|3%|2 Years": [
    { premium: 5000, db: 0.980006, ltc: 0.980005 },
    { premium: 7500, db: 0.999996, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 1.000004, ltc: 1.000005 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.037445, ltc: 0.967407 },
    { premium: 30000, db: 1.095118, ltc: 0.917198 },
  ],
  "10pay_joint|Female|50|None|3%|4 Years": [
    { premium: 5000, db: 0.979932, ltc: 0.979931 },
    { premium: 7500, db: 0.986581, ltc: 0.986581 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999998, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1, ltc: 0.999999 },
    { premium: 30000, db: 1.085093, ltc: 0.921769 },
  ],
  "10pay_joint|Female|50|None|3%|6 Years": [
    { premium: 5000, db: 0.979933, ltc: 0.979931 },
    { premium: 7500, db: 0.986667, ltc: 0.986666 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999997, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 0.999999 },
  ],
  "10pay_joint|Female|50|None|3%|Lifetime": [
    { premium: 5400, db: 0.991394, ltc: 1 },
    { premium: 7500, db: 0.996625, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010104, ltc: 1 },
    { premium: 15500, db: 1.010106, ltc: 1 },
    { premium: 20000, db: 1.010104, ltc: 1 },
    { premium: 25000, db: 1.010104, ltc: 1 },
    { premium: 30000, db: 1.010107, ltc: 1 },
  ],
  "10pay_joint|Female|50|None|5%|2 Years": [
    { premium: 5000, db: 0.979941, ltc: 0.97994 },
    { premium: 7500, db: 0.986617, ltc: 0.986619 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999998, ltc: 0.999996 },
    { premium: 20000, db: 1.053451, ltc: 0.973568 },
    { premium: 25000, db: 1.152837, ltc: 0.924425 },
    { premium: 30000, db: 1.219094, ltc: 0.891664 },
  ],
  "10pay_joint|Female|50|None|5%|4 Years": [
    { premium: 5000, db: 0.979956, ltc: 0.979955 },
    { premium: 7500, db: 0.98662, ltc: 0.986618 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.13034, ltc: 0.923097 },
    { premium: 30000, db: 1.240975, ltc: 0.857822 },
  ],
  "10pay_joint|Female|50|None|5%|6 Years": [
    { premium: 5900, db: 0.992937, ltc: 0.992936 },
    { premium: 7500, db: 0.99659, ltc: 0.996589 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010107, ltc: 1.010107 },
    { premium: 15500, db: 1.010105, ltc: 1.010106 },
    { premium: 20000, db: 1.010109, ltc: 1.010109 },
    { premium: 25000, db: 1.01011, ltc: 1.010111 },
    { premium: 30000, db: 1.113547, ltc: 0.972941 },
  ],
  "10pay_joint|Female|50|None|5%|Lifetime": [
    { premium: 6500, db: 0.994552, ltc: 1 },
    { premium: 7500, db: 0.99664, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010123, ltc: 1 },
    { premium: 15500, db: 1.010122, ltc: 1 },
    { premium: 20000, db: 1.010125, ltc: 1 },
    { premium: 25000, db: 1.010126, ltc: 1 },
    { premium: 30000, db: 1.010127, ltc: 1 },
  ],
  "10pay_joint|Female|50|3%|3%|2 Years": [
    { premium: 5000, db: 0.979943, ltc: 0.979944 },
    { premium: 7500, db: 0.986574, ltc: 0.986577 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_joint|Female|50|3%|3%|4 Years": [
    { premium: 5000, db: 0.979991, ltc: 0.979987 },
    { premium: 7500, db: 0.986648, ltc: 0.986645 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000005 },
    { premium: 15500, db: 1.000009, ltc: 1.000006 },
    { premium: 20000, db: 1.000005, ltc: 1.000003 },
    { premium: 25000, db: 1.000008, ltc: 1.000006 },
    { premium: 30000, db: 1.000006, ltc: 1.000005 },
  ],
  "10pay_joint|Female|50|3%|3%|6 Years": [
    { premium: 5900, db: 0.992984, ltc: 0.992985 },
    { premium: 7500, db: 0.996646, ltc: 0.996646 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010171, ltc: 1.01017 },
    { premium: 15500, db: 1.010174, ltc: 1.010173 },
    { premium: 20000, db: 1.010173, ltc: 1.010172 },
    { premium: 25000, db: 1.010175, ltc: 1.010174 },
    { premium: 30000, db: 1.010175, ltc: 1.010174 },
  ],
  "10pay_joint|Female|50|3%|3%|Lifetime": [
    { premium: 6300, db: 0.994033, ltc: 1 },
    { premium: 7500, db: 0.996574, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010095, ltc: 1 },
    { premium: 15500, db: 1.010102, ltc: 1 },
    { premium: 20000, db: 1.010097, ltc: 1 },
    { premium: 25000, db: 1.010098, ltc: 1 },
    { premium: 30000, db: 1.010099, ltc: 1 },
  ],
  "10pay_joint|Female|50|5%|5%|2 Years": [
    { premium: 5800, db: 0.992691, ltc: 0.992691 },
    { premium: 7500, db: 0.996679, ltc: 0.996681 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010162, ltc: 1.010163 },
    { premium: 15500, db: 1.010162, ltc: 1.010161 },
    { premium: 20000, db: 1.010164, ltc: 1.010165 },
    { premium: 25000, db: 1.010165, ltc: 1.010166 },
  ],
  "10pay_joint|Female|50|5%|5%|4 Years": [
    { premium: 6400, db: 0.994327, ltc: 0.99433 },
    { premium: 7500, db: 0.996693, ltc: 0.996696 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010173, ltc: 1.010173 },
    { premium: 15500, db: 1.010169, ltc: 1.01017 },
    { premium: 20000, db: 1.010173, ltc: 1.010175 },
    { premium: 25000, db: 1.010173, ltc: 1.010174 },
  ],
  "10pay_joint|Female|50|5%|5%|6 Years": [
    { premium: 7800, db: 0.99716, ltc: 0.997161 },
    { premium: 7800, db: 0.99716, ltc: 0.997161 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00342, ltc: 1.00342 },
    { premium: 15500, db: 1.010152, ltc: 1.010152 },
    { premium: 20000, db: 1.01015, ltc: 1.01015 },
    { premium: 25000, db: 1.010153, ltc: 1.010153 },
    { premium: 30000, db: 1.01015, ltc: 1.01015 },
  ],
  "10pay_joint|Female|50|5%|5%|Lifetime": [
    { premium: 8400, db: 0.998069, ltc: 1 },
    { premium: 8400, db: 0.998069, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003326, ltc: 1 },
    { premium: 15500, db: 1.003576, ltc: 1 },
    { premium: 20000, db: 1.010111, ltc: 1 },
    { premium: 25000, db: 1.010111, ltc: 1 },
    { premium: 30000, db: 1.010111, ltc: 1 },
  ],
  "10pay_joint|Female|55|None|None|2 Years": [
    { premium: 5000, db: 0.979967, ltc: 0.979967 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|Female|55|None|None|4 Years": [
    { premium: 5000, db: 0.98003, ltc: 0.98003 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_joint|Female|55|None|None|6 Years": [
    { premium: 5000, db: 0.979935, ltc: 0.979935 },
    { premium: 7500, db: 0.986679, ltc: 0.986679 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|Female|55|None|None|Lifetime": [
    { premium: 5000, db: 0.979934, ltc: 1 },
    { premium: 7500, db: 0.986661, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999996, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|Female|55|None|3%|2 Years": [
    { premium: 5000, db: 0.979972, ltc: 0.979969 },
    { premium: 7500, db: 0.986643, ltc: 0.986642 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999997, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 0.999998 },
    { premium: 25000, db: 1, ltc: 0.999998 },
    { premium: 30000, db: 1.070347, ltc: 0.952944 },
  ],
  "10pay_joint|Female|55|None|3%|4 Years": [
    { premium: 5000, db: 0.979997, ltc: 0.979996 },
    { premium: 7500, db: 0.986613, ltc: 0.986611 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999999, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1, ltc: 0.999998 },
    { premium: 30000, db: 1.022664, ltc: 0.98337 },
  ],
  "10pay_joint|Female|55|None|3%|6 Years": [
    { premium: 5700, db: 0.992367, ltc: 0.992368 },
    { premium: 7500, db: 0.996641, ltc: 0.996641 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010092, ltc: 1.010092 },
    { premium: 15500, db: 1.010096, ltc: 1.010097 },
    { premium: 20000, db: 1.010094, ltc: 1.010093 },
    { premium: 25000, db: 1.010095, ltc: 1.010095 },
    { premium: 30000, db: 1.010092, ltc: 1.010092 },
  ],
  "10pay_joint|Female|55|None|3%|Lifetime": [
    { premium: 6300, db: 0.994116, ltc: 1 },
    { premium: 7500, db: 0.996684, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010138, ltc: 1 },
    { premium: 15500, db: 1.010138, ltc: 1 },
    { premium: 20000, db: 1.010134, ltc: 1 },
    { premium: 25000, db: 1.010136, ltc: 1 },
    { premium: 30000, db: 1.010138, ltc: 1 },
  ],
  "10pay_joint|Female|55|None|5%|2 Years": [
    { premium: 5000, db: 0.979929, ltc: 0.979927 },
    { premium: 7500, db: 0.986614, ltc: 0.986613 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.115843, ltc: 0.959213 },
    { premium: 30000, db: 1.204161, ltc: 0.928116 },
  ],
  "10pay_joint|Female|55|None|5%|4 Years": [
    { premium: 5200, db: 0.990603, ltc: 0.990605 },
    { premium: 7500, db: 0.996558, ltc: 0.996561 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010083, ltc: 1.010084 },
    { premium: 15500, db: 1.010083, ltc: 1.010085 },
    { premium: 20000, db: 1.010088, ltc: 1.010089 },
    { premium: 25000, db: 1.045659, ltc: 0.993692 },
    { premium: 30000, db: 1.196216, ltc: 0.924296 },
  ],
  "10pay_joint|Female|55|None|5%|6 Years": [
    { premium: 6900, db: 0.995493, ltc: 0.995493 },
    { premium: 7500, db: 0.996655, ltc: 0.996653 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010109, ltc: 1.01011 },
    { premium: 15500, db: 1.010103, ltc: 1.010103 },
    { premium: 20000, db: 1.010112, ltc: 1.010111 },
    { premium: 25000, db: 1.010107, ltc: 1.010108 },
    { premium: 30000, db: 1.010109, ltc: 1.01011 },
  ],
  "10pay_joint|Female|55|None|5%|Lifetime": [
    { premium: 7500, db: 0.996596, ltc: 1 },
    { premium: 7500, db: 0.996596, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010081, ltc: 1 },
    { premium: 15500, db: 1.01008, ltc: 1 },
    { premium: 20000, db: 1.010084, ltc: 1 },
    { premium: 25000, db: 1.010079, ltc: 1 },
    { premium: 30000, db: 1.010081, ltc: 1 },
  ],
  "10pay_joint|Female|55|3%|3%|2 Years": [
    { premium: 5100, db: 0.980344, ltc: 0.980341 },
    { premium: 7500, db: 0.986615, ltc: 0.986616 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999998 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999998, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|Female|55|3%|3%|4 Years": [
    { premium: 5600, db: 0.992017, ltc: 0.992016 },
    { premium: 7500, db: 0.996666, ltc: 0.996668 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01012, ltc: 1.01012 },
    { premium: 15500, db: 1.01012, ltc: 1.01012 },
    { premium: 20000, db: 1.010123, ltc: 1.010123 },
    { premium: 25000, db: 1.010126, ltc: 1.010125 },
    { premium: 30000, db: 1.010123, ltc: 1.010123 },
  ],
  "10pay_joint|Female|55|3%|3%|6 Years": [
    { premium: 6900, db: 0.995493, ltc: 0.995492 },
    { premium: 7500, db: 0.99664, ltc: 0.99664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010116, ltc: 1.010115 },
    { premium: 15500, db: 1.010119, ltc: 1.010118 },
    { premium: 20000, db: 1.010121, ltc: 1.01012 },
    { premium: 25000, db: 1.010124, ltc: 1.010124 },
    { premium: 30000, db: 1.010121, ltc: 1.01012 },
  ],
  "10pay_joint|Female|55|3%|3%|Lifetime": [
    { premium: 7400, db: 0.996402, ltc: 1 },
    { premium: 7500, db: 0.996604, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010081, ltc: 1 },
    { premium: 15500, db: 1.010081, ltc: 1 },
    { premium: 20000, db: 1.010086, ltc: 1 },
    { premium: 25000, db: 1.010089, ltc: 1 },
    { premium: 30000, db: 1.010086, ltc: 1 },
  ],
  "10pay_joint|Female|55|5%|5%|2 Years": [
    { premium: 6800, db: 0.995245, ltc: 0.99525 },
    { premium: 7500, db: 0.996648, ltc: 0.996652 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010126, ltc: 1.010128 },
    { premium: 15500, db: 1.010133, ltc: 1.010135 },
    { premium: 20000, db: 1.010129, ltc: 1.010129 },
    { premium: 25000, db: 1.01013, ltc: 1.010132 },
    { premium: 30000, db: 1.010131, ltc: 1.010132 },
  ],
  "10pay_joint|Female|55|5%|5%|4 Years": [
    { premium: 7500, db: 0.996642, ltc: 0.99664 },
    { premium: 7500, db: 0.996642, ltc: 0.99664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010135, ltc: 1.010133 },
    { premium: 15500, db: 1.010137, ltc: 1.010135 },
    { premium: 20000, db: 1.010135, ltc: 1.010133 },
    { premium: 25000, db: 1.010135, ltc: 1.010133 },
    { premium: 30000, db: 1.01014, ltc: 1.010138 },
  ],
  "10pay_joint|Female|55|5%|5%|6 Years": [
    { premium: 9300, db: 0.999238, ltc: 0.999238 },
    { premium: 9300, db: 0.999238, ltc: 0.999238 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003323, ltc: 1.003324 },
    { premium: 15500, db: 1.003534, ltc: 1.003534 },
    { premium: 20000, db: 1.010089, ltc: 1.010091 },
    { premium: 25000, db: 1.010088, ltc: 1.010089 },
    { premium: 30000, db: 1.010086, ltc: 1.010088 },
  ],
  "10pay_joint|Female|55|5%|5%|Lifetime": [
    { premium: 9900, db: 0.999911, ltc: 1 },
    { premium: 9900, db: 0.999911, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003376, ltc: 1 },
    { premium: 15500, db: 1.003577, ltc: 1 },
    { premium: 20000, db: 1.010128, ltc: 1 },
    { premium: 25000, db: 1.010128, ltc: 1 },
    { premium: 30000, db: 1.010134, ltc: 1 },
  ],
  "10pay_joint|Female|60|None|None|2 Years": [
    { premium: 5000, db: 0.979966, ltc: 0.979966 },
    { premium: 7500, db: 0.98668, ltc: 0.98668 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000005, ltc: 1.000005 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_joint|Female|60|None|None|4 Years": [
    { premium: 5000, db: 0.979953, ltc: 0.979953 },
    { premium: 7500, db: 0.986706, ltc: 0.986706 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_joint|Female|60|None|None|6 Years": [
    { premium: 5300, db: 0.991007, ltc: 0.991007 },
    { premium: 7500, db: 0.996672, ltc: 0.996672 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010124, ltc: 1.010124 },
    { premium: 15500, db: 1.01012, ltc: 1.01012 },
    { premium: 20000, db: 1.010121, ltc: 1.010121 },
    { premium: 25000, db: 1.010123, ltc: 1.010123 },
    { premium: 30000, db: 1.010124, ltc: 1.010124 },
  ],
  "10pay_joint|Female|60|None|None|Lifetime": [
    { premium: 5800, db: 0.992667, ltc: 1 },
    { premium: 7500, db: 0.996681, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1 },
    { premium: 15500, db: 1.01012, ltc: 1 },
    { premium: 20000, db: 1.010123, ltc: 1 },
    { premium: 25000, db: 1.010122, ltc: 1 },
    { premium: 30000, db: 1.010125, ltc: 1 },
  ],
  "10pay_joint|Female|60|None|3%|2 Years": [
    { premium: 5000, db: 0.979952, ltc: 0.979948 },
    { premium: 7500, db: 0.98662, ltc: 0.986619 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000001 },
    { premium: 15500, db: 1.000003, ltc: 1.000001 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000002, ltc: 1.000001 },
    { premium: 30000, db: 1.004346, ltc: 0.997589 },
  ],
  "10pay_joint|Female|60|None|3%|4 Years": [
    { premium: 5300, db: 0.99098, ltc: 0.99098 },
    { premium: 7500, db: 0.996618, ltc: 0.996621 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010084, ltc: 1.010084 },
    { premium: 15500, db: 1.010088, ltc: 1.010089 },
    { premium: 20000, db: 1.010089, ltc: 1.01009 },
    { premium: 25000, db: 1.010088, ltc: 1.010089 },
    { premium: 30000, db: 1.010087, ltc: 1.010087 },
  ],
  "10pay_joint|Female|60|None|3%|6 Years": [
    { premium: 6800, db: 0.995283, ltc: 0.995282 },
    { premium: 7500, db: 0.996604, ltc: 0.996604 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010108, ltc: 1.010108 },
    { premium: 15500, db: 1.010112, ltc: 1.010112 },
    { premium: 20000, db: 1.010108, ltc: 1.010108 },
    { premium: 25000, db: 1.010108, ltc: 1.010108 },
    { premium: 30000, db: 1.010108, ltc: 1.010108 },
  ],
  "10pay_joint|Female|60|None|3%|Lifetime": [
    { premium: 7500, db: 0.996648, ltc: 1 },
    { premium: 7500, db: 0.996648, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010105, ltc: 1 },
    { premium: 15500, db: 1.010104, ltc: 1 },
    { premium: 20000, db: 1.010108, ltc: 1 },
    { premium: 25000, db: 1.010104, ltc: 1 },
    { premium: 30000, db: 1.010105, ltc: 1 },
  ],
  "10pay_joint|Female|60|None|5%|2 Years": [
    { premium: 5200, db: 0.990739, ltc: 0.990742 },
    { premium: 7500, db: 0.996669, ltc: 0.99667 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010137, ltc: 1.010136 },
    { premium: 15500, db: 1.010132, ltc: 1.010132 },
    { premium: 20000, db: 1.010137, ltc: 1.010136 },
    { premium: 25000, db: 1.034192, ltc: 1.003338 },
    { premium: 30000, db: 1.148934, ltc: 0.970903 },
  ],
  "10pay_joint|Female|60|None|5%|4 Years": [
    { premium: 6100, db: 0.993529, ltc: 0.993529 },
    { premium: 7500, db: 0.996668, ltc: 0.996669 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010116, ltc: 1.010115 },
    { premium: 15500, db: 1.010119, ltc: 1.010119 },
    { premium: 20000, db: 1.010116, ltc: 1.010115 },
    { premium: 25000, db: 1.010121, ltc: 1.010121 },
    { premium: 30000, db: 1.061892, ltc: 0.989398 },
  ],
  "10pay_joint|Female|60|None|5%|6 Years": [
    { premium: 8200, db: 0.997799, ltc: 0.997801 },
    { premium: 8200, db: 0.997799, ltc: 0.997801 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003385, ltc: 1.003387 },
    { premium: 15500, db: 1.003571, ltc: 1.003572 },
    { premium: 20000, db: 1.010105, ltc: 1.010107 },
    { premium: 25000, db: 1.010102, ltc: 1.010103 },
    { premium: 30000, db: 1.010105, ltc: 1.010107 },
  ],
  "10pay_joint|Female|60|None|5%|Lifetime": [
    { premium: 9000, db: 0.998885, ltc: 1 },
    { premium: 9000, db: 0.998885, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003334, ltc: 1 },
    { premium: 15500, db: 1.003561, ltc: 1 },
    { premium: 20000, db: 1.010099, ltc: 1 },
    { premium: 25000, db: 1.0101, ltc: 1 },
    { premium: 30000, db: 1.010096, ltc: 1 },
  ],
  "10pay_joint|Female|60|3%|3%|2 Years": [
    { premium: 6000, db: 0.993265, ltc: 0.993266 },
    { premium: 7500, db: 0.996623, ltc: 0.996621 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010108, ltc: 1.010112 },
    { premium: 15500, db: 1.010109, ltc: 1.010112 },
    { premium: 20000, db: 1.010108, ltc: 1.01011 },
    { premium: 25000, db: 1.010113, ltc: 1.010114 },
    { premium: 30000, db: 1.010112, ltc: 1.010114 },
  ],
  "10pay_joint|Female|60|3%|3%|4 Years": [
    { premium: 6700, db: 0.995012, ltc: 0.995013 },
    { premium: 7500, db: 0.996675, ltc: 0.996676 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010124, ltc: 1.010125 },
    { premium: 15500, db: 1.010122, ltc: 1.010125 },
    { premium: 20000, db: 1.010126, ltc: 1.010128 },
    { premium: 25000, db: 1.010127, ltc: 1.01013 },
    { premium: 30000, db: 1.010124, ltc: 1.010125 },
  ],
  "10pay_joint|Female|60|3%|3%|6 Years": [
    { premium: 8200, db: 0.99779, ltc: 0.997792 },
    { premium: 8200, db: 0.99779, ltc: 0.997792 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003368, ltc: 1.00337 },
    { premium: 15500, db: 1.003617, ltc: 1.00362 },
    { premium: 20000, db: 1.010129, ltc: 1.010131 },
    { premium: 25000, db: 1.01013, ltc: 1.010132 },
    { premium: 30000, db: 1.010132, ltc: 1.010133 },
  ],
  "10pay_joint|Female|60|3%|3%|Lifetime": [
    { premium: 8900, db: 0.998749, ltc: 1 },
    { premium: 8900, db: 0.998749, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003409, ltc: 1 },
    { premium: 15500, db: 1.003579, ltc: 1 },
    { premium: 20000, db: 1.010122, ltc: 1 },
    { premium: 25000, db: 1.010122, ltc: 1 },
    { premium: 30000, db: 1.010122, ltc: 1 },
  ],
  "10pay_joint|Female|60|5%|5%|2 Years": [
    { premium: 8000, db: 0.997487, ltc: 0.997493 },
    { premium: 8000, db: 0.997487, ltc: 0.997493 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003419, ltc: 1.003419 },
    { premium: 15500, db: 1.00361, ltc: 1.003612 },
    { premium: 20000, db: 1.010131, ltc: 1.010134 },
    { premium: 25000, db: 1.010138, ltc: 1.010141 },
    { premium: 30000, db: 1.010137, ltc: 1.010138 },
  ],
  "10pay_joint|Female|60|5%|5%|4 Years": [
    { premium: 8900, db: 0.998745, ltc: 0.998744 },
    { premium: 8900, db: 0.998745, ltc: 0.998744 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003346, ltc: 1.003345 },
    { premium: 15500, db: 1.00358, ltc: 1.003578 },
    { premium: 20000, db: 1.010118, ltc: 1.010118 },
    { premium: 25000, db: 1.010117, ltc: 1.010116 },
    { premium: 30000, db: 1.010115, ltc: 1.010115 },
  ],
  "10pay_joint|Female|65|None|None|2 Years": [
    { premium: 7500, db: 0.986703, ltc: 0.986703 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000006, ltc: 1.000006 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
  ],
  "10pay_joint|Female|65|None|None|4 Years": [
    { premium: 5500, db: 0.991791, ltc: 0.991791 },
    { premium: 7500, db: 0.996606, ltc: 0.996606 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010117, ltc: 1.010117 },
    { premium: 15500, db: 1.010121, ltc: 1.010121 },
    { premium: 20000, db: 1.010123, ltc: 1.010123 },
    { premium: 25000, db: 1.010122, ltc: 1.010122 },
    { premium: 30000, db: 1.010121, ltc: 1.010121 },
  ],
  "10pay_joint|Female|65|None|None|6 Years": [
    { premium: 6700, db: 0.995051, ltc: 0.995051 },
    { premium: 7500, db: 0.99662, ltc: 0.99662 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010121, ltc: 1.010121 },
    { premium: 15500, db: 1.010124, ltc: 1.010124 },
    { premium: 20000, db: 1.010126, ltc: 1.010126 },
    { premium: 25000, db: 1.010123, ltc: 1.010123 },
    { premium: 30000, db: 1.010126, ltc: 1.010126 },
  ],
  "10pay_joint|Female|65|None|None|Lifetime": [
    { premium: 7300, db: 0.99626, ltc: 1 },
    { premium: 7500, db: 0.996605, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01007, ltc: 1 },
    { premium: 15500, db: 1.010074, ltc: 1 },
    { premium: 20000, db: 1.010077, ltc: 1 },
    { premium: 25000, db: 1.010076, ltc: 1 },
    { premium: 30000, db: 1.010075, ltc: 1 },
  ],
  "10pay_joint|Female|65|None|3%|2 Years": [
    { premium: 5700, db: 0.992352, ltc: 0.992351 },
    { premium: 7500, db: 0.996635, ltc: 0.996634 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01011, ltc: 1.010108 },
    { premium: 15500, db: 1.010105, ltc: 1.010105 },
    { premium: 20000, db: 1.010106, ltc: 1.010105 },
    { premium: 25000, db: 1.010109, ltc: 1.010108 },
    { premium: 30000, db: 1.01011, ltc: 1.010108 },
  ],
  "10pay_joint|Female|65|None|3%|4 Years": [
    { premium: 6600, db: 0.994843, ltc: 0.994843 },
    { premium: 7500, db: 0.996685, ltc: 0.996684 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010118, ltc: 1.010118 },
    { premium: 15500, db: 1.010124, ltc: 1.010124 },
    { premium: 20000, db: 1.01012, ltc: 1.01012 },
    { premium: 25000, db: 1.010121, ltc: 1.010121 },
    { premium: 30000, db: 1.010122, ltc: 1.01012 },
  ],
  "10pay_joint|Female|65|None|3%|6 Years": [
    { premium: 8500, db: 0.998229, ltc: 0.998232 },
    { premium: 8500, db: 0.998229, ltc: 0.998232 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003387, ltc: 1.003387 },
    { premium: 15500, db: 1.00363, ltc: 1.003632 },
    { premium: 20000, db: 1.010118, ltc: 1.01012 },
    { premium: 25000, db: 1.010113, ltc: 1.010114 },
    { premium: 30000, db: 1.010115, ltc: 1.010117 },
  ],
  "10pay_joint|Female|65|None|3%|Lifetime": [
    { premium: 9300, db: 0.999248, ltc: 1 },
    { premium: 9300, db: 0.999248, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003389, ltc: 1 },
    { premium: 15500, db: 1.0036, ltc: 1 },
    { premium: 20000, db: 1.010101, ltc: 1 },
    { premium: 25000, db: 1.010099, ltc: 1 },
    { premium: 30000, db: 1.010098, ltc: 1 },
  ],
  "10pay_joint|Female|65|None|5%|2 Years": [
    { premium: 6500, db: 0.994535, ltc: 0.994539 },
    { premium: 7500, db: 0.996637, ltc: 0.996637 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010073, ltc: 1.010074 },
    { premium: 15500, db: 1.01008, ltc: 1.010082 },
    { premium: 20000, db: 1.010077, ltc: 1.010078 },
    { premium: 25000, db: 1.01008, ltc: 1.010081 },
    { premium: 30000, db: 1.010077, ltc: 1.010078 },
  ],
  "10pay_joint|Female|65|None|5%|4 Years": [
    { premium: 7500, db: 0.996597, ltc: 0.996597 },
    { premium: 7500, db: 0.996597, ltc: 0.996597 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010091, ltc: 1.010089 },
    { premium: 15500, db: 1.010087, ltc: 1.010085 },
    { premium: 20000, db: 1.010091, ltc: 1.01009 },
    { premium: 25000, db: 1.010091, ltc: 1.010089 },
    { premium: 30000, db: 1.010091, ltc: 1.01009 },
  ],
  "10pay_joint|Female|65|3%|3%|2 Years": [
    { premium: 7400, db: 0.99644, ltc: 0.996438 },
    { premium: 7500, db: 0.996577, ltc: 0.996578 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010076, ltc: 1.010074 },
    { premium: 15500, db: 1.010079, ltc: 1.010078 },
    { premium: 20000, db: 1.010074, ltc: 1.01007 },
    { premium: 25000, db: 1.010078, ltc: 1.010075 },
    { premium: 30000, db: 1.010076, ltc: 1.010074 },
  ],
  "10pay_joint|Female|65|3%|3%|4 Years": [
    { premium: 8200, db: 0.997777, ltc: 0.997779 },
    { premium: 8200, db: 0.997777, ltc: 0.997779 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003352, ltc: 1.003352 },
    { premium: 15500, db: 1.003596, ltc: 1.003596 },
    { premium: 20000, db: 1.01009, ltc: 1.010089 },
    { premium: 25000, db: 1.01009, ltc: 1.010088 },
    { premium: 30000, db: 1.010095, ltc: 1.010093 },
  ],
  "10pay_joint|Female|65|5%|5%|2 Years": [
    { premium: 9600, db: 0.999592, ltc: 0.999593 },
    { premium: 9600, db: 0.999592, ltc: 0.999593 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003356, ltc: 1.003358 },
    { premium: 15500, db: 1.003571, ltc: 1.003571 },
    { premium: 20000, db: 1.010079, ltc: 1.010082 },
    { premium: 25000, db: 1.010085, ltc: 1.010087 },
    { premium: 30000, db: 1.010082, ltc: 1.010085 },
  ],
  "10pay_joint|Female|70|None|None|2 Years": [
    { premium: 6100, db: 0.993556, ltc: 0.993556 },
    { premium: 7500, db: 0.9966, ltc: 0.9966 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010135, ltc: 1.010135 },
    { premium: 15500, db: 1.01014, ltc: 1.01014 },
    { premium: 20000, db: 1.010139, ltc: 1.010139 },
    { premium: 25000, db: 1.010142, ltc: 1.010142 },
    { premium: 30000, db: 1.010139, ltc: 1.010139 },
  ],
  "10pay_joint|Female|70|None|None|4 Years": [
    { premium: 6800, db: 0.995231, ltc: 0.995231 },
    { premium: 7500, db: 0.996638, ltc: 0.996638 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010157, ltc: 1.010157 },
    { premium: 15500, db: 1.010158, ltc: 1.010158 },
    { premium: 20000, db: 1.010153, ltc: 1.010153 },
    { premium: 25000, db: 1.010155, ltc: 1.010155 },
    { premium: 30000, db: 1.010157, ltc: 1.010157 },
  ],
  "10pay_joint|Female|70|None|None|6 Years": [
    { premium: 8200, db: 0.997783, ltc: 0.997783 },
    { premium: 8200, db: 0.997783, ltc: 0.997783 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003318, ltc: 1.003318 },
    { premium: 15500, db: 1.003573, ltc: 1.003573 },
    { premium: 20000, db: 1.010107, ltc: 1.010107 },
    { premium: 25000, db: 1.010109, ltc: 1.010109 },
    { premium: 30000, db: 1.010105, ltc: 1.010105 },
  ],
  "10pay_joint|Female|70|None|None|Lifetime": [
    { premium: 8800, db: 0.998649, ltc: 1 },
    { premium: 8800, db: 0.998649, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00338, ltc: 1 },
    { premium: 15500, db: 1.003604, ltc: 1 },
    { premium: 20000, db: 1.01013, ltc: 1 },
    { premium: 25000, db: 1.010132, ltc: 1 },
    { premium: 30000, db: 1.010133, ltc: 1 },
  ],
  "10pay_joint|Female|70|None|3%|2 Years": [
    { premium: 6900, db: 0.995413, ltc: 0.995415 },
    { premium: 7500, db: 0.99658, ltc: 0.996575 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010105, ltc: 1.010105 },
    { premium: 15500, db: 1.010104, ltc: 1.010103 },
    { premium: 20000, db: 1.010102, ltc: 1.010101 },
    { premium: 25000, db: 1.010106, ltc: 1.010105 },
    { premium: 30000, db: 1.010105, ltc: 1.010102 },
  ],
  "10pay_joint|Female|70|None|3%|4 Years": [
    { premium: 7900, db: 0.997331, ltc: 0.997329 },
    { premium: 7900, db: 0.997331, ltc: 0.997329 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00338, ltc: 1.003378 },
    { premium: 15500, db: 1.003642, ltc: 1.003642 },
    { premium: 20000, db: 1.010148, ltc: 1.010148 },
    { premium: 25000, db: 1.010153, ltc: 1.010153 },
    { premium: 30000, db: 1.010151, ltc: 1.01015 },
  ],
  "10pay_joint|Female|70|None|5%|2 Years": [
    { premium: 7700, db: 0.996986, ltc: 0.996988 },
    { premium: 7700, db: 0.996986, ltc: 0.996988 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003369, ltc: 1.00337 },
    { premium: 15500, db: 1.010165, ltc: 1.010168 },
    { premium: 20000, db: 1.01016, ltc: 1.010161 },
    { premium: 25000, db: 1.010162, ltc: 1.010163 },
    { premium: 30000, db: 1.010163, ltc: 1.010164 },
  ],
  "10pay_joint|Female|70|None|5%|4 Years": [
    { premium: 9000, db: 0.998868, ltc: 0.99887 },
    { premium: 9000, db: 0.998868, ltc: 0.99887 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003326, ltc: 1.003329 },
    { premium: 15500, db: 1.003547, ltc: 1.003548 },
    { premium: 20000, db: 1.010111, ltc: 1.010112 },
    { premium: 25000, db: 1.010105, ltc: 1.010109 },
    { premium: 30000, db: 1.010108, ltc: 1.01011 },
  ],
  "10pay_joint|Female|70|3%|3%|2 Years": [
    { premium: 8600, db: 0.998371, ltc: 0.998371 },
    { premium: 8600, db: 0.998371, ltc: 0.998371 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003397, ltc: 1.003398 },
    { premium: 15500, db: 1.003637, ltc: 1.003638 },
    { premium: 20000, db: 1.010148, ltc: 1.010149 },
    { premium: 25000, db: 1.01015, ltc: 1.010148 },
    { premium: 30000, db: 1.010145, ltc: 1.010145 },
  ],
  "10pay_joint|Female|70|3%|3%|4 Years": [
    { premium: 9600, db: 0.999579, ltc: 0.99958 },
    { premium: 9600, db: 0.999579, ltc: 0.99958 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003345, ltc: 1.003345 },
    { premium: 15500, db: 1.003619, ltc: 1.00362 },
    { premium: 20000, db: 1.01012, ltc: 1.010122 },
    { premium: 25000, db: 1.010126, ltc: 1.010126 },
    { premium: 30000, db: 1.010123, ltc: 1.010125 },
  ],
  "10pay_joint|Male|45|None|None|2 Years": [
    { premium: 5000, db: 0.98002, ltc: 0.98002 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|Male|45|None|None|4 Years": [
    { premium: 5000, db: 0.980078, ltc: 0.980078 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|Male|45|None|None|6 Years": [
    { premium: 5000, db: 0.980013, ltc: 0.980013 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_joint|Male|45|None|None|Lifetime": [
    { premium: 5000, db: 0.979999, ltc: 1 },
    { premium: 7500, db: 0.999998, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 1 },
    { premium: 20000, db: 0.999996, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 1 },
    { premium: 30000, db: 0.999998, ltc: 1 },
  ],
  "10pay_joint|Male|45|None|3%|2 Years": [
    { premium: 5000, db: 0.979964, ltc: 0.979964 },
    { premium: 7500, db: 0.999998, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.001856, ltc: 0.997986 },
    { premium: 25000, db: 1.067568, ltc: 0.92651 },
    { premium: 30000, db: 1.111374, ltc: 0.878858 },
  ],
  "10pay_joint|Male|45|None|3%|4 Years": [
    { premium: 5000, db: 0.979966, ltc: 0.979967 },
    { premium: 7500, db: 0.999996, ltc: 0.999995 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999999, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1.054496, ltc: 0.939335 },
    { premium: 30000, db: 1.126107, ltc: 0.859618 },
  ],
  "10pay_joint|Male|45|None|3%|6 Years": [
    { premium: 5000, db: 0.979997, ltc: 0.979996 },
    { premium: 7500, db: 0.986695, ltc: 0.986694 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999998 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 0.999996, ltc: 0.999995 },
    { premium: 25000, db: 0.999998, ltc: 0.999998 },
    { premium: 30000, db: 1.066102, ltc: 0.954766 },
  ],
  "10pay_joint|Male|45|None|3%|Lifetime": [
    { premium: 5000, db: 0.979963, ltc: 1 },
    { premium: 7500, db: 0.98666, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
  ],
  "10pay_joint|Male|45|None|5%|2 Years": [
    { premium: 5000, db: 0.980014, ltc: 0.98001 },
    { premium: 7500, db: 1.000004, ltc: 1.000005 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000002 },
    { premium: 20000, db: 1.100883, ltc: 0.935104 },
    { premium: 25000, db: 1.176056, ltc: 0.88674 },
    { premium: 30000, db: 1.226172, ltc: 0.854498 },
  ],
  "10pay_joint|Male|45|None|5%|4 Years": [
    { premium: 5000, db: 0.979984, ltc: 0.979987 },
    { premium: 7500, db: 0.986648, ltc: 0.98665 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000002, ltc: 1.000003 },
    { premium: 20000, db: 1.066208, ltc: 0.95253 },
    { premium: 25000, db: 1.191876, ltc: 0.862413 },
    { premium: 30000, db: 1.275652, ltc: 0.802334 },
  ],
  "10pay_joint|Male|45|None|5%|6 Years": [
    { premium: 5100, db: 0.980411, ltc: 0.980413 },
    { premium: 7500, db: 0.986697, ltc: 0.986699 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000007, ltc: 1.000007 },
    { premium: 15500, db: 1.000007, ltc: 1.000008 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.064582, ltc: 0.971717 },
    { premium: 30000, db: 1.256676, ltc: 0.887566 },
  ],
  "10pay_joint|Male|45|None|5%|Lifetime": [
    { premium: 5500, db: 0.991673, ltc: 1 },
    { premium: 7500, db: 0.996588, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010077, ltc: 1 },
    { premium: 15500, db: 1.010077, ltc: 1 },
    { premium: 20000, db: 1.010078, ltc: 1 },
    { premium: 25000, db: 1.010075, ltc: 1 },
    { premium: 30000, db: 1.212571, ltc: 1 },
  ],
  "10pay_joint|Male|45|3%|3%|2 Years": [
    { premium: 5000, db: 0.980055, ltc: 0.980058 },
    { premium: 7500, db: 1.000005, ltc: 1.000007 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000002, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|Male|45|3%|3%|4 Years": [
    { premium: 5000, db: 0.98004, ltc: 0.980039 },
    { premium: 7500, db: 0.98662, ltc: 0.986618 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000002 },
    { premium: 15500, db: 1.000004, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000004 },
  ],
  "10pay_joint|Male|45|3%|3%|6 Years": [
    { premium: 5000, db: 0.979973, ltc: 0.979972 },
    { premium: 7500, db: 0.986626, ltc: 0.986625 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1, ltc: 0.999999 },
    { premium: 20000, db: 1.000005, ltc: 1.000004 },
    { premium: 25000, db: 1.000006, ltc: 1.000005 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_joint|Male|45|3%|3%|Lifetime": [
    { premium: 5400, db: 0.991447, ltc: 1 },
    { premium: 7500, db: 0.996695, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010134, ltc: 1 },
    { premium: 15500, db: 1.010135, ltc: 1 },
    { premium: 20000, db: 1.010138, ltc: 1 },
    { premium: 25000, db: 1.010135, ltc: 1 },
    { premium: 30000, db: 1.010138, ltc: 1 },
  ],
  "10pay_joint|Male|45|5%|5%|2 Years": [
    { premium: 5000, db: 0.979983, ltc: 0.97998 },
    { premium: 7500, db: 0.986623, ltc: 0.986624 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999997 },
    { premium: 15500, db: 0.999997, ltc: 0.999994 },
    { premium: 20000, db: 1, ltc: 0.999998 },
  ],
  "10pay_joint|Male|45|5%|5%|4 Years": [
    { premium: 5400, db: 0.99145, ltc: 0.991448 },
    { premium: 7500, db: 0.996638, ltc: 0.996637 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010128, ltc: 1.010128 },
    { premium: 15500, db: 1.010124, ltc: 1.010123 },
    { premium: 20000, db: 1.010128, ltc: 1.010128 },
    { premium: 25000, db: 1.010128, ltc: 1.010127 },
  ],
  "10pay_joint|Male|45|5%|5%|6 Years": [
    { premium: 6600, db: 0.994799, ltc: 0.994802 },
    { premium: 7500, db: 0.996632, ltc: 0.996635 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010095, ltc: 1.010095 },
    { premium: 15500, db: 1.010095, ltc: 1.010096 },
    { premium: 20000, db: 1.010097, ltc: 1.010098 },
    { premium: 25000, db: 1.010093, ltc: 1.010094 },
    { premium: 30000, db: 1.010095, ltc: 1.010096 },
  ],
  "10pay_joint|Male|45|5%|5%|Lifetime": [
    { premium: 7000, db: 0.995699, ltc: 1 },
    { premium: 7500, db: 0.99663, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010111, ltc: 1 },
    { premium: 15500, db: 1.010114, ltc: 1 },
    { premium: 20000, db: 1.010117, ltc: 1 },
    { premium: 25000, db: 1.010116, ltc: 1 },
    { premium: 30000, db: 1.010115, ltc: 1 },
  ],
  "10pay_joint|Male|50|None|None|2 Years": [
    { premium: 5000, db: 0.979972, ltc: 0.979972 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999996, ltc: 0.999996 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 0.999997, ltc: 0.999997 },
    { premium: 25000, db: 0.999998, ltc: 0.999998 },
    { premium: 30000, db: 0.999998, ltc: 0.999998 },
  ],
  "10pay_joint|Male|50|None|None|4 Years": [
    { premium: 5000, db: 0.979931, ltc: 0.979931 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 0.999997, ltc: 0.999997 },
    { premium: 25000, db: 0.999999, ltc: 0.999999 },
    { premium: 30000, db: 0.999998, ltc: 0.999998 },
  ],
  "10pay_joint|Male|50|None|None|6 Years": [
    { premium: 5000, db: 0.979906, ltc: 0.979906 },
    { premium: 7500, db: 0.986591, ltc: 0.986591 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_joint|Male|50|None|None|Lifetime": [
    { premium: 5000, db: 0.979913, ltc: 1 },
    { premium: 7500, db: 0.986603, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000007, ltc: 1 },
    { premium: 30000, db: 1.000005, ltc: 1 },
  ],
  "10pay_joint|Male|50|None|3%|2 Years": [
    { premium: 5000, db: 0.980006, ltc: 0.980005 },
    { premium: 7500, db: 0.999996, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1.000001 },
    { premium: 15500, db: 1.000004, ltc: 1.000005 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.037445, ltc: 0.967407 },
    { premium: 30000, db: 1.095118, ltc: 0.917198 },
  ],
  "10pay_joint|Male|50|None|3%|4 Years": [
    { premium: 5000, db: 0.979932, ltc: 0.979931 },
    { premium: 7500, db: 0.986581, ltc: 0.986581 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999998, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1, ltc: 0.999999 },
    { premium: 30000, db: 1.085093, ltc: 0.921769 },
  ],
  "10pay_joint|Male|50|None|3%|6 Years": [
    { premium: 5000, db: 0.979933, ltc: 0.979931 },
    { premium: 7500, db: 0.986667, ltc: 0.986666 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999997, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 0.999999 },
  ],
  "10pay_joint|Male|50|None|3%|Lifetime": [
    { premium: 5400, db: 0.991394, ltc: 1 },
    { premium: 7500, db: 0.996625, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010104, ltc: 1 },
    { premium: 15500, db: 1.010106, ltc: 1 },
    { premium: 20000, db: 1.010104, ltc: 1 },
    { premium: 25000, db: 1.010104, ltc: 1 },
    { premium: 30000, db: 1.010107, ltc: 1 },
  ],
  "10pay_joint|Male|50|None|5%|2 Years": [
    { premium: 5000, db: 0.979941, ltc: 0.97994 },
    { premium: 7500, db: 0.986617, ltc: 0.986619 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999998, ltc: 0.999996 },
    { premium: 20000, db: 1.053451, ltc: 0.973568 },
    { premium: 25000, db: 1.152837, ltc: 0.924425 },
    { premium: 30000, db: 1.219094, ltc: 0.891664 },
  ],
  "10pay_joint|Male|50|None|5%|4 Years": [
    { premium: 5000, db: 0.979956, ltc: 0.979955 },
    { premium: 7500, db: 0.98662, ltc: 0.986618 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.13034, ltc: 0.923097 },
    { premium: 30000, db: 1.240975, ltc: 0.857822 },
  ],
  "10pay_joint|Male|50|None|5%|6 Years": [
    { premium: 5900, db: 0.992937, ltc: 0.992936 },
    { premium: 7500, db: 0.99659, ltc: 0.996589 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010107, ltc: 1.010107 },
    { premium: 15500, db: 1.010105, ltc: 1.010106 },
    { premium: 20000, db: 1.010109, ltc: 1.010109 },
    { premium: 25000, db: 1.01011, ltc: 1.010111 },
    { premium: 30000, db: 1.113547, ltc: 0.972941 },
  ],
  "10pay_joint|Male|50|None|5%|Lifetime": [
    { premium: 6500, db: 0.994552, ltc: 1 },
    { premium: 7500, db: 0.99664, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010123, ltc: 1 },
    { premium: 15500, db: 1.010122, ltc: 1 },
    { premium: 20000, db: 1.010125, ltc: 1 },
    { premium: 25000, db: 1.010126, ltc: 1 },
    { premium: 30000, db: 1.010127, ltc: 1 },
  ],
  "10pay_joint|Male|50|3%|3%|2 Years": [
    { premium: 5000, db: 0.979943, ltc: 0.979944 },
    { premium: 7500, db: 0.986574, ltc: 0.986577 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_joint|Male|50|3%|3%|4 Years": [
    { premium: 5000, db: 0.979991, ltc: 0.979987 },
    { premium: 7500, db: 0.986648, ltc: 0.986645 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000005 },
    { premium: 15500, db: 1.000009, ltc: 1.000006 },
    { premium: 20000, db: 1.000005, ltc: 1.000003 },
    { premium: 25000, db: 1.000008, ltc: 1.000006 },
    { premium: 30000, db: 1.000006, ltc: 1.000005 },
  ],
  "10pay_joint|Male|50|3%|3%|6 Years": [
    { premium: 5900, db: 0.992984, ltc: 0.992985 },
    { premium: 7500, db: 0.996646, ltc: 0.996646 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010171, ltc: 1.01017 },
    { premium: 15500, db: 1.010174, ltc: 1.010173 },
    { premium: 20000, db: 1.010173, ltc: 1.010172 },
    { premium: 25000, db: 1.010175, ltc: 1.010174 },
    { premium: 30000, db: 1.010175, ltc: 1.010174 },
  ],
  "10pay_joint|Male|50|3%|3%|Lifetime": [
    { premium: 6300, db: 0.994033, ltc: 1 },
    { premium: 7500, db: 0.996574, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010095, ltc: 1 },
    { premium: 15500, db: 1.010102, ltc: 1 },
    { premium: 20000, db: 1.010097, ltc: 1 },
    { premium: 25000, db: 1.010098, ltc: 1 },
    { premium: 30000, db: 1.010099, ltc: 1 },
  ],
  "10pay_joint|Male|50|5%|5%|2 Years": [
    { premium: 5800, db: 0.992691, ltc: 0.992691 },
    { premium: 7500, db: 0.996679, ltc: 0.996681 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010162, ltc: 1.010163 },
    { premium: 15500, db: 1.010162, ltc: 1.010161 },
    { premium: 20000, db: 1.010164, ltc: 1.010165 },
    { premium: 25000, db: 1.010165, ltc: 1.010166 },
  ],
  "10pay_joint|Male|50|5%|5%|4 Years": [
    { premium: 6400, db: 0.994327, ltc: 0.99433 },
    { premium: 7500, db: 0.996693, ltc: 0.996696 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010173, ltc: 1.010173 },
    { premium: 15500, db: 1.010169, ltc: 1.01017 },
    { premium: 20000, db: 1.010173, ltc: 1.010175 },
    { premium: 25000, db: 1.010173, ltc: 1.010174 },
  ],
  "10pay_joint|Male|50|5%|5%|6 Years": [
    { premium: 7800, db: 0.99716, ltc: 0.997161 },
    { premium: 7800, db: 0.99716, ltc: 0.997161 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00342, ltc: 1.00342 },
    { premium: 15500, db: 1.010152, ltc: 1.010152 },
    { premium: 20000, db: 1.01015, ltc: 1.01015 },
    { premium: 25000, db: 1.010153, ltc: 1.010153 },
    { premium: 30000, db: 1.01015, ltc: 1.01015 },
  ],
  "10pay_joint|Male|50|5%|5%|Lifetime": [
    { premium: 8400, db: 0.998069, ltc: 1 },
    { premium: 8400, db: 0.998069, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003326, ltc: 1 },
    { premium: 15500, db: 1.003576, ltc: 1 },
    { premium: 20000, db: 1.010111, ltc: 1 },
    { premium: 25000, db: 1.010111, ltc: 1 },
    { premium: 30000, db: 1.010111, ltc: 1 },
  ],
  "10pay_joint|Male|55|None|None|2 Years": [
    { premium: 5000, db: 0.979967, ltc: 0.979967 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|Male|55|None|None|4 Years": [
    { premium: 5000, db: 0.98003, ltc: 0.98003 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_joint|Male|55|None|None|6 Years": [
    { premium: 5000, db: 0.979935, ltc: 0.979935 },
    { premium: 7500, db: 0.986679, ltc: 0.986679 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|Male|55|None|None|Lifetime": [
    { premium: 5000, db: 0.979934, ltc: 1 },
    { premium: 7500, db: 0.986661, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999996, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|Male|55|None|3%|2 Years": [
    { premium: 5000, db: 0.979972, ltc: 0.979969 },
    { premium: 7500, db: 0.986643, ltc: 0.986642 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999997, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 0.999998 },
    { premium: 25000, db: 1, ltc: 0.999998 },
    { premium: 30000, db: 1.070347, ltc: 0.952944 },
  ],
  "10pay_joint|Male|55|None|3%|4 Years": [
    { premium: 5000, db: 0.979997, ltc: 0.979996 },
    { premium: 7500, db: 0.986613, ltc: 0.986611 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 0.999999 },
    { premium: 15500, db: 0.999999, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 0.999999 },
    { premium: 25000, db: 1, ltc: 0.999998 },
    { premium: 30000, db: 1.022664, ltc: 0.98337 },
  ],
  "10pay_joint|Male|55|None|3%|6 Years": [
    { premium: 5700, db: 0.992367, ltc: 0.992368 },
    { premium: 7500, db: 0.996641, ltc: 0.996641 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010092, ltc: 1.010092 },
    { premium: 15500, db: 1.010096, ltc: 1.010097 },
    { premium: 20000, db: 1.010094, ltc: 1.010093 },
    { premium: 25000, db: 1.010095, ltc: 1.010095 },
    { premium: 30000, db: 1.010092, ltc: 1.010092 },
  ],
  "10pay_joint|Male|55|None|3%|Lifetime": [
    { premium: 6300, db: 0.994116, ltc: 1 },
    { premium: 7500, db: 0.996684, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010138, ltc: 1 },
    { premium: 15500, db: 1.010138, ltc: 1 },
    { premium: 20000, db: 1.010134, ltc: 1 },
    { premium: 25000, db: 1.010136, ltc: 1 },
    { premium: 30000, db: 1.010138, ltc: 1 },
  ],
  "10pay_joint|Male|55|None|5%|2 Years": [
    { premium: 5000, db: 0.979929, ltc: 0.979927 },
    { premium: 7500, db: 0.986614, ltc: 0.986613 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.115843, ltc: 0.959213 },
    { premium: 30000, db: 1.204161, ltc: 0.928116 },
  ],
  "10pay_joint|Male|55|None|5%|4 Years": [
    { premium: 5200, db: 0.990603, ltc: 0.990605 },
    { premium: 7500, db: 0.996558, ltc: 0.996561 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010083, ltc: 1.010084 },
    { premium: 15500, db: 1.010083, ltc: 1.010085 },
    { premium: 20000, db: 1.010088, ltc: 1.010089 },
    { premium: 25000, db: 1.045659, ltc: 0.993692 },
    { premium: 30000, db: 1.196216, ltc: 0.924296 },
  ],
  "10pay_joint|Male|55|None|5%|6 Years": [
    { premium: 6900, db: 0.995493, ltc: 0.995493 },
    { premium: 7500, db: 0.996655, ltc: 0.996653 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010109, ltc: 1.01011 },
    { premium: 15500, db: 1.010103, ltc: 1.010103 },
    { premium: 20000, db: 1.010112, ltc: 1.010111 },
    { premium: 25000, db: 1.010107, ltc: 1.010108 },
    { premium: 30000, db: 1.010109, ltc: 1.01011 },
  ],
  "10pay_joint|Male|55|None|5%|Lifetime": [
    { premium: 7500, db: 0.996596, ltc: 1 },
    { premium: 7500, db: 0.996596, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010081, ltc: 1 },
    { premium: 15500, db: 1.01008, ltc: 1 },
    { premium: 20000, db: 1.010084, ltc: 1 },
    { premium: 25000, db: 1.010079, ltc: 1 },
    { premium: 30000, db: 1.010081, ltc: 1 },
  ],
  "10pay_joint|Male|55|3%|3%|2 Years": [
    { premium: 5100, db: 0.980344, ltc: 0.980341 },
    { premium: 7500, db: 0.986615, ltc: 0.986616 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999998 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999998, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|Male|55|3%|3%|4 Years": [
    { premium: 5600, db: 0.992017, ltc: 0.992016 },
    { premium: 7500, db: 0.996666, ltc: 0.996668 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01012, ltc: 1.01012 },
    { premium: 15500, db: 1.01012, ltc: 1.01012 },
    { premium: 20000, db: 1.010123, ltc: 1.010123 },
    { premium: 25000, db: 1.010126, ltc: 1.010125 },
    { premium: 30000, db: 1.010123, ltc: 1.010123 },
  ],
  "10pay_joint|Male|55|3%|3%|6 Years": [
    { premium: 6900, db: 0.995493, ltc: 0.995492 },
    { premium: 7500, db: 0.99664, ltc: 0.99664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010116, ltc: 1.010115 },
    { premium: 15500, db: 1.010119, ltc: 1.010118 },
    { premium: 20000, db: 1.010121, ltc: 1.01012 },
    { premium: 25000, db: 1.010124, ltc: 1.010124 },
    { premium: 30000, db: 1.010121, ltc: 1.01012 },
  ],
  "10pay_joint|Male|55|3%|3%|Lifetime": [
    { premium: 7400, db: 0.996402, ltc: 1 },
    { premium: 7500, db: 0.996604, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010081, ltc: 1 },
    { premium: 15500, db: 1.010081, ltc: 1 },
    { premium: 20000, db: 1.010086, ltc: 1 },
    { premium: 25000, db: 1.010089, ltc: 1 },
    { premium: 30000, db: 1.010086, ltc: 1 },
  ],
  "10pay_joint|Male|55|5%|5%|2 Years": [
    { premium: 6800, db: 0.995245, ltc: 0.99525 },
    { premium: 7500, db: 0.996648, ltc: 0.996652 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010126, ltc: 1.010128 },
    { premium: 15500, db: 1.010133, ltc: 1.010135 },
    { premium: 20000, db: 1.010129, ltc: 1.010129 },
    { premium: 25000, db: 1.01013, ltc: 1.010132 },
    { premium: 30000, db: 1.010131, ltc: 1.010132 },
  ],
  "10pay_joint|Male|55|5%|5%|4 Years": [
    { premium: 7500, db: 0.996642, ltc: 0.99664 },
    { premium: 7500, db: 0.996642, ltc: 0.99664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010135, ltc: 1.010133 },
    { premium: 15500, db: 1.010137, ltc: 1.010135 },
    { premium: 20000, db: 1.010135, ltc: 1.010133 },
    { premium: 25000, db: 1.010135, ltc: 1.010133 },
    { premium: 30000, db: 1.01014, ltc: 1.010138 },
  ],
  "10pay_joint|Male|55|5%|5%|6 Years": [
    { premium: 9300, db: 0.999238, ltc: 0.999238 },
    { premium: 9300, db: 0.999238, ltc: 0.999238 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003323, ltc: 1.003324 },
    { premium: 15500, db: 1.003534, ltc: 1.003534 },
    { premium: 20000, db: 1.010089, ltc: 1.010091 },
    { premium: 25000, db: 1.010088, ltc: 1.010089 },
    { premium: 30000, db: 1.010086, ltc: 1.010088 },
  ],
  "10pay_joint|Male|55|5%|5%|Lifetime": [
    { premium: 9900, db: 0.999911, ltc: 1 },
    { premium: 9900, db: 0.999911, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003376, ltc: 1 },
    { premium: 15500, db: 1.003577, ltc: 1 },
    { premium: 20000, db: 1.010128, ltc: 1 },
    { premium: 25000, db: 1.010128, ltc: 1 },
    { premium: 30000, db: 1.010134, ltc: 1 },
  ],
  "10pay_joint|Male|60|None|None|2 Years": [
    { premium: 5000, db: 0.979966, ltc: 0.979966 },
    { premium: 7500, db: 0.98668, ltc: 0.98668 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000005, ltc: 1.000005 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_joint|Male|60|None|None|4 Years": [
    { premium: 5000, db: 0.979953, ltc: 0.979953 },
    { premium: 7500, db: 0.986706, ltc: 0.986706 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_joint|Male|60|None|None|6 Years": [
    { premium: 5300, db: 0.991007, ltc: 0.991007 },
    { premium: 7500, db: 0.996672, ltc: 0.996672 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010124, ltc: 1.010124 },
    { premium: 15500, db: 1.01012, ltc: 1.01012 },
    { premium: 20000, db: 1.010121, ltc: 1.010121 },
    { premium: 25000, db: 1.010123, ltc: 1.010123 },
    { premium: 30000, db: 1.010124, ltc: 1.010124 },
  ],
  "10pay_joint|Male|60|None|None|Lifetime": [
    { premium: 5800, db: 0.992667, ltc: 1 },
    { premium: 7500, db: 0.996681, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1 },
    { premium: 15500, db: 1.01012, ltc: 1 },
    { premium: 20000, db: 1.010123, ltc: 1 },
    { premium: 25000, db: 1.010122, ltc: 1 },
    { premium: 30000, db: 1.010125, ltc: 1 },
  ],
  "10pay_joint|Male|60|None|3%|2 Years": [
    { premium: 5000, db: 0.979952, ltc: 0.979948 },
    { premium: 7500, db: 0.98662, ltc: 0.986619 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000001 },
    { premium: 15500, db: 1.000003, ltc: 1.000001 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000002, ltc: 1.000001 },
    { premium: 30000, db: 1.004346, ltc: 0.997589 },
  ],
  "10pay_joint|Male|60|None|3%|4 Years": [
    { premium: 5300, db: 0.99098, ltc: 0.99098 },
    { premium: 7500, db: 0.996618, ltc: 0.996621 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010084, ltc: 1.010084 },
    { premium: 15500, db: 1.010088, ltc: 1.010089 },
    { premium: 20000, db: 1.010089, ltc: 1.01009 },
    { premium: 25000, db: 1.010088, ltc: 1.010089 },
    { premium: 30000, db: 1.010087, ltc: 1.010087 },
  ],
  "10pay_joint|Male|60|None|3%|6 Years": [
    { premium: 6800, db: 0.995283, ltc: 0.995282 },
    { premium: 7500, db: 0.996604, ltc: 0.996604 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010108, ltc: 1.010108 },
    { premium: 15500, db: 1.010112, ltc: 1.010112 },
    { premium: 20000, db: 1.010108, ltc: 1.010108 },
    { premium: 25000, db: 1.010108, ltc: 1.010108 },
    { premium: 30000, db: 1.010108, ltc: 1.010108 },
  ],
  "10pay_joint|Male|60|None|3%|Lifetime": [
    { premium: 7500, db: 0.996648, ltc: 1 },
    { premium: 7500, db: 0.996648, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010105, ltc: 1 },
    { premium: 15500, db: 1.010104, ltc: 1 },
    { premium: 20000, db: 1.010108, ltc: 1 },
    { premium: 25000, db: 1.010104, ltc: 1 },
    { premium: 30000, db: 1.010105, ltc: 1 },
  ],
  "10pay_joint|Male|60|None|5%|2 Years": [
    { premium: 5200, db: 0.990739, ltc: 0.990742 },
    { premium: 7500, db: 0.996669, ltc: 0.99667 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010137, ltc: 1.010136 },
    { premium: 15500, db: 1.010132, ltc: 1.010132 },
    { premium: 20000, db: 1.010137, ltc: 1.010136 },
    { premium: 25000, db: 1.034192, ltc: 1.003338 },
    { premium: 30000, db: 1.148934, ltc: 0.970903 },
  ],
  "10pay_joint|Male|60|None|5%|4 Years": [
    { premium: 6100, db: 0.993529, ltc: 0.993529 },
    { premium: 7500, db: 0.996668, ltc: 0.996669 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010116, ltc: 1.010115 },
    { premium: 15500, db: 1.010119, ltc: 1.010119 },
    { premium: 20000, db: 1.010116, ltc: 1.010115 },
    { premium: 25000, db: 1.010121, ltc: 1.010121 },
    { premium: 30000, db: 1.061892, ltc: 0.989398 },
  ],
  "10pay_joint|Male|60|None|5%|6 Years": [
    { premium: 8200, db: 0.997799, ltc: 0.997801 },
    { premium: 8200, db: 0.997799, ltc: 0.997801 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003385, ltc: 1.003387 },
    { premium: 15500, db: 1.003571, ltc: 1.003572 },
    { premium: 20000, db: 1.010105, ltc: 1.010107 },
    { premium: 25000, db: 1.010102, ltc: 1.010103 },
    { premium: 30000, db: 1.010105, ltc: 1.010107 },
  ],
  "10pay_joint|Male|60|None|5%|Lifetime": [
    { premium: 9000, db: 0.998885, ltc: 1 },
    { premium: 9000, db: 0.998885, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003334, ltc: 1 },
    { premium: 15500, db: 1.003561, ltc: 1 },
    { premium: 20000, db: 1.010099, ltc: 1 },
    { premium: 25000, db: 1.0101, ltc: 1 },
    { premium: 30000, db: 1.010096, ltc: 1 },
  ],
  "10pay_joint|Male|60|3%|3%|2 Years": [
    { premium: 6000, db: 0.993265, ltc: 0.993266 },
    { premium: 7500, db: 0.996623, ltc: 0.996621 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010108, ltc: 1.010112 },
    { premium: 15500, db: 1.010109, ltc: 1.010112 },
    { premium: 20000, db: 1.010108, ltc: 1.01011 },
    { premium: 25000, db: 1.010113, ltc: 1.010114 },
    { premium: 30000, db: 1.010112, ltc: 1.010114 },
  ],
  "10pay_joint|Male|60|3%|3%|4 Years": [
    { premium: 6700, db: 0.995012, ltc: 0.995013 },
    { premium: 7500, db: 0.996675, ltc: 0.996676 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010124, ltc: 1.010125 },
    { premium: 15500, db: 1.010122, ltc: 1.010125 },
    { premium: 20000, db: 1.010126, ltc: 1.010128 },
    { premium: 25000, db: 1.010127, ltc: 1.01013 },
    { premium: 30000, db: 1.010124, ltc: 1.010125 },
  ],
  "10pay_joint|Male|60|3%|3%|6 Years": [
    { premium: 8200, db: 0.99779, ltc: 0.997792 },
    { premium: 8200, db: 0.99779, ltc: 0.997792 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003368, ltc: 1.00337 },
    { premium: 15500, db: 1.003617, ltc: 1.00362 },
    { premium: 20000, db: 1.010129, ltc: 1.010131 },
    { premium: 25000, db: 1.01013, ltc: 1.010132 },
    { premium: 30000, db: 1.010132, ltc: 1.010133 },
  ],
  "10pay_joint|Male|60|3%|3%|Lifetime": [
    { premium: 8900, db: 0.998749, ltc: 1 },
    { premium: 8900, db: 0.998749, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003409, ltc: 1 },
    { premium: 15500, db: 1.003579, ltc: 1 },
    { premium: 20000, db: 1.010122, ltc: 1 },
    { premium: 25000, db: 1.010122, ltc: 1 },
    { premium: 30000, db: 1.010122, ltc: 1 },
  ],
  "10pay_joint|Male|60|5%|5%|2 Years": [
    { premium: 8000, db: 0.997487, ltc: 0.997493 },
    { premium: 8000, db: 0.997487, ltc: 0.997493 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003419, ltc: 1.003419 },
    { premium: 15500, db: 1.00361, ltc: 1.003612 },
    { premium: 20000, db: 1.010131, ltc: 1.010134 },
    { premium: 25000, db: 1.010138, ltc: 1.010141 },
    { premium: 30000, db: 1.010137, ltc: 1.010138 },
  ],
  "10pay_joint|Male|60|5%|5%|4 Years": [
    { premium: 8900, db: 0.998745, ltc: 0.998744 },
    { premium: 8900, db: 0.998745, ltc: 0.998744 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003346, ltc: 1.003345 },
    { premium: 15500, db: 1.00358, ltc: 1.003578 },
    { premium: 20000, db: 1.010118, ltc: 1.010118 },
    { premium: 25000, db: 1.010117, ltc: 1.010116 },
    { premium: 30000, db: 1.010115, ltc: 1.010115 },
  ],
  "10pay_joint|Male|65|None|None|2 Years": [
    { premium: 5000, db: 0.980035, ltc: 0.980035 },
    { premium: 7500, db: 0.986703, ltc: 0.986703 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000006, ltc: 1.000006 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
  ],
  "10pay_joint|Male|65|None|None|4 Years": [
    { premium: 5500, db: 0.991791, ltc: 0.991791 },
    { premium: 7500, db: 0.996606, ltc: 0.996606 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010117, ltc: 1.010117 },
    { premium: 15500, db: 1.010121, ltc: 1.010121 },
    { premium: 20000, db: 1.010123, ltc: 1.010123 },
    { premium: 25000, db: 1.010122, ltc: 1.010122 },
    { premium: 30000, db: 1.010121, ltc: 1.010121 },
  ],
  "10pay_joint|Male|65|None|None|6 Years": [
    { premium: 6700, db: 0.995051, ltc: 0.995051 },
    { premium: 7500, db: 0.99662, ltc: 0.99662 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010121, ltc: 1.010121 },
    { premium: 15500, db: 1.010124, ltc: 1.010124 },
    { premium: 20000, db: 1.010126, ltc: 1.010126 },
    { premium: 25000, db: 1.010123, ltc: 1.010123 },
    { premium: 30000, db: 1.010126, ltc: 1.010126 },
  ],
  "10pay_joint|Male|65|None|None|Lifetime": [
    { premium: 7300, db: 0.99626, ltc: 1 },
    { premium: 7500, db: 0.996605, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01007, ltc: 1 },
    { premium: 15500, db: 1.010074, ltc: 1 },
    { premium: 20000, db: 1.010077, ltc: 1 },
    { premium: 25000, db: 1.010076, ltc: 1 },
    { premium: 30000, db: 1.010075, ltc: 1 },
  ],
  "10pay_joint|Male|65|None|3%|2 Years": [
    { premium: 5700, db: 0.992352, ltc: 0.992351 },
    { premium: 7500, db: 0.996635, ltc: 0.996634 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01011, ltc: 1.010108 },
    { premium: 15500, db: 1.010105, ltc: 1.010105 },
    { premium: 20000, db: 1.010106, ltc: 1.010105 },
    { premium: 25000, db: 1.010109, ltc: 1.010108 },
    { premium: 30000, db: 1.01011, ltc: 1.010108 },
  ],
  "10pay_joint|Male|65|None|3%|4 Years": [
    { premium: 6600, db: 0.994843, ltc: 0.994843 },
    { premium: 7500, db: 0.996685, ltc: 0.996684 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010118, ltc: 1.010118 },
    { premium: 15500, db: 1.010124, ltc: 1.010124 },
    { premium: 20000, db: 1.01012, ltc: 1.01012 },
    { premium: 25000, db: 1.010121, ltc: 1.010121 },
    { premium: 30000, db: 1.010122, ltc: 1.01012 },
  ],
  "10pay_joint|Male|65|None|3%|6 Years": [
    { premium: 8500, db: 0.998229, ltc: 0.998232 },
    { premium: 8500, db: 0.998229, ltc: 0.998232 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003387, ltc: 1.003387 },
    { premium: 15500, db: 1.00363, ltc: 1.003632 },
    { premium: 20000, db: 1.010118, ltc: 1.01012 },
    { premium: 25000, db: 1.010113, ltc: 1.010114 },
    { premium: 30000, db: 1.010115, ltc: 1.010117 },
  ],
  "10pay_joint|Male|65|None|3%|Lifetime": [
    { premium: 9300, db: 0.999248, ltc: 1 },
    { premium: 9300, db: 0.999248, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003389, ltc: 1 },
    { premium: 15500, db: 1.0036, ltc: 1 },
    { premium: 20000, db: 1.010101, ltc: 1 },
    { premium: 25000, db: 1.010099, ltc: 1 },
    { premium: 30000, db: 1.010098, ltc: 1 },
  ],
  "10pay_joint|Male|65|None|5%|2 Years": [
    { premium: 6500, db: 0.994535, ltc: 0.994539 },
    { premium: 7500, db: 0.996637, ltc: 0.996637 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010073, ltc: 1.010074 },
    { premium: 15500, db: 1.01008, ltc: 1.010082 },
    { premium: 20000, db: 1.010077, ltc: 1.010078 },
    { premium: 25000, db: 1.01008, ltc: 1.010081 },
    { premium: 30000, db: 1.010077, ltc: 1.010078 },
  ],
  "10pay_joint|Male|65|None|5%|4 Years": [
    { premium: 7500, db: 0.996597, ltc: 0.996597 },
    { premium: 7500, db: 0.996597, ltc: 0.996597 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010091, ltc: 1.010089 },
    { premium: 15500, db: 1.010087, ltc: 1.010085 },
    { premium: 20000, db: 1.010091, ltc: 1.01009 },
    { premium: 25000, db: 1.010091, ltc: 1.010089 },
    { premium: 30000, db: 1.010091, ltc: 1.01009 },
  ],
  "10pay_joint|Male|65|3%|3%|2 Years": [
    { premium: 7400, db: 0.99644, ltc: 0.996438 },
    { premium: 7500, db: 0.996577, ltc: 0.996578 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010076, ltc: 1.010074 },
    { premium: 15500, db: 1.010079, ltc: 1.010078 },
    { premium: 20000, db: 1.010074, ltc: 1.01007 },
    { premium: 25000, db: 1.010078, ltc: 1.010075 },
    { premium: 30000, db: 1.010076, ltc: 1.010074 },
  ],
  "10pay_joint|Male|65|3%|3%|4 Years": [
    { premium: 8200, db: 0.997777, ltc: 0.997779 },
    { premium: 8200, db: 0.997777, ltc: 0.997779 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003352, ltc: 1.003352 },
    { premium: 15500, db: 1.003596, ltc: 1.003596 },
    { premium: 20000, db: 1.01009, ltc: 1.010089 },
    { premium: 25000, db: 1.01009, ltc: 1.010088 },
    { premium: 30000, db: 1.010095, ltc: 1.010093 },
  ],
  "10pay_joint|Male|65|5%|5%|2 Years": [
    { premium: 9600, db: 0.999592, ltc: 0.999593 },
    { premium: 9600, db: 0.999592, ltc: 0.999593 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003356, ltc: 1.003358 },
    { premium: 15500, db: 1.003571, ltc: 1.003571 },
    { premium: 20000, db: 1.010079, ltc: 1.010082 },
    { premium: 25000, db: 1.010085, ltc: 1.010087 },
    { premium: 30000, db: 1.010082, ltc: 1.010085 },
  ],
  "10pay_joint|Male|70|None|None|2 Years": [
    { premium: 6100, db: 0.993556, ltc: 0.993556 },
    { premium: 7500, db: 0.9966, ltc: 0.9966 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010135, ltc: 1.010135 },
    { premium: 15500, db: 1.01014, ltc: 1.01014 },
    { premium: 20000, db: 1.010139, ltc: 1.010139 },
    { premium: 25000, db: 1.010142, ltc: 1.010142 },
    { premium: 30000, db: 1.010139, ltc: 1.010139 },
  ],
  "10pay_joint|Male|70|None|None|4 Years": [
    { premium: 6800, db: 0.995231, ltc: 0.995231 },
    { premium: 7500, db: 0.996638, ltc: 0.996638 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010157, ltc: 1.010157 },
    { premium: 15500, db: 1.010158, ltc: 1.010158 },
    { premium: 20000, db: 1.010153, ltc: 1.010153 },
    { premium: 25000, db: 1.010155, ltc: 1.010155 },
    { premium: 30000, db: 1.010157, ltc: 1.010157 },
  ],
  "10pay_joint|Male|70|None|None|6 Years": [
    { premium: 8200, db: 0.997783, ltc: 0.997783 },
    { premium: 8200, db: 0.997783, ltc: 0.997783 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003318, ltc: 1.003318 },
    { premium: 15500, db: 1.003573, ltc: 1.003573 },
    { premium: 20000, db: 1.010107, ltc: 1.010107 },
    { premium: 25000, db: 1.010109, ltc: 1.010109 },
    { premium: 30000, db: 1.010105, ltc: 1.010105 },
  ],
  "10pay_joint|Male|70|None|None|Lifetime": [
    { premium: 8800, db: 0.998649, ltc: 1 },
    { premium: 8800, db: 0.998649, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00338, ltc: 1 },
    { premium: 15500, db: 1.003604, ltc: 1 },
    { premium: 20000, db: 1.01013, ltc: 1 },
    { premium: 25000, db: 1.010132, ltc: 1 },
    { premium: 30000, db: 1.010133, ltc: 1 },
  ],
  "10pay_joint|Male|70|None|3%|2 Years": [
    { premium: 6900, db: 0.995413, ltc: 0.995415 },
    { premium: 7500, db: 0.99658, ltc: 0.996575 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010105, ltc: 1.010105 },
    { premium: 15500, db: 1.010104, ltc: 1.010103 },
    { premium: 20000, db: 1.010102, ltc: 1.010101 },
    { premium: 25000, db: 1.010106, ltc: 1.010105 },
    { premium: 30000, db: 1.010105, ltc: 1.010102 },
  ],
  "10pay_joint|Male|70|None|3%|4 Years": [
    { premium: 7900, db: 0.997331, ltc: 0.997329 },
    { premium: 7900, db: 0.997331, ltc: 0.997329 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00338, ltc: 1.003378 },
    { premium: 15500, db: 1.003642, ltc: 1.003642 },
    { premium: 20000, db: 1.010148, ltc: 1.010148 },
    { premium: 25000, db: 1.010153, ltc: 1.010153 },
    { premium: 30000, db: 1.010151, ltc: 1.01015 },
  ],
  "10pay_joint|Male|70|None|5%|2 Years": [
    { premium: 7700, db: 0.996986, ltc: 0.996988 },
    { premium: 7700, db: 0.996986, ltc: 0.996988 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003369, ltc: 1.00337 },
    { premium: 15500, db: 1.010165, ltc: 1.010168 },
    { premium: 20000, db: 1.01016, ltc: 1.010161 },
    { premium: 25000, db: 1.010162, ltc: 1.010163 },
    { premium: 30000, db: 1.010163, ltc: 1.010164 },
  ],
  "10pay_joint|Male|70|None|5%|4 Years": [
    { premium: 9000, db: 0.998868, ltc: 0.99887 },
    { premium: 9000, db: 0.998868, ltc: 0.99887 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003326, ltc: 1.003329 },
    { premium: 15500, db: 1.003547, ltc: 1.003548 },
    { premium: 20000, db: 1.010111, ltc: 1.010112 },
    { premium: 25000, db: 1.010105, ltc: 1.010109 },
    { premium: 30000, db: 1.010108, ltc: 1.01011 },
  ],
  "10pay_joint|Male|70|3%|3%|2 Years": [
    { premium: 8600, db: 0.998371, ltc: 0.998371 },
    { premium: 8600, db: 0.998371, ltc: 0.998371 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003397, ltc: 1.003398 },
    { premium: 15500, db: 1.003637, ltc: 1.003638 },
    { premium: 20000, db: 1.010148, ltc: 1.010149 },
    { premium: 25000, db: 1.01015, ltc: 1.010148 },
    { premium: 30000, db: 1.010145, ltc: 1.010145 },
  ],
  "10pay_joint|Male|70|3%|3%|4 Years": [
    { premium: 9600, db: 0.999579, ltc: 0.99958 },
    { premium: 9600, db: 0.999579, ltc: 0.99958 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003345, ltc: 1.003345 },
    { premium: 15500, db: 1.003619, ltc: 1.00362 },
    { premium: 20000, db: 1.01012, ltc: 1.010122 },
    { premium: 25000, db: 1.010126, ltc: 1.010126 },
    { premium: 30000, db: 1.010123, ltc: 1.010125 },
  ],
};

export const OA_CAT3_AVAILABLE_AGES = [45, 50, 55, 60, 65, 70] as const;
